import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  KSerializerzf77vz1967fq as KSerializer,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  UnknownFieldException_init_$Create$3p6j2tgfvvykj as UnknownFieldException_init_$Create$,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  ReferenceArraySerializer3juj1vqolxkrs as ReferenceArraySerializer,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
  DoubleSerializer_getInstance2y096mioqlqlr as DoubleSerializer_getInstance,
  STRING_getInstance2md3nu8ka1da4 as STRING_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
  DOUBLE_getInstance15940a49743iy as DOUBLE_getInstance,
  serializer1x79l67jvwntn as serializer,
  ArraySerializermpxy3fgi5xnb as ArraySerializer,
  BOOLEAN_getInstance2bvk5fygnzp1q as BOOLEAN_getInstance,
  INT_getInstancety325w3vt74z as INT_getInstance,
  serializer1hwzc6m64v1op as serializer_0,
  listSerialDescriptor1yo4gcd7570ts as listSerialDescriptor,
  serializer1i4e9ym37oxmo as serializer_1,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  toString1pkumu07cwy4m as toString,
  IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  defineProp3hxgpk2knu2px as defineProp,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Exceptiondt2hlxn7j7vw as Exception,
  Unit_instanceat14thlj150z as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString30pk9tzaqopn as toString_0,
  equals2au1ep9vhcato as equals,
  LinkedHashMap_init_$Create$2gfxg59gogbfz as LinkedHashMap_init_$Create$,
  reversedArray1jvawboiqjp41 as reversedArray,
  Exception_init_$Create$1f9k5rt5gytdg as Exception_init_$Create$,
  LinkedHashSet_init_$Create$161uomhguzhxi as LinkedHashSet_init_$Create$,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$snys8oz8txtu as LinkedHashMap_init_$Create$_0,
  copyToArray2j022khrow2yi as copyToArray,
  emptyList1g2z5xcrvp2zy as emptyList,
  Error3ofk6owajcepa as Error_0,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$_0,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  emptyMapr06gerzljqtm as emptyMap,
  hashCodeq5arwsb9dgti as hashCode,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getKClass1s3j9wy1cofik as getKClass,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  toMutableList3ewlpx8m5ca2q as toMutableList,
  Paire9pteg33gng7 as Pair,
  listOf1jh22dvmctj1r as listOf,
  plus1di085adi7f7m as plus,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  isBlank1dvkhjjvox3p0 as isBlank,
  sortedWith2csnbbb21k0lg as sortedWith,
  plus2m1vv33moko5t as plus_0,
  plus27p1csfyhycs6 as plus_1,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  isArray1hxjqtqy632bc as isArray,
  toList383f556t1dixk as toList,
  addAll1k27qatfgp3k5 as addAll,
  isNaNymqb93xtq8w8 as isNaN_0,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  firstOrNull1gk7vzkf4h3nq as firstOrNull,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
  Enum3alwj03lh1n41 as Enum,
  NoSuchElementException_init_$Create$1admdzgt61c19 as NoSuchElementException_init_$Create$,
  StringBuilder_init_$Create$zzhi687lupah as StringBuilder_init_$Create$,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  toDouble1kn912gjoizjp as toDouble,
  contains2el4s70rdq4ld as contains,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  round2mrvepag8eey0 as round,
  joinToString1cxrrlmo0chqs as joinToString,
  contains3ue2qo8xhmpf1 as contains_0,
  Exception_init_$Init$2t8qsqvbxaqim as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  trimIndent1qytc1wvt8suh as trimIndent,
  joinToStringxqcavsxcmh4q as joinToString_0,
  UnsupportedOperationException_init_$Create$1usmxm8d6ijjz as UnsupportedOperationException_init_$Create$,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
} from './kotlin-kotlin-stdlib.mjs';
import {
  LoggerState_getInstance458njkt1c1yk as LoggerState_getInstance,
  ProductParamsqcv385pfoovn as ProductParams,
  ProductParamsComponent3tz0lreyu4pf2 as ProductParamsComponent,
  Companion_getInstanceiuj3shxmfy4i as Companion_getInstance,
  CatalogSizeComponent18xv9v502n7ro as CatalogSizeComponent,
  productSpecification1di33unl59xxe as productSpecification,
  Companion_getInstance1gt5uaft3z0z9 as Companion_getInstance_0,
  AssemblyPartsComponent_init_$Create$30ms2ttoutmay as AssemblyPartsComponent_init_$Create$,
  createCustomAssembly2xru0w2yvxl0g as createCustomAssembly,
  createCustomAssemblySpecificationrtotobw2qkrj as createCustomAssemblySpecification,
  ProductCatalog103osycina0dv as ProductCatalog,
  Companion_instance1jc5thgshmt53 as Companion_instance,
  get_serializabletahhnzjs6wap as get_serializable,
  get_doStoreInSnapshot2ouhd6iwtr8a6 as get_doStoreInSnapshot,
  Component1lglqnbx5ofkj as Component,
  $serializer_getInstance2cm4qg7o1asp1 as $serializer_getInstance,
  $serializer_getInstance2thyfr0ndtc2i as $serializer_getInstance_0,
  AssemblyStructureComponent3qqm1io5f7l8g as AssemblyStructureComponent,
  ProductSpecificationsunk1qtx1k13 as ProductSpecification,
  ModelInfoComponentvt7uz6p6kni4 as ModelInfoComponent,
  RelativeConnectorsComponent2s0o9ntl664k2 as RelativeConnectorsComponent,
  DisplayNameComponent37eao6dtqdntj as DisplayNameComponent,
  ConnectionRootComponent3fd9sp0aqznxo as ConnectionRootComponent,
  Vector1cgy08ha6e7ya as Vector,
  TemplateDataComponentpbjy7hrg15a7 as TemplateDataComponent,
  DraggableComponent2vg3of9uj9uwn as DraggableComponent,
  AlwaysHangDownComponent_instance2s6f7ev3q7y3y as AlwaysHangDownComponent_instance,
  UnserializableEntityComponent3dbbopzug8j88 as UnserializableEntityComponent,
  SelectableComponent2e9l9zv14vcv9 as SelectableComponent,
  OutlineableComponent1wms50wedlllg as OutlineableComponent,
  ConnectorsComponent32a4eg1gtppvf as ConnectorsComponent,
  ColliderShapeComponent102whak4g71e2 as ColliderShapeComponent,
  ModelTransformComponentljn0f1n2gsc8 as ModelTransformComponent,
  ProppingComponent3ntna4jqkya3u as ProppingComponent,
  DragSurfacesComponent2obth6ol1y4en as DragSurfacesComponent,
  Companion_getInstance1k2wrnuhjrbuv as Companion_getInstance_1,
  ProductStructureConnection2fj7164v4tcgh as ProductStructureConnection,
  ProductStructureItem3ehsotxzwomz5 as ProductStructureItem,
  ProductStructureComponent1n49mlfstxaxv as ProductStructureComponent,
  AssemblyPartSnapInfo3vtetiub067zv as AssemblyPartSnapInfo,
  Companion_getInstancebkytj44sbgxv as Companion_getInstance_2,
  AssemblyPart110oq599i90v0 as AssemblyPart,
  Companion_getInstanceblwi6p98rjjg as Companion_getInstance_3,
  Degrees1pmrlnndueajq as Degrees,
  Transform2e9p9l2euepqa as Transform,
  Companion_getInstanceoonrb8185bmg as Companion_getInstance_4,
  Margin55v3iexvqdfb as Margin,
  Sizervsnigdp89bq as Size,
  merge14fhz8zclcclx as merge,
  Companion_getInstance1cmxj7l93cwya as Companion_getInstance_5,
  Companion_instance2u0j4bg5mk4do as Companion_instance_0,
  Companion_instance1l2xi6jq9r026 as Companion_instance_1,
  RotationDegreeOfFreedom_ONE_getInstance2o4nol40iudhw as RotationDegreeOfFreedom_ONE_getInstance,
  RotationDegreeOfFreedom_NONE_getInstance33hadjigf520i as RotationDegreeOfFreedom_NONE_getInstance,
  PointConnector2aof4iylw00ug as PointConnector,
  PointSeriesConnector14wrze1fez6ba as PointSeriesConnector,
  EdgeConnector18c5afzui3cj0 as EdgeConnector,
  SurfaceConnector2qgrveebgrhin as SurfaceConnector,
  Companion_instanceky5cav6lf93r as Companion_instance_2,
  Companion_instance180k82anvpmzv as Companion_instance_3,
  ConnectorTagConstants_instance25r6fly62d92a as ConnectorTagConstants_instance,
  RelationOrigin3sa84ujcjvad5 as RelationOrigin,
  RelativeBoxOffset2b8mgz1w3jy13 as RelativeBoxOffset,
  RelativeConnectorData1sdpyngxtictl as RelativeConnectorData,
  fromSizeAndCenter1wsnpvuimuz5l as fromSizeAndCenter,
  DragSurface3d7ocyb1ribou as DragSurface,
  Companion_instancebp32or5zv9ar as Companion_instance_4,
  SizeFromVector3opll479fkt93 as SizeFromVector,
  Companion_instance1crj6uacmrlqq as Companion_instance_5,
  Companion_instanceydebsezhypgx as Companion_instance_6,
  Companion_instance958nhgcvitga as Companion_instance_7,
  $serializer_getInstance12w01pzkae8i7 as $serializer_getInstance_1,
} from './core-core-api.mjs';
import {
  JsonElementSerializer_getInstance2oljfos0dzhs0 as JsonElementSerializer_getInstance,
  Jsonsmkyu9xjl7fv as Json,
  Default_getInstance2o39jijms8bnj as Default_getInstance,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_double1785hcxaminy4 as get_double,
  Companion_instanceo6n8nih21ztr as Companion_instance_8,
  get_jsonArray18sglwhl4pclz as get_jsonArray,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  get_jsonObject2u4z2ch1uuca9 as get_jsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  get_doubleOrNull2fo14gjg922um as get_doubleOrNull,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  ConnectorVisualizationData12c6o2kaz0oxo as ConnectorVisualizationData,
  RecommendedInitialPositionFromFloorComponent2w8snp7w7asn as RecommendedInitialPositionFromFloorComponent,
  FunctionalMarginShapeComponent1ipzxulknf0p as FunctionalMarginShapeComponent,
  FunctionalZonesLocalComponent1aj0wo49dpyv3 as FunctionalZonesLocalComponent,
  PlacementZoneByHeightComponent17hvd16v0ynlm as PlacementZoneByHeightComponent,
  AutoAdaptHostComponent34qpeh2sq4yhu as AutoAdaptHostComponent,
  AllowedDoorPairsComponent3mt210f8oa8rk as AllowedDoorPairsComponent,
  AutoAdaptGuestComponentm7ystystq256 as AutoAdaptGuestComponent,
  CommunicationSizeComponent3b9iyn3tznkse as CommunicationSizeComponent,
  LegComponent_getInstance2b9gn5nn97ee3 as LegComponent_getInstance,
  FrameComponent_getInstance2c998mz05aq2i as FrameComponent_getInstance,
  DoorComponent1aqj2bxcz9fq3 as DoorComponent,
  DoorFrontComponent_getInstance2e2t42qmfke7o as DoorFrontComponent_getInstance,
  HandleComponent_getInstance3ura479bgq6yv as HandleComponent_getInstance,
  DrawerComponent_getInstancev1maoc1j7lic as DrawerComponent_getInstance,
  LightComponentkx6mitxrp2z0 as LightComponent,
  DragProjectionPointComponent373iy7kyauua1 as DragProjectionPointComponent,
  FunctionalZone2cyfwjzx0uu9k as FunctionalZone,
} from './core-core-stl.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForObject(CustomSerializer, 'CustomSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(AutoAdaptGroup, 'AutoAdaptGroup', VOID, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance});
initMetadataForCompanion(Companion);
initMetadataForClass(DynamicComponentResolver, 'DynamicComponentResolver');
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DynamicProduct, 'DynamicProduct', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_1);
initMetadataForClass(DynamicProductCatalog, 'DynamicProductCatalog', VOID, VOID, [ProductCatalog]);
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DynamicTemplateData, 'DynamicTemplateData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DynamicProductData, 'DynamicProductData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_4);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ProductTemplate, 'ProductTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_5);
initMetadataForClass(MetaDataComponent, 'MetaDataComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(VisualLightSourceComponent, 'VisualLightSourceComponent', VisualLightSourceComponent, VOID, [Component]);
initMetadataForCompanion(Companion_7);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CatalogTemplateData, 'CatalogTemplateData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_8);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ModelRenderInfo, 'ModelRenderInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_9);
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Part, 'Part', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_10);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ProductDataComponent, 'ProductDataComponent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForClass(TemplateEditorConnectorData, 'TemplateEditorConnectorData', VOID, VOID, [ConnectorVisualizationData]);
initMetadataForClass(DynamicComponentBuilder, 'DynamicComponentBuilder');
initMetadataForClass(DynamicAssembly, 'DynamicAssembly', VOID, DynamicComponentBuilder);
initMetadataForCompanion(Companion_11);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(DynamicShape, 'DynamicShape', VOID, DynamicComponentBuilder);
initMetadataForCompanion(Companion_13);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AssemblyChild, 'AssemblyChild', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_14);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AssemblyTemplate, 'AssemblyTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForObject(CustomSerializer_0, 'CustomSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(AutoAdaptHostTemplate, 'AutoAdaptHostTemplate', AutoAdaptHostTemplate, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_0});
initMetadataForCompanion(Companion_15, VOID, [KSerializer]);
initMetadataForClass(BoundItemTemplate, 'BoundItemTemplate', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_22});
initMetadataForCompanion(Companion_16, VOID, [KSerializer]);
initMetadataForClass(Compartment, 'Compartment', Compartment, VOID, VOID, VOID, VOID, {0: Companion_getInstance_23});
initMetadataForCompanion(Companion_17);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ComponentsTemplate, 'ComponentsTemplate', ComponentsTemplate, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_18, VOID, [KSerializer]);
initMetadataForClass(ConnectorItemTemplate, 'ConnectorItemTemplate', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_25});
initMetadataForCompanion(Companion_19, VOID, [KSerializer]);
initMetadataForClass(DynamicRangeDimension, 'Dimension', DynamicRangeDimension, VOID, VOID, VOID, VOID, {0: Companion_getInstance_26});
initMetadataForCompanion(Companion_20);
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DragSurfaceTemplate, 'DragSurfaceTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForObject(CustomSerializer_1, 'CustomSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(DragSurfacesTemplate, 'DragSurfacesTemplate', VOID, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_1});
initMetadataForClass(DynamicRangeUtils$Companion$getMeta$1);
initMetadataForCompanion(Companion_21);
initMetadataForClass(DynamicRangeUtils, 'DynamicRangeUtils', DynamicRangeUtils);
initMetadataForCompanion(Companion_22);
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LightTemplate, 'LightTemplate', LightTemplate, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForObject(MarginTemplateSerializer, 'MarginTemplateSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MarginTemplate, 'MarginTemplate', MarginTemplate, VOID, VOID, VOID, VOID, {0: MarginTemplateSerializer_getInstance});
initMetadataForCompanion(Companion_23);
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Model3DTemplate, 'Model3DTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForObject(CustomSerializer_2, 'CustomSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(OriginTemplate, 'OriginTemplate', VOID, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_2});
initMetadataForCompanion(Companion_24);
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlacementZoneByHeightTemplate, 'PlacementZoneByHeightTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForObject(PositionTemplateSerializer, 'PositionTemplateSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PositionTemplate, 'PositionTemplate', VOID, VOID, VOID, VOID, VOID, {0: PositionTemplateSerializer_getInstance});
initMetadataForCompanion(Companion_25);
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VisualLightSourceTemplate, 'VisualLightSourceTemplate', VisualLightSourceTemplate, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
initMetadataForCompanion(Companion_26);
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ProductStructureConnectionTemplate, 'ProductStructureConnectionTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
initMetadataForCompanion(Companion_27);
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ProductStructureItemTemplate, 'ProductStructureItemTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
initMetadataForCompanion(Companion_28, VOID, [SerializerFactory]);
initMetadataForClass(OriginRelativeTo, 'OriginRelativeTo', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_35});
initMetadataForObject(OriginRelativeToImpostor_0, 'OriginRelativeToImpostor');
initMetadataForCompanion(Companion_29);
initMetadataForClass(PositionType, 'PositionType', VOID, Enum);
initMetadataForCompanion(Companion_30);
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PositionValue, 'PositionValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
initMetadataForCompanion(Companion_31, VOID, [KSerializer]);
initMetadataForClass(RelativePosition, 'RelativePosition', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_38});
initMetadataForObject(RelativeTransformSerializer, 'RelativeTransformSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(RelativeTransform, 'RelativeTransform', RelativeTransform, VOID, VOID, VOID, VOID, {0: RelativeTransformSerializer_getInstance});
initMetadataForObject(NamedTransformObjectDeserializer, 'NamedTransformObjectDeserializer');
initMetadataForObject(RelationOriginSerializer, 'RelationOriginSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(RelativeTransformDeserializer, 'RelativeTransformDeserializer');
initMetadataForClass(DynamicRangeParseError, 'DynamicRangeParseError', VOID, Exception);
initMetadataForClass(CatalogGenerator, 'CatalogGenerator', CatalogGenerator);
initMetadataForClass(parseMeta$result$1);
//endregion
function CustomSerializer() {
  CustomSerializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.AutoAdaptGroup', null, 2);
  tmp0_serialDesc.lw('key', false);
  tmp0_serialDesc.lw('priority', false);
  this.z5d_1 = tmp0_serialDesc;
}
protoOf(CustomSerializer).vl = function (decoder) {
  try {
    var key = decoder.wo();
    return new AutoAdaptGroup(key, 0);
  } catch ($p) {
    if ($p instanceof SerializationException) {
      var e = $p;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var $this$run = decoder.bp(this.z5d_1);
      var key_0 = null;
      var priority = null;
      $l$loop: while (true) {
        var index = $this$run.sp(CustomSerializer_getInstance().z5d_1);
        if (index === -1)
          break $l$loop;
        switch (index) {
          case 0:
            key_0 = $this$run.lp(CustomSerializer_getInstance().z5d_1, 0);
            break;
          case 1:
            priority = $this$run.gp(CustomSerializer_getInstance().z5d_1, 1);
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = 'AutoAdaptGroup: unexpected index: ' + index;
            throw IllegalStateException_init_$Create$(toString(message));
        }
      }
      $this$run.cp(CustomSerializer_getInstance().z5d_1);
      if (key_0 == null) {
        // Inline function 'kotlin.error' call
        var message_0 = 'AutoAdaptGroup: key must be specified';
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
      var tmp = key_0;
      var tmp1_elvis_lhs = priority;
      return new AutoAdaptGroup(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
    } else {
      throw $p;
    }
  }
};
protoOf(CustomSerializer).tl = function () {
  return this.z5d_1;
};
protoOf(CustomSerializer).a5e = function (encoder, value) {
  var tmp0_desc = this.z5d_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.key);
  tmp1_output.lq(tmp0_desc, 1, value.priority);
  tmp1_output.cp(tmp0_desc);
};
protoOf(CustomSerializer).ul = function (encoder, value) {
  return this.a5e(encoder, value instanceof AutoAdaptGroup ? value : THROW_CCE());
};
protoOf(CustomSerializer).z18 = function () {
  return CustomSerializer_getInstance();
};
var CustomSerializer_instance;
function CustomSerializer_getInstance() {
  if (CustomSerializer_instance == null)
    new CustomSerializer();
  return CustomSerializer_instance;
}
function AutoAdaptGroup(key, priority) {
  CustomSerializer_getInstance();
  this.key = key;
  this.priority = priority;
}
protoOf(AutoAdaptGroup).b2 = function () {
  return this.key;
};
protoOf(AutoAdaptGroup).n28 = function () {
  return this.priority;
};
protoOf(AutoAdaptGroup).tf = function () {
  return this.key;
};
protoOf(AutoAdaptGroup).uf = function () {
  return this.priority;
};
protoOf(AutoAdaptGroup).b5e = function (key, priority) {
  return new AutoAdaptGroup(key, priority);
};
protoOf(AutoAdaptGroup).copy = function (key, priority, $super) {
  key = key === VOID ? this.key : key;
  priority = priority === VOID ? this.priority : priority;
  return this.b5e(key, priority);
};
protoOf(AutoAdaptGroup).toString = function () {
  return 'AutoAdaptGroup(key=' + this.key + ', priority=' + this.priority + ')';
};
protoOf(AutoAdaptGroup).hashCode = function () {
  var result = getStringHashCode(this.key);
  result = imul(result, 31) + this.priority | 0;
  return result;
};
protoOf(AutoAdaptGroup).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AutoAdaptGroup))
    return false;
  var tmp0_other_with_cast = other instanceof AutoAdaptGroup ? other : THROW_CCE();
  if (!(this.key === tmp0_other_with_cast.key))
    return false;
  if (!(this.priority === tmp0_other_with_cast.priority))
    return false;
  return true;
};
function modelRenderInfo($this, dynamicProduct) {
  // Inline function 'kotlin.text.isNullOrEmpty' call
  var this_0 = dynamicProduct.modelURI;
  // Inline function 'kotlin.contracts.contract' call
  if (this_0 == null || charSequenceLength(this_0) === 0)
    return null;
  return new ModelRenderInfo($this.d5e_1, dynamicProduct.modelURI, '');
}
function Companion() {
  Companion_instance_9 = this;
  this.e5e_1 = LoggerState_getInstance().g1v('DynamicComponentResolver');
}
var Companion_instance_9;
function Companion_getInstance_6() {
  if (Companion_instance_9 == null)
    new Companion();
  return Companion_instance_9;
}
function DynamicComponentResolver$builder$lambda($templateId) {
  return function () {
    return "No template found for for '" + $templateId + "'.";
  };
}
function DynamicComponentResolver$builder$lambda_0($templateId, $e) {
  return function () {
    return "There are errors in the loaded data for '" + $templateId + "'. (" + $e.message + ')';
  };
}
function DynamicComponentResolver(catalog, modelRootUrl) {
  Companion_getInstance_6();
  modelRootUrl = modelRootUrl === VOID ? null : modelRootUrl;
  this.c5e_1 = catalog;
  this.d5e_1 = modelRootUrl;
}
protoOf(DynamicComponentResolver).f5e = function (productInfo) {
  var templateId = productInfo.template.id;
  var tmp;
  try {
    var productTemplate = this.c5e_1.findTemplateDTO(templateId);
    var tmp_0;
    if (!(productTemplate == null)) {
      var tmp_1;
      if (!(productTemplate.components.assembly == null)) {
        tmp_1 = new DynamicAssembly(productInfo, productInfo.template, productTemplate, this.c5e_1);
      } else {
        tmp_1 = new DynamicShape(productInfo, productInfo.template, modelRenderInfo(this, productInfo), productTemplate, this.c5e_1);
      }
      tmp_0 = tmp_1;
    } else {
      var tmp_2 = Companion_getInstance_6().e5e_1;
      tmp_2.warn(DynamicComponentResolver$builder$lambda(templateId));
      tmp_0 = null;
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_3;
    if ($p instanceof Exception) {
      var e = $p;
      var tmp_4 = Companion_getInstance_6().e5e_1;
      tmp_4.warn(DynamicComponentResolver$builder$lambda_0(templateId, e));
      tmp_3 = null;
    } else {
      throw $p;
    }
    tmp = tmp_3;
  }
  return tmp;
};
function Companion_0() {
  Companion_instance_10 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i5e_1 = [null, null, null, null, null, null, null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance())];
}
protoOf(Companion_0).z18 = function () {
  return $serializer_getInstance_2();
};
var Companion_instance_10;
function Companion_getInstance_7() {
  if (Companion_instance_10 == null)
    new Companion_0();
  return Companion_instance_10;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.DynamicProduct', this, 11);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('type', true);
  tmp0_serialDesc.lw('dexf', true);
  tmp0_serialDesc.lw('modelURI', true);
  tmp0_serialDesc.lw('desc', true);
  tmp0_serialDesc.lw('template', false);
  tmp0_serialDesc.lw('typeCode', true);
  tmp0_serialDesc.lw('partsInPackage', true);
  tmp0_serialDesc.lw('autoAdaptGroup', true);
  tmp0_serialDesc.lw('dexfAssetName', true);
  tmp0_serialDesc.lw('meta', true);
  this.j5e_1 = tmp0_serialDesc;
}
protoOf($serializer).k5e = function (encoder, value) {
  var tmp0_desc = this.j5e_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_7().i5e_1;
  tmp1_output.qq(tmp0_desc, 0, value.id);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.type == null)) {
    tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.dexf == null)) {
    tmp1_output.uq(tmp0_desc, 2, StringSerializer_getInstance(), value.dexf);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.modelURI == null)) {
    tmp1_output.uq(tmp0_desc, 3, StringSerializer_getInstance(), value.modelURI);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.desc === '')) {
    tmp1_output.qq(tmp0_desc, 4, value.desc);
  }
  tmp1_output.sq(tmp0_desc, 5, $serializer_getInstance_6(), value.template);
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.typeCode == null)) {
    tmp1_output.uq(tmp0_desc, 6, IntSerializer_getInstance(), value.typeCode);
  }
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.partsInPackage == null)) {
    tmp1_output.uq(tmp0_desc, 7, IntSerializer_getInstance(), value.partsInPackage);
  }
  if (tmp1_output.yq(tmp0_desc, 8) ? true : !(value.autoAdaptGroup == null)) {
    tmp1_output.uq(tmp0_desc, 8, CustomSerializer_getInstance(), value.autoAdaptGroup);
  }
  if (tmp1_output.yq(tmp0_desc, 9) ? true : !(value.dexfAssetName == null)) {
    tmp1_output.uq(tmp0_desc, 9, StringSerializer_getInstance(), value.dexfAssetName);
  }
  if (tmp1_output.yq(tmp0_desc, 10) ? true : !(value.meta == null)) {
    tmp1_output.uq(tmp0_desc, 10, tmp2_cached[10], value.meta);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer).ul = function (encoder, value) {
  return this.k5e(encoder, value instanceof DynamicProduct ? value : THROW_CCE());
};
protoOf($serializer).vl = function (decoder) {
  var tmp0_desc = this.j5e_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_input = decoder.bp(tmp0_desc);
  var tmp16_cached = Companion_getInstance_7().i5e_1;
  if (tmp15_input.rp()) {
    tmp4_local0 = tmp15_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp15_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp15_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp15_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp15_input.lp(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp15_input.np(tmp0_desc, 5, $serializer_getInstance_6(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp15_input.pp(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp15_input.pp(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp15_input.pp(tmp0_desc, 8, CustomSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp15_input.pp(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp15_input.pp(tmp0_desc, 10, tmp16_cached[10], tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp15_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp15_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp15_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp15_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp15_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp15_input.lp(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp15_input.np(tmp0_desc, 5, $serializer_getInstance_6(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp15_input.pp(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp15_input.pp(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp15_input.pp(tmp0_desc, 8, CustomSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp15_input.pp(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp15_input.pp(tmp0_desc, 10, tmp16_cached[10], tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp15_input.cp(tmp0_desc);
  return DynamicProduct_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
};
protoOf($serializer).tl = function () {
  return this.j5e_1;
};
protoOf($serializer).ex = function () {
  var tmp0_cached = Companion_getInstance_7().i5e_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), $serializer_getInstance_6(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(CustomSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[10])];
};
var $serializer_instance;
function $serializer_getInstance_2() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function DynamicProduct_init_$Init$(seen0, id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName, meta, serializationConstructorMarker, $this) {
  if (!(33 === (33 & seen0))) {
    throwMissingFieldException(seen0, 33, $serializer_getInstance_2().j5e_1);
  }
  $this.id = id;
  if (0 === (seen0 & 2))
    $this.type = null;
  else
    $this.type = type;
  if (0 === (seen0 & 4))
    $this.dexf = null;
  else
    $this.dexf = dexf;
  if (0 === (seen0 & 8))
    $this.modelURI = null;
  else
    $this.modelURI = modelURI;
  if (0 === (seen0 & 16))
    $this.desc = '';
  else
    $this.desc = desc;
  $this.template = template;
  if (0 === (seen0 & 64))
    $this.typeCode = null;
  else
    $this.typeCode = typeCode;
  if (0 === (seen0 & 128))
    $this.partsInPackage = null;
  else
    $this.partsInPackage = partsInPackage;
  if (0 === (seen0 & 256))
    $this.autoAdaptGroup = null;
  else
    $this.autoAdaptGroup = autoAdaptGroup;
  if (0 === (seen0 & 512))
    $this.dexfAssetName = null;
  else
    $this.dexfAssetName = dexfAssetName;
  if (0 === (seen0 & 1024))
    $this.meta = null;
  else
    $this.meta = meta;
  return $this;
}
function DynamicProduct_init_$Create$(seen0, id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName, meta, serializationConstructorMarker) {
  return DynamicProduct_init_$Init$(seen0, id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName, meta, serializationConstructorMarker, objectCreate(protoOf(DynamicProduct)));
}
function DynamicProduct(id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName) {
  Companion_getInstance_7();
  type = type === VOID ? null : type;
  dexf = dexf === VOID ? null : dexf;
  modelURI = modelURI === VOID ? null : modelURI;
  desc = desc === VOID ? '' : desc;
  typeCode = typeCode === VOID ? null : typeCode;
  partsInPackage = partsInPackage === VOID ? null : partsInPackage;
  autoAdaptGroup = autoAdaptGroup === VOID ? null : autoAdaptGroup;
  dexfAssetName = dexfAssetName === VOID ? null : dexfAssetName;
  this.id = id;
  this.type = type;
  this.dexf = dexf;
  this.modelURI = modelURI;
  this.desc = desc;
  this.template = template;
  this.typeCode = typeCode;
  this.partsInPackage = partsInPackage;
  this.autoAdaptGroup = autoAdaptGroup;
  this.dexfAssetName = dexfAssetName;
  this.meta = null;
}
protoOf(DynamicProduct).n1s = function () {
  return this.id;
};
protoOf(DynamicProduct).w2a = function () {
  return this.type;
};
protoOf(DynamicProduct).l5e = function () {
  return this.dexf;
};
protoOf(DynamicProduct).m5e = function () {
  return this.modelURI;
};
protoOf(DynamicProduct).n5e = function () {
  return this.desc;
};
protoOf(DynamicProduct).o5e = function () {
  return this.template;
};
protoOf(DynamicProduct).p5e = function () {
  return this.typeCode;
};
protoOf(DynamicProduct).q5e = function () {
  return this.partsInPackage;
};
protoOf(DynamicProduct).r5e = function () {
  return this.autoAdaptGroup;
};
protoOf(DynamicProduct).s5e = function () {
  return this.dexfAssetName;
};
protoOf(DynamicProduct).t5e = function (_set____db54di) {
  this.meta = _set____db54di;
};
protoOf(DynamicProduct).u5e = function () {
  return this.meta;
};
protoOf(DynamicProduct).v5e = function (meta) {
  this.meta = meta;
  return this;
};
protoOf(DynamicProduct).isMultipartAssembly = function () {
  var tmp0_safe_receiver = this.template.parts;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    tmp = !(tmp0_safe_receiver.length === 0);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
};
protoOf(DynamicProduct).tf = function () {
  return this.id;
};
protoOf(DynamicProduct).uf = function () {
  return this.type;
};
protoOf(DynamicProduct).m1m = function () {
  return this.dexf;
};
protoOf(DynamicProduct).n1m = function () {
  return this.modelURI;
};
protoOf(DynamicProduct).o1m = function () {
  return this.desc;
};
protoOf(DynamicProduct).p1m = function () {
  return this.template;
};
protoOf(DynamicProduct).q1m = function () {
  return this.typeCode;
};
protoOf(DynamicProduct).l2e = function () {
  return this.partsInPackage;
};
protoOf(DynamicProduct).m2e = function () {
  return this.autoAdaptGroup;
};
protoOf(DynamicProduct).n2e = function () {
  return this.dexfAssetName;
};
protoOf(DynamicProduct).w5e = function (id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName) {
  return new DynamicProduct(id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName);
};
protoOf(DynamicProduct).copy = function (id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName, $super) {
  id = id === VOID ? this.id : id;
  type = type === VOID ? this.type : type;
  dexf = dexf === VOID ? this.dexf : dexf;
  modelURI = modelURI === VOID ? this.modelURI : modelURI;
  desc = desc === VOID ? this.desc : desc;
  template = template === VOID ? this.template : template;
  typeCode = typeCode === VOID ? this.typeCode : typeCode;
  partsInPackage = partsInPackage === VOID ? this.partsInPackage : partsInPackage;
  autoAdaptGroup = autoAdaptGroup === VOID ? this.autoAdaptGroup : autoAdaptGroup;
  dexfAssetName = dexfAssetName === VOID ? this.dexfAssetName : dexfAssetName;
  return this.w5e(id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, dexfAssetName);
};
protoOf(DynamicProduct).toString = function () {
  return 'DynamicProduct(id=' + this.id + ', type=' + this.type + ', dexf=' + this.dexf + ', modelURI=' + this.modelURI + ', desc=' + this.desc + ', template=' + this.template.toString() + ', typeCode=' + this.typeCode + ', partsInPackage=' + this.partsInPackage + ', autoAdaptGroup=' + toString_0(this.autoAdaptGroup) + ', dexfAssetName=' + this.dexfAssetName + ')';
};
protoOf(DynamicProduct).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + (this.type == null ? 0 : getStringHashCode(this.type)) | 0;
  result = imul(result, 31) + (this.dexf == null ? 0 : getStringHashCode(this.dexf)) | 0;
  result = imul(result, 31) + (this.modelURI == null ? 0 : getStringHashCode(this.modelURI)) | 0;
  result = imul(result, 31) + getStringHashCode(this.desc) | 0;
  result = imul(result, 31) + this.template.hashCode() | 0;
  result = imul(result, 31) + (this.typeCode == null ? 0 : this.typeCode) | 0;
  result = imul(result, 31) + (this.partsInPackage == null ? 0 : this.partsInPackage) | 0;
  result = imul(result, 31) + (this.autoAdaptGroup == null ? 0 : this.autoAdaptGroup.hashCode()) | 0;
  result = imul(result, 31) + (this.dexfAssetName == null ? 0 : getStringHashCode(this.dexfAssetName)) | 0;
  return result;
};
protoOf(DynamicProduct).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DynamicProduct))
    return false;
  var tmp0_other_with_cast = other instanceof DynamicProduct ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.type == tmp0_other_with_cast.type))
    return false;
  if (!(this.dexf == tmp0_other_with_cast.dexf))
    return false;
  if (!(this.modelURI == tmp0_other_with_cast.modelURI))
    return false;
  if (!(this.desc === tmp0_other_with_cast.desc))
    return false;
  if (!this.template.equals(tmp0_other_with_cast.template))
    return false;
  if (!(this.typeCode == tmp0_other_with_cast.typeCode))
    return false;
  if (!(this.partsInPackage == tmp0_other_with_cast.partsInPackage))
    return false;
  if (!equals(this.autoAdaptGroup, tmp0_other_with_cast.autoAdaptGroup))
    return false;
  if (!(this.dexfAssetName == tmp0_other_with_cast.dexfAssetName))
    return false;
  return true;
};
function DynamicProductCatalog$Companion$jsonParser$lambda($this$Json) {
  $this$Json.s17_1 = true;
  $this$Json.r17_1 = true;
  return Unit_instance;
}
function extractVersionForThisCatalog($this, catalogVersions) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = catalogVersions.length;
    while (inductionVariable < last) {
      var element = catalogVersions[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.extractVersionForThisCatalog.<anonymous>' call
      if (element.rangeId === $this.rangeId()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.version;
}
function createProductParamsComponent($this, providedParams, product) {
  return !(providedParams == null) ? new ProductParamsComponent(providedParams, false) : new ProductParamsComponent(new ProductParams(product.template.size), true);
}
function applyParams($this, product, params) {
  if (params == null)
    return product;
  var tmp1_elvis_lhs = Companion_getInstance().y2z(product.template.size, params);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return product;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var newSize = tmp;
  var newProduct = product.copy(VOID, VOID, VOID, VOID, VOID, product.template.copy(VOID, newSize));
  newProduct.v5e(product.meta);
  return newProduct;
}
function getProductInfo($this, productId) {
  return $this.y5e_1.f2(productId);
}
function parseTemplates($this, json) {
  var templates = Companion_getInstance_8().j5f_1.w16(Companion_getInstance_9().z18(), json).h5f_1;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = templates.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.parseTemplates.<anonymous>' call
    var tmp0_safe_receiver = element.components.bounds;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element_0 = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.parseTemplates.<anonymous>.<anonymous>' call
        element_0.sourceTemplateId = element.templateId;
      }
    }
    var tmp1_safe_receiver = element.components.connectors;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp1_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_1 = tmp1_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.parseTemplates.<anonymous>.<anonymous>' call
        element_1.sourceTemplateId = element.templateId;
      }
    }
  }
  return resolveTemplateInheritance($this, templates);
}
function resolveTemplateInheritance($this, templates) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var resolved = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = templates.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.resolveTemplateInheritance.<anonymous>' call
    if (resolved.f2(element.templateId) == null) {
      resolve($this, element, resolved, templates);
    }
  }
  return resolved;
}
function resolve($this, productTemplate, resolved, unresolved) {
  if (productTemplate.inherits == null) {
    // Inline function 'kotlin.collections.set' call
    var key = productTemplate.templateId;
    resolved.q2(key, productTemplate);
    return productTemplate;
  } else {
    var resultingTemplate = productTemplate;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = reversedArray(productTemplate.inherits);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.resolve.<anonymous>' call
      var extended = resolved.f2(element);
      if (extended == null) {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = unresolved.k();
          while (tmp0_iterator.m()) {
            var element_0 = tmp0_iterator.n();
            // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.resolve.<anonymous>.<anonymous>' call
            if (element_0.templateId === element) {
              tmp$ret$1 = element_0;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw Exception_init_$Create$("Template '" + productTemplate.templateId + "' extends '" + element + "' that cannot be found");
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var unresolvedExtended = tmp;
        extended = resolve($this, unresolvedExtended, resolved, unresolved);
      }
      resultingTemplate = resultingTemplate.inherit(extended);
    }
    // Inline function 'kotlin.collections.set' call
    var key_0 = resultingTemplate.templateId;
    var value = resultingTemplate;
    resolved.q2(key_0, value);
    return resultingTemplate;
  }
}
function parseInfo($this, json) {
  var parsed = Companion_getInstance_8().j5f_1.w16(Companion_getInstance_10().z18(), json);
  $this.b5f_1 = parsed.q5f_1;
  $this.c5f_1 = parsed.s5f_1;
  return parsed.t5f_1;
}
function Companion_1() {
  Companion_instance_11 = this;
  var tmp = this;
  tmp.j5f_1 = Json(VOID, DynamicProductCatalog$Companion$jsonParser$lambda);
}
protoOf(Companion_1).u5f = function () {
  return this.j5f_1;
};
var Companion_instance_11;
function Companion_getInstance_8() {
  if (Companion_instance_11 == null)
    new Companion_1();
  return Companion_instance_11;
}
function DynamicProductCatalog(productInfoJson, templatesJson, modelRootUrl) {
  Companion_getInstance_8();
  modelRootUrl = modelRootUrl === VOID ? null : modelRootUrl;
  this.x5e_1 = true;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.y5e_1 = LinkedHashMap_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.a5f_1 = LinkedHashMap_init_$Create$();
  this.b5f_1 = 'dynamic';
  this.c5f_1 = '0';
  var tmp_1 = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp_1.d5f_1 = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.plusAssign' call
  var this_0 = this.y5e_1;
  // Inline function 'kotlin.collections.associateBy' call
  var this_1 = parseInfo(this, productInfoJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$_0(capacity);
  var tmp0_iterator = this_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.<anonymous>' call
    var tmp$ret$3 = element.id;
    destination.q2(tmp$ret$3, element);
  }
  this_0.s2(destination);
  this.a5f_1.s2(parseTemplates(this, templatesJson));
  this.z5e_1 = new DynamicComponentResolver(this, modelRootUrl);
}
protoOf(DynamicProductCatalog).s1t = function () {
  return this.x5e_1;
};
protoOf(DynamicProductCatalog).addInterceptor = function (interceptor) {
  this.d5f_1.h(interceptor);
};
protoOf(DynamicProductCatalog).removeInterceptor = function (interceptor) {
  this.d5f_1.j2(interceptor);
};
protoOf(DynamicProductCatalog).rangeId = function () {
  return this.b5f_1;
};
protoOf(DynamicProductCatalog).rangeVersion = function () {
  return this.c5f_1;
};
protoOf(DynamicProductCatalog).beforeDeserialize = function (json, catalogVersions) {
  var res = json;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.d5f_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.beforeDeserialize.<anonymous>' call
    res = element.beforeDeserialize(res, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
  return res;
};
protoOf(DynamicProductCatalog).beforeBuildingEntities = function (serializableTree, catalogVersions) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.d5f_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.beforeBuildingEntities.<anonymous>' call
    element.beforeBuildingEntities(serializableTree, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
};
protoOf(DynamicProductCatalog).beforeParsingComponents = function (serializableTree, catalogVersions) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.d5f_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.beforeParsingComponents.<anonymous>' call
    element.beforeParsingComponents(serializableTree, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
};
protoOf(DynamicProductCatalog).afterDeserializeComplete = function (root, catalogVersions) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.d5f_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.afterDeserializeComplete.<anonymous>' call
    element.afterDeserializeComplete(root, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
};
protoOf(DynamicProductCatalog).allProductRefs = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.y5e_1.g2();
  return copyToArray(this_0);
};
protoOf(DynamicProductCatalog).findProductDTO = function (id) {
  return getProductInfo(this, id);
};
protoOf(DynamicProductCatalog).productDTOs = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.y5e_1.h2();
  return copyToArray(this_0);
};
protoOf(DynamicProductCatalog).findTemplateDTO = function (id) {
  return this.a5f_1.f2(id);
};
protoOf(DynamicProductCatalog).findTemplateDTOFromProductRef = function (productRef) {
  var product = this.findProductDTO(productRef);
  var tmp;
  if (product == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.findTemplateDTOFromProductRef.<anonymous>' call
    tmp = this.a5f_1.f2(product.template.id);
  }
  return tmp;
};
protoOf(DynamicProductCatalog).templateDTOs = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.a5f_1.h2();
  return copyToArray(this_0);
};
protoOf(DynamicProductCatalog).t1t = function (productRef, params) {
  var tmp0_elvis_lhs = this.findProductDTO(productRef);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var product = tmp;
  var productWithAppliedParams = applyParams(this, product, params);
  var tmp1_safe_receiver = this.z5e_1.f5e(productWithAppliedParams);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.v5f();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.addComponent(new CatalogSizeComponent(product.template.size));
  var specification = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.addComponent(createProductParamsComponent(this, params, product));
  return specification;
};
protoOf(DynamicProductCatalog).setTemplate = function (templatesJson) {
  try {
    resolve(this, Companion_getInstance_8().j5f_1.w16(Companion_getInstance_11().z18(), templatesJson), this.a5f_1, emptyList());
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_0(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
protoOf(DynamicProductCatalog).setTemplateObject = function (template) {
  try {
    resolve(this, template, this.a5f_1, emptyList());
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_0(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
protoOf(DynamicProductCatalog).setMultipleTemplates = function (templatesJson) {
  try {
    var unresolved = Companion_getInstance_8().j5f_1.w16(ListSerializer(Companion_getInstance_11().z18()), templatesJson);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = unresolved.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.setMultipleTemplates.<anonymous>' call
      resolve(this, element, this.a5f_1, unresolved);
    }
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_0(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
protoOf(DynamicProductCatalog).setProduct = function (productJson) {
  try {
    var tmp0_safe_receiver = Companion_getInstance_8().j5f_1.w16(Companion_getInstance_7().z18(), productJson);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var this_0 = this.y5e_1;
      var key = tmp0_safe_receiver.id;
      this_0.q2(key, tmp0_safe_receiver);
    }
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_0(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
protoOf(DynamicProductCatalog).setMultipleProducts = function (productsJson) {
  try {
    // Inline function 'kotlin.collections.map' call
    var this_0 = Companion_getInstance_8().j5f_1.w16(ListSerializer(Companion_getInstance_7().z18()), productsJson);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      var this_1 = this.y5e_1;
      var key = item.id;
      this_1.q2(key, item);
      destination.h(Unit_instance);
    }
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_0(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
protoOf(DynamicProductCatalog).hasTemplateFor = function (templateId) {
  return this.a5f_1.d2(templateId);
};
protoOf(DynamicProductCatalog).createCustomAssemblyWithOtherParts = function (originalProduct, parts) {
  var tmp0_elvis_lhs = this.findProductDTO(originalProduct);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var originalDynamicProduct = tmp;
  var oldParts = originalDynamicProduct.template.parts;
  var tmp_0;
  if (oldParts == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = oldParts.length;
    while (inductionVariable < last) {
      var element = oldParts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      $l$block: {
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.createCustomAssembly.<anonymous>' call
        var tmp0_safe_receiver = getProductInfo(this, element.id);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.template;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          tmp$ret$0 = null;
          break $l$block;
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var templateForOldPart = tmp_1;
        tmp$ret$0 = to(templateForOldPart, element.id);
      }
      var tmp0_safe_receiver_0 = tmp$ret$0;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver_0);
      }
    }
    tmp_0 = destination;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toMap(tmp2_safe_receiver);
  var oldPartsTemplates = tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = parts.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = parts[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    var tmp$ret$4;
    $l$block_1: {
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.createCustomAssembly.<anonymous>' call
      var tmp0_safe_receiver_1 = getProductInfo(this, element_0);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.template;
      var tmp2_elvis_lhs_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.id;
      var tmp_2;
      if (tmp2_elvis_lhs_0 == null) {
        tmp$ret$4 = null;
        break $l$block_1;
      } else {
        tmp_2 = tmp2_elvis_lhs_0;
      }
      var templateForNewPart = tmp_2;
      var tmp3_elvis_lhs_0 = oldPartsTemplates.f2(templateForNewPart);
      var tmp_3;
      if (tmp3_elvis_lhs_0 == null) {
        tmp$ret$4 = null;
        break $l$block_1;
      } else {
        tmp_3 = tmp3_elvis_lhs_0;
      }
      var oldPartWithSameTemplate = tmp_3;
      tmp$ret$4 = to(oldPartWithSameTemplate, element_0);
    }
    var tmp0_safe_receiver_2 = tmp$ret$4;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver_2);
    }
  }
  var replaceMap = toMap(destination_0);
  var specification = this.productSpecification(originalProduct);
  var partsComponent = specification == null ? null : specification.findComponent(Companion_getInstance_0().id);
  var tmp6_safe_receiver = partsComponent == null ? null : partsComponent.t1s_1;
  var tmp_4;
  if (tmp6_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(tmp6_safe_receiver.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = tmp6_safe_receiver.i2().k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.createCustomAssembly.<anonymous>' call
      var newPartProductRef = replaceMap.f2(item.c2());
      var tmp_5;
      if (!(newPartProductRef == null)) {
        tmp_5 = to(item.b2(), newPartProductRef);
      } else {
        tmp_5 = to(item.b2(), item.c2());
      }
      var tmp$ret$9 = tmp_5;
      destination_1.h(tmp$ret$9);
    }
    tmp_4 = destination_1;
  }
  var tmp7_safe_receiver = tmp_4;
  var newPartsMap = tmp7_safe_receiver == null ? null : toMap(tmp7_safe_receiver);
  var tmp_6;
  if (!(newPartsMap == null)) {
    tmp_6 = specification.addComponent(AssemblyPartsComponent_init_$Create$(newPartsMap));
  } else {
    tmp_6 = specification;
  }
  return tmp_6;
};
protoOf(DynamicProductCatalog).toString = function () {
  return 'Dynamic Range';
};
function Companion_2() {
  Companion_instance_12 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.k5f_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_5()), null];
}
protoOf(Companion_2).z18 = function () {
  return $serializer_getInstance_3();
};
var Companion_instance_12;
function Companion_getInstance_9() {
  if (Companion_instance_12 == null)
    new Companion_2();
  return Companion_instance_12;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.DynamicTemplateData', this, 5);
  tmp0_serialDesc.lw('range', false);
  tmp0_serialDesc.lw('rangeVersion', false);
  tmp0_serialDesc.lw('schemaVersion', false);
  tmp0_serialDesc.lw('templates', false);
  tmp0_serialDesc.lw('assetSource', true);
  this.x5f_1 = tmp0_serialDesc;
}
protoOf($serializer_0).y5f = function (encoder, value) {
  var tmp0_desc = this.x5f_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_9().k5f_1;
  tmp1_output.qq(tmp0_desc, 0, value.e5f_1);
  tmp1_output.qq(tmp0_desc, 1, value.f5f_1);
  tmp1_output.qq(tmp0_desc, 2, value.g5f_1);
  tmp1_output.sq(tmp0_desc, 3, tmp2_cached[3], value.h5f_1);
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.i5f_1 == null)) {
    tmp1_output.uq(tmp0_desc, 4, StringSerializer_getInstance(), value.i5f_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_0).ul = function (encoder, value) {
  return this.y5f(encoder, value instanceof DynamicTemplateData ? value : THROW_CCE());
};
protoOf($serializer_0).vl = function (decoder) {
  var tmp0_desc = this.x5f_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.bp(tmp0_desc);
  var tmp10_cached = Companion_getInstance_9().k5f_1;
  if (tmp9_input.rp()) {
    tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.np(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.pp(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.np(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.pp(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.cp(tmp0_desc);
  return DynamicTemplateData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_0).tl = function () {
  return this.x5f_1;
};
protoOf($serializer_0).ex = function () {
  var tmp0_cached = Companion_getInstance_9().k5f_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_0;
function $serializer_getInstance_3() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function DynamicTemplateData_init_$Init$(seen0, range, rangeVersion, schemaVersion, templates, assetSource, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_3().x5f_1);
  }
  $this.e5f_1 = range;
  $this.f5f_1 = rangeVersion;
  $this.g5f_1 = schemaVersion;
  $this.h5f_1 = templates;
  if (0 === (seen0 & 16))
    $this.i5f_1 = null;
  else
    $this.i5f_1 = assetSource;
  return $this;
}
function DynamicTemplateData_init_$Create$(seen0, range, rangeVersion, schemaVersion, templates, assetSource, serializationConstructorMarker) {
  return DynamicTemplateData_init_$Init$(seen0, range, rangeVersion, schemaVersion, templates, assetSource, serializationConstructorMarker, objectCreate(protoOf(DynamicTemplateData)));
}
function DynamicTemplateData() {
}
protoOf(DynamicTemplateData).toString = function () {
  return 'DynamicTemplateData(range=' + this.e5f_1 + ', rangeVersion=' + this.f5f_1 + ', schemaVersion=' + this.g5f_1 + ', templates=' + toString(this.h5f_1) + ', assetSource=' + this.i5f_1 + ')';
};
protoOf(DynamicTemplateData).hashCode = function () {
  var result = getStringHashCode(this.e5f_1);
  result = imul(result, 31) + getStringHashCode(this.f5f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.g5f_1) | 0;
  result = imul(result, 31) + hashCode(this.h5f_1) | 0;
  result = imul(result, 31) + (this.i5f_1 == null ? 0 : getStringHashCode(this.i5f_1)) | 0;
  return result;
};
protoOf(DynamicTemplateData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DynamicTemplateData))
    return false;
  var tmp0_other_with_cast = other instanceof DynamicTemplateData ? other : THROW_CCE();
  if (!(this.e5f_1 === tmp0_other_with_cast.e5f_1))
    return false;
  if (!(this.f5f_1 === tmp0_other_with_cast.f5f_1))
    return false;
  if (!(this.g5f_1 === tmp0_other_with_cast.g5f_1))
    return false;
  if (!equals(this.h5f_1, tmp0_other_with_cast.h5f_1))
    return false;
  if (!(this.i5f_1 == tmp0_other_with_cast.i5f_1))
    return false;
  return true;
};
function Companion_3() {
  Companion_instance_13 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.p5f_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_2())];
}
protoOf(Companion_3).z18 = function () {
  return $serializer_getInstance_4();
};
var Companion_instance_13;
function Companion_getInstance_10() {
  if (Companion_instance_13 == null)
    new Companion_3();
  return Companion_instance_13;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.DynamicProductData', this, 4);
  tmp0_serialDesc.lw('range', false);
  tmp0_serialDesc.lw('schemaVersion', false);
  tmp0_serialDesc.lw('rangeVersion', false);
  tmp0_serialDesc.lw('products', false);
  this.z5f_1 = tmp0_serialDesc;
}
protoOf($serializer_1).a5g = function (encoder, value) {
  var tmp0_desc = this.z5f_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_10().p5f_1;
  tmp1_output.qq(tmp0_desc, 0, value.q5f_1);
  tmp1_output.qq(tmp0_desc, 1, value.r5f_1);
  tmp1_output.qq(tmp0_desc, 2, value.s5f_1);
  tmp1_output.sq(tmp0_desc, 3, tmp2_cached[3], value.t5f_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_1).ul = function (encoder, value) {
  return this.a5g(encoder, value instanceof DynamicProductData ? value : THROW_CCE());
};
protoOf($serializer_1).vl = function (decoder) {
  var tmp0_desc = this.z5f_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.bp(tmp0_desc);
  var tmp9_cached = Companion_getInstance_10().p5f_1;
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.np(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.np(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return DynamicProductData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_1).tl = function () {
  return this.z5f_1;
};
protoOf($serializer_1).ex = function () {
  var tmp0_cached = Companion_getInstance_10().p5f_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3]];
};
var $serializer_instance_1;
function $serializer_getInstance_4() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function DynamicProductData_init_$Init$(seen0, range, schemaVersion, rangeVersion, products, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_4().z5f_1);
  }
  $this.q5f_1 = range;
  $this.r5f_1 = schemaVersion;
  $this.s5f_1 = rangeVersion;
  $this.t5f_1 = products;
  return $this;
}
function DynamicProductData_init_$Create$(seen0, range, schemaVersion, rangeVersion, products, serializationConstructorMarker) {
  return DynamicProductData_init_$Init$(seen0, range, schemaVersion, rangeVersion, products, serializationConstructorMarker, objectCreate(protoOf(DynamicProductData)));
}
function DynamicProductData() {
}
protoOf(DynamicProductData).toString = function () {
  return 'DynamicProductData(range=' + this.q5f_1 + ', schemaVersion=' + this.r5f_1 + ', rangeVersion=' + this.s5f_1 + ', products=' + toString(this.t5f_1) + ')';
};
protoOf(DynamicProductData).hashCode = function () {
  var result = getStringHashCode(this.q5f_1);
  result = imul(result, 31) + getStringHashCode(this.r5f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.s5f_1) | 0;
  result = imul(result, 31) + hashCode(this.t5f_1) | 0;
  return result;
};
protoOf(DynamicProductData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DynamicProductData))
    return false;
  var tmp0_other_with_cast = other instanceof DynamicProductData ? other : THROW_CCE();
  if (!(this.q5f_1 === tmp0_other_with_cast.q5f_1))
    return false;
  if (!(this.r5f_1 === tmp0_other_with_cast.r5f_1))
    return false;
  if (!(this.s5f_1 === tmp0_other_with_cast.s5f_1))
    return false;
  if (!equals(this.t5f_1, tmp0_other_with_cast.t5f_1))
    return false;
  return true;
};
function Companion_4() {
  Companion_instance_14 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.w5f_1 = [null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().nb(), StringSerializer_getInstance())];
}
protoOf(Companion_4).z18 = function () {
  return $serializer_getInstance_5();
};
var Companion_instance_14;
function Companion_getInstance_11() {
  if (Companion_instance_14 == null)
    new Companion_4();
  return Companion_instance_14;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.ProductTemplate', this, 4);
  tmp0_serialDesc.lw('templateId', false);
  tmp0_serialDesc.lw('name', true);
  tmp0_serialDesc.lw('components', false);
  tmp0_serialDesc.lw('inherits', true);
  this.b5g_1 = tmp0_serialDesc;
}
protoOf($serializer_2).c5g = function (encoder, value) {
  var tmp0_desc = this.b5g_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_11().w5f_1;
  tmp1_output.qq(tmp0_desc, 0, value.templateId);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.name === '')) {
    tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.name);
  }
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance_12(), value.components);
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.inherits == null)) {
    tmp1_output.uq(tmp0_desc, 3, tmp2_cached[3], value.inherits);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_2).ul = function (encoder, value) {
  return this.c5g(encoder, value instanceof ProductTemplate ? value : THROW_CCE());
};
protoOf($serializer_2).vl = function (decoder) {
  var tmp0_desc = this.b5g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp9_input = decoder.bp(tmp0_desc);
  var tmp10_cached = Companion_getInstance_11().w5f_1;
  if (tmp9_input.rp()) {
    tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.np(tmp0_desc, 2, $serializer_getInstance_12(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.pp(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.np(tmp0_desc, 2, $serializer_getInstance_12(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.pp(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.cp(tmp0_desc);
  return ProductTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_2).tl = function () {
  return this.b5g_1;
};
protoOf($serializer_2).ex = function () {
  var tmp0_cached = Companion_getInstance_11().w5f_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), $serializer_getInstance_12(), get_nullable(tmp0_cached[3])];
};
var $serializer_instance_2;
function $serializer_getInstance_5() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function ProductTemplate_init_$Init$(seen0, templateId, name, components, inherits, serializationConstructorMarker, $this) {
  if (!(5 === (5 & seen0))) {
    throwMissingFieldException(seen0, 5, $serializer_getInstance_5().b5g_1);
  }
  $this.templateId = templateId;
  if (0 === (seen0 & 2))
    $this.name = '';
  else
    $this.name = name;
  $this.components = components;
  if (0 === (seen0 & 8))
    $this.inherits = null;
  else
    $this.inherits = inherits;
  $this.h5e_1 = 0;
  return $this;
}
function ProductTemplate_init_$Create$(seen0, templateId, name, components, inherits, serializationConstructorMarker) {
  return ProductTemplate_init_$Init$(seen0, templateId, name, components, inherits, serializationConstructorMarker, objectCreate(protoOf(ProductTemplate)));
}
function ProductTemplate(templateId, name, components, inherits) {
  Companion_getInstance_11();
  name = name === VOID ? '' : name;
  inherits = inherits === VOID ? null : inherits;
  this.templateId = templateId;
  this.name = name;
  this.components = components;
  this.inherits = inherits;
  this.h5e_1 = 0;
}
protoOf(ProductTemplate).a30 = function () {
  return this.templateId;
};
protoOf(ProductTemplate).v2 = function () {
  return this.name;
};
protoOf(ProductTemplate).l1u = function () {
  return this.components;
};
protoOf(ProductTemplate).d5g = function () {
  return this.inherits;
};
protoOf(ProductTemplate).e5g = function (templateData, overrideSize) {
  var tmp;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  var this_0 = this.components.connectors;
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  if (this_0 == null) {
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.collections.isEmpty' call
    tmp_0 = this_0.length === 0;
  }
  if (tmp_0) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    var tmp0_safe_receiver = this.components.connectors;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = overrideSize == null ? templateData.size : overrideSize;
      var tmp2_elvis_lhs = templateData.family;
      tmp_1 = getConnectorsForSize(tmp0_safe_receiver, tmp_2, templateData.comSize, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs, templateData.id);
    }
    var tmp3_elvis_lhs = tmp_1;
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = [];
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    tmp = tmp_3;
  }
  return tmp;
};
protoOf(ProductTemplate).getConnectors = function (templateData, overrideSize, $super) {
  overrideSize = overrideSize === VOID ? null : overrideSize;
  return this.e5g(templateData, overrideSize);
};
protoOf(ProductTemplate).getRelativeConnectorData = function (size) {
  var tmp0_safe_receiver = this.components.connectors;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.catalog.ProductTemplate.getRelativeConnectorData.<anonymous>' call
      if (element.isRelativeToBounds()) {
        destination.h(element);
      }
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var tmp0_iterator = tmp1_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.range.dynamic.catalog.ProductTemplate.getRelativeConnectorData.<anonymous>' call
      var tmp$ret$3 = item.createRelativeConnectorData(size);
      destination_0.h(tmp$ret$3);
    }
    tmp_0 = destination_0;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_1 = copyToArray(tmp2_safe_receiver);
  }
  return tmp_1;
};
protoOf(ProductTemplate).inherit = function (extended) {
  var components = this.components.inherit(extended.components);
  return new ProductTemplate(this.templateId, this.name, components, null);
};
protoOf(ProductTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ProductTemplate))
    THROW_CCE();
  if (!(this.templateId === other.templateId))
    return false;
  if (!(this.name == other.name))
    return false;
  return true;
};
protoOf(ProductTemplate).hashCode = function () {
  if (this.h5e_1 === 0) {
    var tmp = this;
    var tmp_0 = imul(31, getStringHashCode(this.templateId));
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.name;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    tmp.h5e_1 = tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  return this.h5e_1;
};
protoOf(ProductTemplate).tf = function () {
  return this.templateId;
};
protoOf(ProductTemplate).uf = function () {
  return this.name;
};
protoOf(ProductTemplate).m1m = function () {
  return this.components;
};
protoOf(ProductTemplate).n1m = function () {
  return this.inherits;
};
protoOf(ProductTemplate).f5g = function (templateId, name, components, inherits) {
  return new ProductTemplate(templateId, name, components, inherits);
};
protoOf(ProductTemplate).copy = function (templateId, name, components, inherits, $super) {
  templateId = templateId === VOID ? this.templateId : templateId;
  name = name === VOID ? this.name : name;
  components = components === VOID ? this.components : components;
  inherits = inherits === VOID ? this.inherits : inherits;
  return this.f5g(templateId, name, components, inherits);
};
protoOf(ProductTemplate).toString = function () {
  return 'ProductTemplate(templateId=' + this.templateId + ', name=' + this.name + ', components=' + this.components.toString() + ', inherits=' + toString(this.inherits) + ')';
};
function Companion_5() {
  Companion_instance_15 = this;
  this.g5g_1 = Companion_instance.j1o_1;
}
protoOf(Companion_5).j1y = function () {
  return this.g5g_1;
};
var Companion_instance_15;
function Companion_getInstance_12() {
  if (Companion_instance_15 == null)
    new Companion_5();
  return Companion_instance_15;
}
function get_ID() {
  return Companion_getInstance_12().g5g_1;
}
function MetaDataComponent(data) {
  Companion_getInstance_12();
  this.data = data;
  this.h5g_1 = this.id;
}
protoOf(MetaDataComponent).q52 = function () {
  return this.data;
};
protoOf(MetaDataComponent).p1s = function () {
  return this.h5g_1;
};
protoOf(MetaDataComponent).n1s = function () {
  return Companion_instance.j1o_1;
};
protoOf(MetaDataComponent).i5g = function () {
  return parseMeta(this.data);
};
protoOf(MetaDataComponent).eq = function (other) {
  return equals((other instanceof MetaDataComponent ? other : THROW_CCE()).data, this.data);
};
protoOf(MetaDataComponent).tf = function () {
  return this.data;
};
protoOf(MetaDataComponent).j5g = function (data) {
  return new MetaDataComponent(data);
};
protoOf(MetaDataComponent).copy = function (data, $super) {
  data = data === VOID ? this.data : data;
  return this.j5g(data);
};
protoOf(MetaDataComponent).toString = function () {
  return 'MetaDataComponent(data=' + toString(this.data) + ')';
};
protoOf(MetaDataComponent).hashCode = function () {
  return hashCode(this.data);
};
protoOf(MetaDataComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MetaDataComponent))
    return false;
  var tmp0_other_with_cast = other instanceof MetaDataComponent ? other : THROW_CCE();
  if (!equals(this.data, tmp0_other_with_cast.data))
    return false;
  return true;
};
function Companion_6() {
  Companion_instance_16 = this;
  this.id = Companion_instance.p1p_1;
}
protoOf(Companion_6).n1s = function () {
  return this.id;
};
var Companion_instance_16;
function Companion_getInstance_13() {
  if (Companion_instance_16 == null)
    new Companion_6();
  return Companion_instance_16;
}
function VisualLightSourceComponent(type, intensity, colorTemperature) {
  Companion_getInstance_13();
  type = type === VOID ? null : type;
  intensity = intensity === VOID ? null : intensity;
  colorTemperature = colorTemperature === VOID ? null : colorTemperature;
  this.type = type;
  this.intensity = intensity;
  this.colorTemperature = colorTemperature;
  this.k5g_1 = Companion_getInstance_13().id;
}
protoOf(VisualLightSourceComponent).w2a = function () {
  return this.type;
};
protoOf(VisualLightSourceComponent).l5g = function () {
  return this.intensity;
};
protoOf(VisualLightSourceComponent).m5g = function () {
  return this.colorTemperature;
};
protoOf(VisualLightSourceComponent).p1s = function () {
  return this.k5g_1;
};
protoOf(VisualLightSourceComponent).eq = function (other) {
  var o = other instanceof VisualLightSourceComponent ? other : THROW_CCE();
  return this.k5g_1 === o.k5g_1 && this.intensity == other.intensity && this.colorTemperature == o.colorTemperature;
};
function Companion_7() {
  Companion_instance_17 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.n5g_1 = [null, null, null, null, new ReferenceArraySerializer(getKClass(Part), $serializer_getInstance_8()), null, null, null, null, null];
}
protoOf(Companion_7).z18 = function () {
  return $serializer_getInstance_6();
};
var Companion_instance_17;
function Companion_getInstance_14() {
  if (Companion_instance_17 == null)
    new Companion_7();
  return Companion_instance_17;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.CatalogTemplateData', this, 10);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('size', false);
  tmp0_serialDesc.lw('comSize', false);
  tmp0_serialDesc.lw('family', true);
  tmp0_serialDesc.lw('parts', true);
  tmp0_serialDesc.lw('modelInfo', true);
  tmp0_serialDesc.lw('modelTransform', true);
  tmp0_serialDesc.lw('isExterior', true);
  tmp0_serialDesc.lw('isInterior', true);
  tmp0_serialDesc.lw('variant', true);
  this.o5g_1 = tmp0_serialDesc;
}
protoOf($serializer_3).p5g = function (encoder, value) {
  var tmp0_desc = this.o5g_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_14().n5g_1;
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance(), value.size);
  tmp1_output.sq(tmp0_desc, 2, $serializer_getInstance(), value.comSize);
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.family === '')) {
    tmp1_output.uq(tmp0_desc, 3, StringSerializer_getInstance(), value.family);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.parts == null)) {
    tmp1_output.uq(tmp0_desc, 4, tmp2_cached[4], value.parts);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !(value.modelInfo == null)) {
    tmp1_output.uq(tmp0_desc, 5, $serializer_getInstance_7(), value.modelInfo);
  }
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.modelTransform == null)) {
    tmp1_output.uq(tmp0_desc, 6, $serializer_getInstance_0(), value.modelTransform);
  }
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.isExterior === false)) {
    tmp1_output.iq(tmp0_desc, 7, value.isExterior);
  }
  if (tmp1_output.yq(tmp0_desc, 8) ? true : !(value.isInterior === false)) {
    tmp1_output.iq(tmp0_desc, 8, value.isInterior);
  }
  if (tmp1_output.yq(tmp0_desc, 9) ? true : !(value.variant == null)) {
    tmp1_output.uq(tmp0_desc, 9, StringSerializer_getInstance(), value.variant);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_3).ul = function (encoder, value) {
  return this.p5g(encoder, value instanceof CatalogTemplateData ? value : THROW_CCE());
};
protoOf($serializer_3).vl = function (decoder) {
  var tmp0_desc = this.o5g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = false;
  var tmp12_local8 = false;
  var tmp13_local9 = null;
  var tmp14_input = decoder.bp(tmp0_desc);
  var tmp15_cached = Companion_getInstance_14().n5g_1;
  if (tmp14_input.rp()) {
    tmp4_local0 = tmp14_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp14_input.np(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp14_input.np(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp14_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp14_input.pp(tmp0_desc, 4, tmp15_cached[4], tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp14_input.pp(tmp0_desc, 5, $serializer_getInstance_7(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp14_input.pp(tmp0_desc, 6, $serializer_getInstance_0(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp14_input.dp(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp14_input.dp(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp14_input.pp(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp14_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp14_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp14_input.np(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp14_input.np(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp14_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp14_input.pp(tmp0_desc, 4, tmp15_cached[4], tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp14_input.pp(tmp0_desc, 5, $serializer_getInstance_7(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp14_input.pp(tmp0_desc, 6, $serializer_getInstance_0(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp14_input.dp(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp14_input.dp(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp14_input.pp(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp14_input.cp(tmp0_desc);
  return CatalogTemplateData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
};
protoOf($serializer_3).tl = function () {
  return this.o5g_1;
};
protoOf($serializer_3).ex = function () {
  var tmp0_cached = Companion_getInstance_14().n5g_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[4]), get_nullable($serializer_getInstance_7()), get_nullable($serializer_getInstance_0()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_3;
function $serializer_getInstance_6() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function CatalogTemplateData_init_$Init$(seen0, id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_6().o5g_1);
  }
  $this.id = id;
  $this.size = size;
  $this.comSize = comSize;
  if (0 === (seen0 & 8))
    $this.family = '';
  else
    $this.family = family;
  if (0 === (seen0 & 16))
    $this.parts = null;
  else
    $this.parts = parts;
  if (0 === (seen0 & 32))
    $this.modelInfo = null;
  else
    $this.modelInfo = modelInfo;
  if (0 === (seen0 & 64))
    $this.modelTransform = null;
  else
    $this.modelTransform = modelTransform;
  if (0 === (seen0 & 128))
    $this.isExterior = false;
  else
    $this.isExterior = isExterior;
  if (0 === (seen0 & 256))
    $this.isInterior = false;
  else
    $this.isInterior = isInterior;
  if (0 === (seen0 & 512))
    $this.variant = null;
  else
    $this.variant = variant;
  return $this;
}
function CatalogTemplateData_init_$Create$(seen0, id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, serializationConstructorMarker) {
  return CatalogTemplateData_init_$Init$(seen0, id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, serializationConstructorMarker, objectCreate(protoOf(CatalogTemplateData)));
}
function CatalogTemplateData(id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant) {
  Companion_getInstance_14();
  family = family === VOID ? '' : family;
  parts = parts === VOID ? null : parts;
  modelInfo = modelInfo === VOID ? null : modelInfo;
  modelTransform = modelTransform === VOID ? null : modelTransform;
  isExterior = isExterior === VOID ? false : isExterior;
  isInterior = isInterior === VOID ? false : isInterior;
  variant = variant === VOID ? null : variant;
  this.id = id;
  this.size = size;
  this.comSize = comSize;
  this.family = family;
  this.parts = parts;
  this.modelInfo = modelInfo;
  this.modelTransform = modelTransform;
  this.isExterior = isExterior;
  this.isInterior = isInterior;
  this.variant = variant;
}
protoOf(CatalogTemplateData).n1s = function () {
  return this.id;
};
protoOf(CatalogTemplateData).o = function () {
  return this.size;
};
protoOf(CatalogTemplateData).b30 = function () {
  return this.comSize;
};
protoOf(CatalogTemplateData).c30 = function () {
  return this.family;
};
protoOf(CatalogTemplateData).o1s = function () {
  return this.parts;
};
protoOf(CatalogTemplateData).q5g = function (_set____db54di) {
  this.modelInfo = _set____db54di;
};
protoOf(CatalogTemplateData).r5g = function () {
  return this.modelInfo;
};
protoOf(CatalogTemplateData).s5g = function () {
  return this.modelTransform;
};
protoOf(CatalogTemplateData).t5g = function () {
  return this.isExterior;
};
protoOf(CatalogTemplateData).u5g = function () {
  return this.isInterior;
};
protoOf(CatalogTemplateData).k1m = function () {
  return this.variant;
};
protoOf(CatalogTemplateData).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof CatalogTemplateData))
    THROW_CCE();
  if (!(this.id === other.id))
    return false;
  return true;
};
protoOf(CatalogTemplateData).hashCode = function () {
  return getStringHashCode(this.id);
};
protoOf(CatalogTemplateData).tf = function () {
  return this.id;
};
protoOf(CatalogTemplateData).uf = function () {
  return this.size;
};
protoOf(CatalogTemplateData).m1m = function () {
  return this.comSize;
};
protoOf(CatalogTemplateData).n1m = function () {
  return this.family;
};
protoOf(CatalogTemplateData).o1m = function () {
  return this.parts;
};
protoOf(CatalogTemplateData).p1m = function () {
  return this.modelInfo;
};
protoOf(CatalogTemplateData).q1m = function () {
  return this.modelTransform;
};
protoOf(CatalogTemplateData).l2e = function () {
  return this.isExterior;
};
protoOf(CatalogTemplateData).m2e = function () {
  return this.isInterior;
};
protoOf(CatalogTemplateData).n2e = function () {
  return this.variant;
};
protoOf(CatalogTemplateData).v5g = function (id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant) {
  return new CatalogTemplateData(id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant);
};
protoOf(CatalogTemplateData).copy = function (id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, $super) {
  id = id === VOID ? this.id : id;
  size = size === VOID ? this.size : size;
  comSize = comSize === VOID ? this.comSize : comSize;
  family = family === VOID ? this.family : family;
  parts = parts === VOID ? this.parts : parts;
  modelInfo = modelInfo === VOID ? this.modelInfo : modelInfo;
  modelTransform = modelTransform === VOID ? this.modelTransform : modelTransform;
  isExterior = isExterior === VOID ? this.isExterior : isExterior;
  isInterior = isInterior === VOID ? this.isInterior : isInterior;
  variant = variant === VOID ? this.variant : variant;
  return this.v5g(id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant);
};
protoOf(CatalogTemplateData).toString = function () {
  return 'CatalogTemplateData(id=' + this.id + ', size=' + this.size.toString() + ', comSize=' + this.comSize.toString() + ', family=' + this.family + ', parts=' + toString(this.parts) + ', modelInfo=' + toString_0(this.modelInfo) + ', modelTransform=' + toString_0(this.modelTransform) + ', isExterior=' + this.isExterior + ', isInterior=' + this.isInterior + ', variant=' + this.variant + ')';
};
function Companion_8() {
}
protoOf(Companion_8).z18 = function () {
  return $serializer_getInstance_7();
};
var Companion_instance_18;
function Companion_getInstance_15() {
  return Companion_instance_18;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.ModelRenderInfo', this, 3);
  tmp0_serialDesc.lw('modelRootUrl', false);
  tmp0_serialDesc.lw('model', false);
  tmp0_serialDesc.lw('texture', false);
  this.w5g_1 = tmp0_serialDesc;
}
protoOf($serializer_4).x5g = function (encoder, value) {
  var tmp0_desc = this.w5g_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.uq(tmp0_desc, 0, StringSerializer_getInstance(), value.modelRootUrl);
  tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.model);
  tmp1_output.uq(tmp0_desc, 2, StringSerializer_getInstance(), value.texture);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_4).ul = function (encoder, value) {
  return this.x5g(encoder, value instanceof ModelRenderInfo ? value : THROW_CCE());
};
protoOf($serializer_4).vl = function (decoder) {
  var tmp0_desc = this.w5g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return ModelRenderInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_4).tl = function () {
  return this.w5g_1;
};
protoOf($serializer_4).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_4;
function $serializer_getInstance_7() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function ModelRenderInfo_init_$Init$(seen0, modelRootUrl, model, texture, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_7().w5g_1);
  }
  $this.modelRootUrl = modelRootUrl;
  $this.model = model;
  $this.texture = texture;
  return $this;
}
function ModelRenderInfo_init_$Create$(seen0, modelRootUrl, model, texture, serializationConstructorMarker) {
  return ModelRenderInfo_init_$Init$(seen0, modelRootUrl, model, texture, serializationConstructorMarker, objectCreate(protoOf(ModelRenderInfo)));
}
function ModelRenderInfo(modelRootUrl, model, texture) {
  this.modelRootUrl = modelRootUrl;
  this.model = model;
  this.texture = texture;
}
protoOf(ModelRenderInfo).s30 = function () {
  return this.modelRootUrl;
};
protoOf(ModelRenderInfo).t30 = function () {
  return this.model;
};
protoOf(ModelRenderInfo).u30 = function () {
  return this.texture;
};
protoOf(ModelRenderInfo).tf = function () {
  return this.modelRootUrl;
};
protoOf(ModelRenderInfo).uf = function () {
  return this.model;
};
protoOf(ModelRenderInfo).m1m = function () {
  return this.texture;
};
protoOf(ModelRenderInfo).w30 = function (modelRootUrl, model, texture) {
  return new ModelRenderInfo(modelRootUrl, model, texture);
};
protoOf(ModelRenderInfo).copy = function (modelRootUrl, model, texture, $super) {
  modelRootUrl = modelRootUrl === VOID ? this.modelRootUrl : modelRootUrl;
  model = model === VOID ? this.model : model;
  texture = texture === VOID ? this.texture : texture;
  return this.w30(modelRootUrl, model, texture);
};
protoOf(ModelRenderInfo).toString = function () {
  return 'ModelRenderInfo(modelRootUrl=' + this.modelRootUrl + ', model=' + this.model + ', texture=' + this.texture + ')';
};
protoOf(ModelRenderInfo).hashCode = function () {
  var result = this.modelRootUrl == null ? 0 : getStringHashCode(this.modelRootUrl);
  result = imul(result, 31) + (this.model == null ? 0 : getStringHashCode(this.model)) | 0;
  result = imul(result, 31) + (this.texture == null ? 0 : getStringHashCode(this.texture)) | 0;
  return result;
};
protoOf(ModelRenderInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ModelRenderInfo))
    return false;
  var tmp0_other_with_cast = other instanceof ModelRenderInfo ? other : THROW_CCE();
  if (!(this.modelRootUrl == tmp0_other_with_cast.modelRootUrl))
    return false;
  if (!(this.model == tmp0_other_with_cast.model))
    return false;
  if (!(this.texture == tmp0_other_with_cast.texture))
    return false;
  return true;
};
function Companion_9() {
}
protoOf(Companion_9).z18 = function () {
  return $serializer_getInstance_8();
};
var Companion_instance_19;
function Companion_getInstance_16() {
  return Companion_instance_19;
}
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.Part', this, 4);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('partKey', false);
  tmp0_serialDesc.lw('main', true);
  tmp0_serialDesc.lw('included', true);
  this.y5g_1 = tmp0_serialDesc;
}
protoOf($serializer_5).z5g = function (encoder, value) {
  var tmp0_desc = this.y5g_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.qq(tmp0_desc, 1, value.partKey);
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.main === false)) {
    tmp1_output.iq(tmp0_desc, 2, value.main);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.included === false)) {
    tmp1_output.iq(tmp0_desc, 3, value.included);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_5).ul = function (encoder, value) {
  return this.z5g(encoder, value instanceof Part ? value : THROW_CCE());
};
protoOf($serializer_5).vl = function (decoder) {
  var tmp0_desc = this.y5g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = false;
  var tmp7_local3 = false;
  var tmp8_input = decoder.bp(tmp0_desc);
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.dp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.dp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.dp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.dp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return Part_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_5).tl = function () {
  return this.y5g_1;
};
protoOf($serializer_5).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance_5;
function $serializer_getInstance_8() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function Part_init_$Init$(seen0, id, partKey, main, included, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_8().y5g_1);
  }
  $this.id = id;
  $this.partKey = partKey;
  if (0 === (seen0 & 4))
    $this.main = false;
  else
    $this.main = main;
  if (0 === (seen0 & 8))
    $this.included = false;
  else
    $this.included = included;
  return $this;
}
function Part_init_$Create$(seen0, id, partKey, main, included, serializationConstructorMarker) {
  return Part_init_$Init$(seen0, id, partKey, main, included, serializationConstructorMarker, objectCreate(protoOf(Part)));
}
function Part(id, partKey, main, included) {
  main = main === VOID ? false : main;
  included = included === VOID ? false : included;
  this.id = id;
  this.partKey = partKey;
  this.main = main;
  this.included = included;
}
protoOf(Part).n1s = function () {
  return this.id;
};
protoOf(Part).f1m = function () {
  return this.partKey;
};
protoOf(Part).a5h = function () {
  return this.main;
};
protoOf(Part).b5h = function () {
  return this.included;
};
protoOf(Part).tf = function () {
  return this.id;
};
protoOf(Part).uf = function () {
  return this.partKey;
};
protoOf(Part).m1m = function () {
  return this.main;
};
protoOf(Part).n1m = function () {
  return this.included;
};
protoOf(Part).c5h = function (id, partKey, main, included) {
  return new Part(id, partKey, main, included);
};
protoOf(Part).copy = function (id, partKey, main, included, $super) {
  id = id === VOID ? this.id : id;
  partKey = partKey === VOID ? this.partKey : partKey;
  main = main === VOID ? this.main : main;
  included = included === VOID ? this.included : included;
  return this.c5h(id, partKey, main, included);
};
protoOf(Part).toString = function () {
  return 'Part(id=' + this.id + ', partKey=' + this.partKey + ', main=' + this.main + ', included=' + this.included + ')';
};
protoOf(Part).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + getStringHashCode(this.partKey) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.main) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.included) | 0;
  return result;
};
protoOf(Part).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Part))
    return false;
  var tmp0_other_with_cast = other instanceof Part ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.partKey === tmp0_other_with_cast.partKey))
    return false;
  if (!(this.main === tmp0_other_with_cast.main))
    return false;
  if (!(this.included === tmp0_other_with_cast.included))
    return false;
  return true;
};
function Companion_10() {
  Companion_instance_20 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.d5h_1 = [null, null, null, null, null, null, null, null, null, null, null, new ReferenceArraySerializer(getKClass(Part), $serializer_getInstance_8()), new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance())];
}
protoOf(Companion_10).z18 = function () {
  return $serializer_getInstance_9();
};
var Companion_instance_20;
function Companion_getInstance_17() {
  if (Companion_instance_20 == null)
    new Companion_10();
  return Companion_instance_20;
}
function $serializer_6() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.ProductDataComponent', this, 13);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('range', false);
  tmp0_serialDesc.lw('description', true);
  tmp0_serialDesc.lw('dexfId', true);
  tmp0_serialDesc.lw('size', false);
  tmp0_serialDesc.lw('comSize', false);
  tmp0_serialDesc.lw('productGroup', false);
  tmp0_serialDesc.lw('autoAdaptGroup', true);
  tmp0_serialDesc.lw('type', true);
  tmp0_serialDesc.lw('typeCode', true);
  tmp0_serialDesc.lw('partsInPackage', true);
  tmp0_serialDesc.lw('parts', true);
  tmp0_serialDesc.lw('meta', true);
  this.e5h_1 = tmp0_serialDesc;
}
protoOf($serializer_6).f5h = function (encoder, value) {
  var tmp0_desc = this.e5h_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_17().d5h_1;
  tmp1_output.qq(tmp0_desc, 0, value.id);
  tmp1_output.qq(tmp0_desc, 1, value.range);
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.description == null)) {
    tmp1_output.uq(tmp0_desc, 2, StringSerializer_getInstance(), value.description);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.dexfId == null)) {
    tmp1_output.uq(tmp0_desc, 3, StringSerializer_getInstance(), value.dexfId);
  }
  tmp1_output.sq(tmp0_desc, 4, $serializer_getInstance(), value.size);
  tmp1_output.sq(tmp0_desc, 5, $serializer_getInstance(), value.comSize);
  tmp1_output.qq(tmp0_desc, 6, value.productGroup);
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.autoAdaptGroup == null)) {
    tmp1_output.uq(tmp0_desc, 7, StringSerializer_getInstance(), value.autoAdaptGroup);
  }
  if (tmp1_output.yq(tmp0_desc, 8) ? true : !(value.type === '')) {
    tmp1_output.qq(tmp0_desc, 8, value.type);
  }
  if (tmp1_output.yq(tmp0_desc, 9) ? true : !(value.typeCode == null)) {
    tmp1_output.uq(tmp0_desc, 9, IntSerializer_getInstance(), value.typeCode);
  }
  if (tmp1_output.yq(tmp0_desc, 10) ? true : !(value.partsInPackage === 1)) {
    tmp1_output.uq(tmp0_desc, 10, IntSerializer_getInstance(), value.partsInPackage);
  }
  if (tmp1_output.yq(tmp0_desc, 11) ? true : !(value.parts == null)) {
    tmp1_output.uq(tmp0_desc, 11, tmp2_cached[11], value.parts);
  }
  if (tmp1_output.yq(tmp0_desc, 12) ? true : !(value.meta == null)) {
    tmp1_output.uq(tmp0_desc, 12, tmp2_cached[12], value.meta);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_6).ul = function (encoder, value) {
  return this.f5h(encoder, value instanceof ProductDataComponent ? value : THROW_CCE());
};
protoOf($serializer_6).vl = function (decoder) {
  var tmp0_desc = this.e5h_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_local12 = null;
  var tmp17_input = decoder.bp(tmp0_desc);
  var tmp18_cached = Companion_getInstance_17().d5h_1;
  if (tmp17_input.rp()) {
    tmp4_local0 = tmp17_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp17_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp17_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp17_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp17_input.np(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp17_input.np(tmp0_desc, 5, $serializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp17_input.lp(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp17_input.pp(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp17_input.lp(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp17_input.pp(tmp0_desc, 9, IntSerializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp17_input.pp(tmp0_desc, 10, IntSerializer_getInstance(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp17_input.pp(tmp0_desc, 11, tmp18_cached[11], tmp15_local11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp17_input.pp(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp17_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp17_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp17_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp17_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp17_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp17_input.np(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp17_input.np(tmp0_desc, 5, $serializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp17_input.lp(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp17_input.pp(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp17_input.lp(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp17_input.pp(tmp0_desc, 9, IntSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp17_input.pp(tmp0_desc, 10, IntSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp17_input.pp(tmp0_desc, 11, tmp18_cached[11], tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp17_input.pp(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp17_input.cp(tmp0_desc);
  return ProductDataComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
};
protoOf($serializer_6).tl = function () {
  return this.e5h_1;
};
protoOf($serializer_6).ex = function () {
  var tmp0_cached = Companion_getInstance_17().d5h_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), $serializer_getInstance(), $serializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(tmp0_cached[11]), get_nullable(tmp0_cached[12])];
};
var $serializer_instance_6;
function $serializer_getInstance_9() {
  if ($serializer_instance_6 == null)
    new $serializer_6();
  return $serializer_instance_6;
}
function ProductDataComponent_init_$Init$(seen0, id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, serializationConstructorMarker, $this) {
  if (!(115 === (115 & seen0))) {
    throwMissingFieldException(seen0, 115, $serializer_getInstance_9().e5h_1);
  }
  $this.id = id;
  $this.range = range;
  if (0 === (seen0 & 4))
    $this.description = null;
  else
    $this.description = description;
  if (0 === (seen0 & 8))
    $this.dexfId = null;
  else
    $this.dexfId = dexfId;
  $this.size = size;
  $this.comSize = comSize;
  $this.productGroup = productGroup;
  if (0 === (seen0 & 128))
    $this.autoAdaptGroup = null;
  else
    $this.autoAdaptGroup = autoAdaptGroup;
  if (0 === (seen0 & 256))
    $this.type = '';
  else
    $this.type = type;
  if (0 === (seen0 & 512))
    $this.typeCode = null;
  else
    $this.typeCode = typeCode;
  if (0 === (seen0 & 1024))
    $this.partsInPackage = 1;
  else
    $this.partsInPackage = partsInPackage;
  if (0 === (seen0 & 2048))
    $this.parts = null;
  else
    $this.parts = parts;
  if (0 === (seen0 & 4096))
    $this.meta = null;
  else
    $this.meta = meta;
  return $this;
}
function ProductDataComponent_init_$Create$(seen0, id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, serializationConstructorMarker) {
  return ProductDataComponent_init_$Init$(seen0, id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, serializationConstructorMarker, objectCreate(protoOf(ProductDataComponent)));
}
function ProductDataComponent(id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts) {
  Companion_getInstance_17();
  description = description === VOID ? null : description;
  dexfId = dexfId === VOID ? null : dexfId;
  autoAdaptGroup = autoAdaptGroup === VOID ? null : autoAdaptGroup;
  type = type === VOID ? '' : type;
  typeCode = typeCode === VOID ? null : typeCode;
  partsInPackage = partsInPackage === VOID ? 1 : partsInPackage;
  parts = parts === VOID ? null : parts;
  this.id = id;
  this.range = range;
  this.description = description;
  this.dexfId = dexfId;
  this.size = size;
  this.comSize = comSize;
  this.productGroup = productGroup;
  this.autoAdaptGroup = autoAdaptGroup;
  this.type = type;
  this.typeCode = typeCode;
  this.partsInPackage = partsInPackage;
  this.parts = parts;
  this.meta = null;
}
protoOf(ProductDataComponent).n1s = function () {
  return this.id;
};
protoOf(ProductDataComponent).g5h = function () {
  return this.range;
};
protoOf(ProductDataComponent).h5h = function () {
  return this.description;
};
protoOf(ProductDataComponent).i5h = function () {
  return this.dexfId;
};
protoOf(ProductDataComponent).o = function () {
  return this.size;
};
protoOf(ProductDataComponent).b30 = function () {
  return this.comSize;
};
protoOf(ProductDataComponent).j5h = function () {
  return this.productGroup;
};
protoOf(ProductDataComponent).r5e = function () {
  return this.autoAdaptGroup;
};
protoOf(ProductDataComponent).w2a = function () {
  return this.type;
};
protoOf(ProductDataComponent).p5e = function () {
  return this.typeCode;
};
protoOf(ProductDataComponent).q5e = function () {
  return this.partsInPackage;
};
protoOf(ProductDataComponent).o1s = function () {
  return this.parts;
};
protoOf(ProductDataComponent).t5e = function (_set____db54di) {
  this.meta = _set____db54di;
};
protoOf(ProductDataComponent).u5e = function () {
  return this.meta;
};
protoOf(ProductDataComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ProductDataComponent))
    THROW_CCE();
  if (!(this.id === other.id))
    return false;
  return true;
};
protoOf(ProductDataComponent).hashCode = function () {
  return getStringHashCode(this.id);
};
protoOf(ProductDataComponent).tf = function () {
  return this.id;
};
protoOf(ProductDataComponent).uf = function () {
  return this.range;
};
protoOf(ProductDataComponent).m1m = function () {
  return this.description;
};
protoOf(ProductDataComponent).n1m = function () {
  return this.dexfId;
};
protoOf(ProductDataComponent).o1m = function () {
  return this.size;
};
protoOf(ProductDataComponent).p1m = function () {
  return this.comSize;
};
protoOf(ProductDataComponent).q1m = function () {
  return this.productGroup;
};
protoOf(ProductDataComponent).l2e = function () {
  return this.autoAdaptGroup;
};
protoOf(ProductDataComponent).m2e = function () {
  return this.type;
};
protoOf(ProductDataComponent).n2e = function () {
  return this.typeCode;
};
protoOf(ProductDataComponent).o2e = function () {
  return this.partsInPackage;
};
protoOf(ProductDataComponent).p2e = function () {
  return this.parts;
};
protoOf(ProductDataComponent).k5h = function (id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts) {
  return new ProductDataComponent(id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts);
};
protoOf(ProductDataComponent).copy = function (id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, $super) {
  id = id === VOID ? this.id : id;
  range = range === VOID ? this.range : range;
  description = description === VOID ? this.description : description;
  dexfId = dexfId === VOID ? this.dexfId : dexfId;
  size = size === VOID ? this.size : size;
  comSize = comSize === VOID ? this.comSize : comSize;
  productGroup = productGroup === VOID ? this.productGroup : productGroup;
  autoAdaptGroup = autoAdaptGroup === VOID ? this.autoAdaptGroup : autoAdaptGroup;
  type = type === VOID ? this.type : type;
  typeCode = typeCode === VOID ? this.typeCode : typeCode;
  partsInPackage = partsInPackage === VOID ? this.partsInPackage : partsInPackage;
  parts = parts === VOID ? this.parts : parts;
  return this.k5h(id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts);
};
protoOf(ProductDataComponent).toString = function () {
  return 'ProductDataComponent(id=' + this.id + ', range=' + this.range + ', description=' + this.description + ', dexfId=' + this.dexfId + ', size=' + this.size.toString() + ', comSize=' + this.comSize.toString() + ', productGroup=' + this.productGroup + ', autoAdaptGroup=' + this.autoAdaptGroup + ', type=' + this.type + ', typeCode=' + this.typeCode + ', partsInPackage=' + this.partsInPackage + ', parts=' + toString(this.parts) + ')';
};
function TemplateEditorConnectorData(connectorKey, style, selected, visible, active, showActivationDistance, showTransform, connector) {
  this.l5h_1 = connectorKey;
  this.m5h_1 = style;
  this.n5h_1 = selected;
  this.o5h_1 = visible;
  this.p5h_1 = active;
  this.q5h_1 = showActivationDistance;
  this.r5h_1 = showTransform;
  this.connector = connector;
}
protoOf(TemplateEditorConnectorData).w2g = function () {
  return this.l5h_1;
};
protoOf(TemplateEditorConnectorData).g53 = function () {
  return this.m5h_1;
};
protoOf(TemplateEditorConnectorData).h53 = function () {
  return this.n5h_1;
};
protoOf(TemplateEditorConnectorData).i53 = function () {
  return this.o5h_1;
};
protoOf(TemplateEditorConnectorData).j53 = function () {
  return this.p5h_1;
};
protoOf(TemplateEditorConnectorData).s5h = function (_set____db54di) {
  this.q5h_1 = _set____db54di;
};
protoOf(TemplateEditorConnectorData).k53 = function () {
  return this.q5h_1;
};
protoOf(TemplateEditorConnectorData).t5h = function (_set____db54di) {
  this.r5h_1 = _set____db54di;
};
protoOf(TemplateEditorConnectorData).l53 = function () {
  return this.r5h_1;
};
protoOf(TemplateEditorConnectorData).u5h = function (_set____db54di) {
  this.connector = _set____db54di;
};
protoOf(TemplateEditorConnectorData).t1m = function () {
  return this.connector;
};
function assemblyComponents($this) {
  var tmp0_safe_receiver = $this.w5h_1.parts;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toMutableList(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicAssembly.assemblyComponents.<anonymous>' call
    var tmp0_safe_receiver_0 = $this.x5h_1.components.assembly;
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.children;
    var tmp_0;
    if (tmp1_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicAssembly.assemblyComponents.<anonymous>.<anonymous>' call
      tmp_0 = Companion_getInstance_21().mapGeneratorPartsToTemplateChildren($this.y5h_1, tmp1_safe_receiver, tmp1_safe_receiver_0, $this.w5h_1.size);
    }
    tmp = tmp_0;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$4 = [];
    tmp_1 = new Pair(tmp$ret$4, emptyMap());
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var _destruct__k2r9zo = tmp_1;
  var assemblyParts = _destruct__k2r9zo.tf();
  var partsMap = _destruct__k2r9zo.uf();
  return listOf([new AssemblyStructureComponent(assemblyParts), AssemblyPartsComponent_init_$Create$(partsMap)]);
}
function DynamicAssembly(product, templateData, template, catalog) {
  DynamicComponentBuilder.call(this);
  this.v5h_1 = product;
  this.w5h_1 = templateData;
  this.x5h_1 = template;
  this.y5h_1 = catalog;
  var tmp = this;
  var tmp0_elvis_lhs = this.w5h_1.family;
  tmp.z5h_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  var tmp_0 = this;
  var tmp0_elvis_lhs_0 = this.x5h_1.name;
  tmp_0.a5i_1 = tmp0_elvis_lhs_0 == null ? this.x5h_1.templateId : tmp0_elvis_lhs_0;
  this.b5i_1 = null;
}
protoOf(DynamicAssembly).d5i = function () {
  return this.v5h_1;
};
protoOf(DynamicAssembly).e5i = function () {
  return this.w5h_1;
};
protoOf(DynamicAssembly).o5e = function () {
  return this.x5h_1;
};
protoOf(DynamicAssembly).f5i = function () {
  return this.y5h_1;
};
protoOf(DynamicAssembly).c30 = function () {
  return this.z5h_1;
};
protoOf(DynamicAssembly).v2 = function () {
  return this.a5i_1;
};
protoOf(DynamicAssembly).r5g = function () {
  return this.b5i_1;
};
protoOf(DynamicAssembly).g5i = function () {
  return null;
};
protoOf(DynamicAssembly).h5i = function () {
  return null;
};
protoOf(DynamicAssembly).i5i = function () {
  return this.x5h_1.getConnectors(this.w5h_1);
};
protoOf(DynamicAssembly).v5f = function () {
  var components = plus(assemblyComponents(this), this.j5i());
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(components);
  return new ProductSpecification(tmp$ret$0);
};
function createModelInfoComponent($this, modelInfo) {
  return new ModelInfoComponent(modelInfo.modelRootUrl, modelInfo.model, '');
}
function descriptiveName($this) {
  if (!($this.e5i().comSize.b2y_1 === 0.0) || !($this.e5i().comSize.c2y_1 === 0.0) || !($this.e5i().comSize.d2y_1 === 0.0))
    return $this.d5i().id + ' ' + $this.e5i().comSize.b2y_1 + 'x' + $this.e5i().comSize.c2y_1 + 'x' + $this.e5i().comSize.d2y_1;
  return $this.c30() + ' ' + $this.v2();
}
function relativeConnectors($this, size) {
  var relativeConnectors = $this.o5e().getRelativeConnectorData(size);
  var tmp;
  if (!(relativeConnectors == null)) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    tmp = !(relativeConnectors.length === 0);
  } else {
    tmp = false;
  }
  if (tmp) {
    return new RelativeConnectorsComponent(relativeConnectors);
  }
  return null;
}
function Companion_11() {
}
var Companion_instance_21;
function Companion_getInstance_18() {
  return Companion_instance_21;
}
function sam$kotlin_Comparator$0(function_0) {
  this.k5i_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
  return this.k5i_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0).s3 = function () {
  return this.k5i_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.s3());
};
function DynamicComponentBuilder$componentsFromTemplate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
  var tmp0_safe_receiver = b.autoAdaptGroup;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.priority;
  // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
  var tmp0_safe_receiver_0 = a.autoAdaptGroup;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.priority;
  return compareValues(tmp, tmp$ret$1);
}
function DynamicComponentBuilder() {
}
protoOf(DynamicComponentBuilder).j5i = function () {
  // Inline function 'kotlin.collections.mutableListOf' call
  var components = ArrayList_init_$Create$_0();
  components.h(new DisplayNameComponent(descriptiveName(this)));
  components.h(new ConnectionRootComponent());
  components.h(new TemplateDataComponent(this.e5i().id, new Vector(this.e5i().size.b2y_1, this.e5i().size.c2y_1, this.e5i().size.d2y_1), new Vector(this.e5i().comSize.b2y_1, this.e5i().comSize.c2y_1, this.e5i().comSize.d2y_1), this.e5i().family, this.e5i().variant));
  if (this.o5e().components.draggable === true) {
    components.h(new DraggableComponent());
  }
  if (this.o5e().components.alwaysHangDown === true) {
    components.h(AlwaysHangDownComponent_instance);
  }
  if (this.o5e().components.serializeEntity === false) {
    components.h(new UnserializableEntityComponent());
  }
  if (this.o5e().components.selectable === true) {
    components.h(new SelectableComponent());
  }
  if (this.o5e().components.outlineable === true) {
    components.h(new OutlineableComponent());
  }
  var conns = this.i5i();
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  if (conns == null) {
    tmp = true;
  } else {
    // Inline function 'kotlin.collections.isEmpty' call
    tmp = conns.length === 0;
  }
  if (!tmp) {
    components.h(new ConnectorsComponent(conns));
  }
  var tmp0_safe_receiver = this.g5i();
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new ColliderShapeComponent(tmp0_safe_receiver.rf_1, tmp0_safe_receiver.sf_1));
    tmp_0 = tmp0_safe_receiver.rf_1;
  }
  var collider = tmp_0;
  var tmp1_safe_receiver = this.o5e().components.recommendedInitialPositionFromFloor;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new RecommendedInitialPositionFromFloorComponent(tmp1_safe_receiver));
  }
  var tmp2_safe_receiver = this.o5e().components.functionalMargin;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new FunctionalMarginShapeComponent(tmp2_safe_receiver.toMargin()));
  }
  var tmp3_safe_receiver = this.h5i();
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new FunctionalZonesLocalComponent(tmp3_safe_receiver));
  }
  var tmp4_safe_receiver = this.o5e().components.placementZoneByHeight;
  if (tmp4_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new PlacementZoneByHeightComponent(tmp4_safe_receiver.minY, tmp4_safe_receiver.maxY));
  }
  var tmp5_safe_receiver = relativeConnectors(this, this.e5i().size);
  if (tmp5_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(tmp5_safe_receiver);
  }
  var tmp6_safe_receiver = this.o5e().components.autoAdaptHost;
  if (tmp6_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    var tmp0_safe_receiver_0 = tmp6_safe_receiver.hostZone;
    var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.getPolyhedronForSize(this.e5i().size);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver_0 = this.g5i();
      tmp_1 = tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.rf_1;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var hostZone = tmp_1;
    var tmp_2;
    if (hostZone == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
      components.h(new AutoAdaptHostComponent(hostZone));
      tmp_2 = hostZone;
    }
  }
  var tmp7_safe_receiver = this.r5g();
  if (tmp7_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    var tmp0_safe_receiver_1 = tmp7_safe_receiver.model;
    var tmp_3;
    if (tmp0_safe_receiver_1 == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.text.isNotBlank' call
      tmp_3 = !isBlank(tmp0_safe_receiver_1);
    }
    if (tmp_3 === true) {
      components.h(createModelInfoComponent(Companion_instance_21, tmp7_safe_receiver));
    }
    var tmp1_safe_receiver_0 = this.e5i().modelTransform;
    var tmp_4;
    if (tmp1_safe_receiver_0 == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
      tmp_4 = components.h(new ModelTransformComponent(tmp1_safe_receiver_0));
    }
  }
  var tmp8_safe_receiver = this.o5e().components.allowedDoorPairs;
  if (tmp8_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp8_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp8_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
      var tmp_5;
      if (element.length === 2) {
        var tmp_6;
        if (element[0] === 0) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_6 = [element[1]];
        } else if (element[1] === 0) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_6 = [element[0]];
        } else {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_6 = [element[0], element[1]];
        }
        tmp_5 = tmp_6;
      } else {
        tmp_5 = null;
      }
      var tmp0_safe_receiver_2 = tmp_5;
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver_2);
      }
    }
    var doorPairs = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$36 = copyToArray(doorPairs);
    components.h(new AllowedDoorPairsComponent(tmp$ret$36));
  }
  var tmp9_safe_receiver = this.d5i().autoAdaptGroup;
  if (tmp9_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.f5i().productDTOs();
    var destination_0 = ArrayList_init_$Create$_0();
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_3 = element_0.autoAdaptGroup;
      if ((tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.key) === tmp9_safe_receiver.key) {
        destination_0.h(element_0);
      }
    }
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_7 = DynamicComponentBuilder$componentsFromTemplate$lambda;
    var tmp$ret$41 = new sam$kotlin_Comparator$0(tmp_7);
    var this_1 = sortedWith(destination_0, tmp$ret$41);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
      var tmp$ret$43 = item.id;
      destination_1.h(tmp$ret$43);
    }
    var variants = copyToArray(destination_1);
    components.h(new AutoAdaptGuestComponent(variants, tmp9_safe_receiver.key));
  }
  var tmp10_safe_receiver = this.o5e().components.communicationSize;
  var tmp_8;
  if (tmp10_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new CommunicationSizeComponent(tmp10_safe_receiver));
    tmp_8 = tmp10_safe_receiver;
  }
  if (tmp_8 == null)
    components.h(new CommunicationSizeComponent(this.e5i().comSize));
  if (this.o5e().components.leg === true) {
    components.h(LegComponent_getInstance());
  }
  if (this.o5e().components.frame === true) {
    components.h(FrameComponent_getInstance());
  }
  if (this.o5e().components.door === true) {
    components.h(new DoorComponent());
  }
  if (this.o5e().components.doorFront === true) {
    components.h(DoorFrontComponent_getInstance());
  }
  if (this.o5e().components.handle === true) {
    components.h(HandleComponent_getInstance());
  }
  if (this.o5e().components.drawer === true) {
    components.h(DrawerComponent_getInstance());
  }
  var tmp12_safe_receiver = this.o5e().components.light;
  if (tmp12_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new LightComponent(tmp12_safe_receiver.type));
  }
  var tmp13_safe_receiver = this.o5e().components.visualLightSource;
  if (tmp13_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    components.h(new VisualLightSourceComponent(tmp13_safe_receiver.type, tmp13_safe_receiver.intensity, tmp13_safe_receiver.colorTemperature));
  }
  var tmp14_elvis_lhs = this.o5e().components.meta;
  var tmp_9 = tmp14_elvis_lhs == null ? emptyMap() : tmp14_elvis_lhs;
  var tmp15_elvis_lhs = this.d5i().meta;
  var mergedMeta = plus_0(tmp_9, tmp15_elvis_lhs == null ? emptyMap() : tmp15_elvis_lhs);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!mergedMeta.r()) {
    components.h(new MetaDataComponent(mergedMeta));
  }
  var tmp16_elvis_lhs = this.o5e().components.propping;
  if (tmp16_elvis_lhs == null ? false : tmp16_elvis_lhs) {
    components.h(new ProppingComponent());
  }
  var tmp17_safe_receiver = this.o5e().components.dragSurfaces;
  if (tmp17_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    var dragSurfaces = tmp17_safe_receiver.generateDragSurface(this.e5i().size, collider);
    var tmp_10;
    if (dragSurfaces == null) {
      tmp_10 = null;
    } else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
      components.h(new DragSurfacesComponent(dragSurfaces, false));
      tmp_10 = dragSurfaces;
    }
  }
  var tmp18_safe_receiver = this.o5e().components.dragProjectionPoint;
  if (tmp18_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    var point = tmp18_safe_receiver.applyToBox(Companion_getInstance_1().fromSize$default(this.e5i().size.vector)).position;
    components.h(new DragProjectionPointComponent(point));
  }
  var tmp19_safe_receiver = this.o5e().components.productStructure;
  if (tmp19_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
    var sizeAABB = Companion_getInstance_1().fromSize$default(this.e5i().size.vector);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_2 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_1 = 0;
    var last_1 = tmp19_safe_receiver.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = tmp19_safe_receiver[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$63;
      $l$block_0: {
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_4 = this.d5i().template.parts;
        var tmp_11;
        if (tmp0_safe_receiver_4 == null) {
          tmp_11 = null;
        } else {
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$61;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_2 = 0;
            var last_2 = tmp0_safe_receiver_4.length;
            while (inductionVariable_2 < last_2) {
              var element_2 = tmp0_safe_receiver_4[inductionVariable_2];
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>.<anonymous>' call
              if (element_2.partKey === element_1.partKey) {
                tmp$ret$61 = element_2;
                break $l$block;
              }
            }
            tmp$ret$61 = null;
          }
          tmp_11 = tmp$ret$61;
        }
        var tmp1_safe_receiver_1 = tmp_11;
        var tmp2_elvis_lhs = tmp1_safe_receiver_1 == null ? null : tmp1_safe_receiver_1.id;
        var tmp_12;
        if (tmp2_elvis_lhs == null) {
          tmp$ret$63 = null;
          break $l$block_0;
        } else {
          tmp_12 = tmp2_elvis_lhs;
        }
        var productRef = tmp_12;
        var tmp3_safe_receiver_0 = element_1.snap;
        var tmp_13;
        if (tmp3_safe_receiver_0 == null) {
          tmp_13 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>.<anonymous>' call
          tmp_13 = new ProductStructureConnection(tmp3_safe_receiver_0.offeringPartKey, tmp3_safe_receiver_0.demandingConnector, tmp3_safe_receiver_0.offeringConnector);
        }
        tmp$ret$63 = new ProductStructureItem(element_1.partKey, productRef, tmp_13, element_1.transform.applyToBox(sizeAABB));
      }
      var tmp0_safe_receiver_5 = tmp$ret$63;
      if (tmp0_safe_receiver_5 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_2.h(tmp0_safe_receiver_5);
      }
    }
    var tmp$ret$69 = copyToArray(destination_2);
    components.h(new ProductStructureComponent(tmp$ret$69));
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(components);
};
function Companion_12() {
  this.l5i_1 = 'DynamicShape';
}
var Companion_instance_22;
function Companion_getInstance_19() {
  return Companion_instance_22;
}
function DynamicShape(product, templateData, modelInfo, template, catalog) {
  DynamicComponentBuilder.call(this);
  this.m5i_1 = product;
  this.n5i_1 = templateData;
  this.o5i_1 = modelInfo;
  this.p5i_1 = template;
  this.q5i_1 = catalog;
  var tmp = this;
  var tmp0_elvis_lhs = this.n5i_1.family;
  tmp.r5i_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  var tmp_0 = this;
  var tmp0_elvis_lhs_0 = this.p5i_1.name;
  tmp_0.s5i_1 = tmp0_elvis_lhs_0 == null ? this.p5i_1.templateId : tmp0_elvis_lhs_0;
}
protoOf(DynamicShape).d5i = function () {
  return this.m5i_1;
};
protoOf(DynamicShape).e5i = function () {
  return this.n5i_1;
};
protoOf(DynamicShape).r5g = function () {
  return this.o5i_1;
};
protoOf(DynamicShape).o5e = function () {
  return this.p5i_1;
};
protoOf(DynamicShape).f5i = function () {
  return this.q5i_1;
};
protoOf(DynamicShape).c30 = function () {
  return this.r5i_1;
};
protoOf(DynamicShape).v2 = function () {
  return this.s5i_1;
};
protoOf(DynamicShape).g5i = function () {
  var tmp0_safe_receiver = this.p5i_1.components.bounds;
  return tmp0_safe_receiver == null ? null : getPolyhedronForSize(tmp0_safe_receiver, this.n5i_1.size);
};
protoOf(DynamicShape).h5i = function () {
  var tmp0_safe_receiver = this.p5i_1.components.functionalZones;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var item = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.shape.DynamicShape.functionalZones.<anonymous>' call
      var tmp$ret$0 = new FunctionalZone(item.id, item.layer, item.getPolyhedronForSize(this.n5i_1.size));
      destination.h(tmp$ret$0);
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp1_safe_receiver);
  }
  return tmp_0;
};
protoOf(DynamicShape).i5i = function () {
  return this.p5i_1.getConnectors(this.n5i_1);
};
protoOf(DynamicShape).v5f = function () {
  return new ProductSpecification(this.j5i());
};
protoOf(DynamicShape).toString = function () {
  return 'DynamicShape(product=' + this.m5i_1.toString() + ', templateData=' + this.n5i_1.toString() + ', modelInfo=' + toString_0(this.o5i_1) + ', template=' + this.p5i_1.toString() + ', catalog=' + this.q5i_1.toString() + ')';
};
protoOf(DynamicShape).hashCode = function () {
  var result = this.m5i_1.hashCode();
  result = imul(result, 31) + this.n5i_1.hashCode() | 0;
  result = imul(result, 31) + (this.o5i_1 == null ? 0 : this.o5i_1.hashCode()) | 0;
  result = imul(result, 31) + this.p5i_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.q5i_1) | 0;
  return result;
};
protoOf(DynamicShape).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DynamicShape))
    return false;
  var tmp0_other_with_cast = other instanceof DynamicShape ? other : THROW_CCE();
  if (!this.m5i_1.equals(tmp0_other_with_cast.m5i_1))
    return false;
  if (!this.n5i_1.equals(tmp0_other_with_cast.n5i_1))
    return false;
  if (!equals(this.o5i_1, tmp0_other_with_cast.o5i_1))
    return false;
  if (!this.p5i_1.equals(tmp0_other_with_cast.p5i_1))
    return false;
  if (!equals(this.q5i_1, tmp0_other_with_cast.q5i_1))
    return false;
  return true;
};
function extractHash($this) {
  var tmp0_safe_receiver = $this.templateId;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
  var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  result = imul(31, result) + getStringHashCode($this.partKey) | 0;
  return result;
}
function Companion_13() {
  Companion_instance_23 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.u5i_1 = [null, null, null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().lb(), DoubleSerializer_getInstance()), null, null, null];
}
protoOf(Companion_13).z18 = function () {
  return $serializer_getInstance_10();
};
var Companion_instance_23;
function Companion_getInstance_20() {
  if (Companion_instance_23 == null)
    new Companion_13();
  return Companion_instance_23;
}
function $serializer_7() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.AssemblyChild', this, 9);
  tmp0_serialDesc.lw('templateId', true);
  tmp0_serialDesc.lw('partKey', false);
  tmp0_serialDesc.lw('connector', true);
  tmp0_serialDesc.lw('connectorOnHost', true);
  tmp0_serialDesc.lw('position', true);
  tmp0_serialDesc.lw('transform', true);
  tmp0_serialDesc.lw('components', true);
  tmp0_serialDesc.lw('children', true);
  tmp0_serialDesc.lw('locked', true);
  this.v5i_1 = tmp0_serialDesc;
}
protoOf($serializer_7).w5i = function (encoder, value) {
  var tmp0_desc = this.v5i_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_20().u5i_1;
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.templateId === '')) {
    tmp1_output.uq(tmp0_desc, 0, StringSerializer_getInstance(), value.templateId);
  }
  tmp1_output.qq(tmp0_desc, 1, value.partKey);
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.connector == null)) {
    tmp1_output.uq(tmp0_desc, 2, StringSerializer_getInstance(), value.connector);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.connectorOnHost == null)) {
    tmp1_output.uq(tmp0_desc, 3, StringSerializer_getInstance(), value.connectorOnHost);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.position == null)) {
    tmp1_output.uq(tmp0_desc, 4, PositionTemplateSerializer_getInstance(), value.position);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !(value.transform == null)) {
    tmp1_output.uq(tmp0_desc, 5, tmp2_cached[5], value.transform);
  }
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.components == null)) {
    tmp1_output.uq(tmp0_desc, 6, $serializer_getInstance_12(), value.components);
  }
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.children == null)) {
    tmp1_output.uq(tmp0_desc, 7, new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_10()), value.children);
  }
  if (tmp1_output.yq(tmp0_desc, 8) ? true : !(value.locked === true)) {
    tmp1_output.uq(tmp0_desc, 8, BooleanSerializer_getInstance(), value.locked);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_7).ul = function (encoder, value) {
  return this.w5i(encoder, value instanceof AssemblyChild ? value : THROW_CCE());
};
protoOf($serializer_7).vl = function (decoder) {
  var tmp0_desc = this.v5i_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp14_input = decoder.bp(tmp0_desc);
  var tmp15_cached = Companion_getInstance_20().u5i_1;
  if (tmp14_input.rp()) {
    tmp4_local0 = tmp14_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp14_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp14_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp14_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp14_input.pp(tmp0_desc, 4, PositionTemplateSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp14_input.pp(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp14_input.pp(tmp0_desc, 6, $serializer_getInstance_12(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp14_input.pp(tmp0_desc, 7, new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_10()), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp14_input.pp(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp14_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp14_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp14_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp14_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp14_input.pp(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp14_input.pp(tmp0_desc, 4, PositionTemplateSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp14_input.pp(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp14_input.pp(tmp0_desc, 6, $serializer_getInstance_12(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp14_input.pp(tmp0_desc, 7, new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_10()), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp14_input.pp(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp14_input.cp(tmp0_desc);
  return AssemblyChild_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
};
protoOf($serializer_7).tl = function () {
  return this.v5i_1;
};
protoOf($serializer_7).ex = function () {
  var tmp0_cached = Companion_getInstance_20().u5i_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(PositionTemplateSerializer_getInstance()), get_nullable(tmp0_cached[5]), get_nullable($serializer_getInstance_12()), get_nullable(new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_10())), get_nullable(BooleanSerializer_getInstance())];
};
var $serializer_instance_7;
function $serializer_getInstance_10() {
  if ($serializer_instance_7 == null)
    new $serializer_7();
  return $serializer_instance_7;
}
function AssemblyChild_init_$Init$(seen0, templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_10().v5i_1);
  }
  if (0 === (seen0 & 1))
    $this.templateId = '';
  else
    $this.templateId = templateId;
  $this.partKey = partKey;
  if (0 === (seen0 & 4))
    $this.connector = null;
  else
    $this.connector = connector;
  if (0 === (seen0 & 8))
    $this.connectorOnHost = null;
  else
    $this.connectorOnHost = connectorOnHost;
  if (0 === (seen0 & 16))
    $this.position = null;
  else
    $this.position = position;
  if (0 === (seen0 & 32))
    $this.transform = null;
  else
    $this.transform = transform;
  if (0 === (seen0 & 64))
    $this.components = null;
  else
    $this.components = components;
  if (0 === (seen0 & 128))
    $this.children = null;
  else
    $this.children = children;
  if (0 === (seen0 & 256))
    $this.locked = true;
  else
    $this.locked = locked;
  $this.t5i_1 = extractHash($this);
  return $this;
}
function AssemblyChild_init_$Create$(seen0, templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, serializationConstructorMarker) {
  return AssemblyChild_init_$Init$(seen0, templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, serializationConstructorMarker, objectCreate(protoOf(AssemblyChild)));
}
function AssemblyChild(templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked) {
  Companion_getInstance_20();
  templateId = templateId === VOID ? '' : templateId;
  connector = connector === VOID ? null : connector;
  connectorOnHost = connectorOnHost === VOID ? null : connectorOnHost;
  position = position === VOID ? null : position;
  transform = transform === VOID ? null : transform;
  components = components === VOID ? null : components;
  children = children === VOID ? null : children;
  locked = locked === VOID ? true : locked;
  this.templateId = templateId;
  this.partKey = partKey;
  this.connector = connector;
  this.connectorOnHost = connectorOnHost;
  this.position = position;
  this.transform = transform;
  this.components = components;
  this.children = children;
  this.locked = locked;
  this.t5i_1 = extractHash(this);
}
protoOf(AssemblyChild).a30 = function () {
  return this.templateId;
};
protoOf(AssemblyChild).f1m = function () {
  return this.partKey;
};
protoOf(AssemblyChild).t1m = function () {
  return this.connector;
};
protoOf(AssemblyChild).s1m = function () {
  return this.connectorOnHost;
};
protoOf(AssemblyChild).f2w = function () {
  return this.position;
};
protoOf(AssemblyChild).z2a = function () {
  return this.transform;
};
protoOf(AssemblyChild).l1u = function () {
  return this.components;
};
protoOf(AssemblyChild).i1m = function () {
  return this.children;
};
protoOf(AssemblyChild).j1m = function () {
  return this.locked;
};
protoOf(AssemblyChild).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof AssemblyChild))
    THROW_CCE();
  if (!(this.templateId == other.templateId))
    return false;
  if (!(this.partKey === other.partKey))
    return false;
  return true;
};
protoOf(AssemblyChild).hashCode = function () {
  return this.t5i_1;
};
protoOf(AssemblyChild).tf = function () {
  return this.templateId;
};
protoOf(AssemblyChild).uf = function () {
  return this.partKey;
};
protoOf(AssemblyChild).m1m = function () {
  return this.connector;
};
protoOf(AssemblyChild).n1m = function () {
  return this.connectorOnHost;
};
protoOf(AssemblyChild).o1m = function () {
  return this.position;
};
protoOf(AssemblyChild).p1m = function () {
  return this.transform;
};
protoOf(AssemblyChild).q1m = function () {
  return this.components;
};
protoOf(AssemblyChild).l2e = function () {
  return this.children;
};
protoOf(AssemblyChild).m2e = function () {
  return this.locked;
};
protoOf(AssemblyChild).x5i = function (templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked) {
  return new AssemblyChild(templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked);
};
protoOf(AssemblyChild).copy = function (templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, $super) {
  templateId = templateId === VOID ? this.templateId : templateId;
  partKey = partKey === VOID ? this.partKey : partKey;
  connector = connector === VOID ? this.connector : connector;
  connectorOnHost = connectorOnHost === VOID ? this.connectorOnHost : connectorOnHost;
  position = position === VOID ? this.position : position;
  transform = transform === VOID ? this.transform : transform;
  components = components === VOID ? this.components : components;
  children = children === VOID ? this.children : children;
  locked = locked === VOID ? this.locked : locked;
  return this.x5i(templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked);
};
protoOf(AssemblyChild).toString = function () {
  return 'AssemblyChild(templateId=' + this.templateId + ', partKey=' + this.partKey + ', connector=' + this.connector + ', connectorOnHost=' + this.connectorOnHost + ', position=' + toString_0(this.position) + ', transform=' + toString(this.transform) + ', components=' + toString_0(this.components) + ', children=' + toString(this.children) + ', locked=' + this.locked + ')';
};
function Companion_14() {
  Companion_instance_24 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.y5i_1 = [new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_10())];
}
protoOf(Companion_14).mapGeneratorPartsToTemplateChildren = function (catalog, catalogParts, templateChildren, catalogSize) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var assemblyParts = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var partsMap = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = templateChildren.length;
  while (inductionVariable < last) {
    var element = templateChildren[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.dynamic.template.Companion.mapGeneratorPartsToTemplateChildren.<anonymous>' call
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var tmp0_iterator = catalogParts.k();
      while (tmp0_iterator.m()) {
        var item = tmp0_iterator.n();
        // Inline function 'com.ikea.range.dynamic.template.Companion.mapGeneratorPartsToTemplateChildren.<anonymous>.<anonymous>' call
        if (item.partKey === element.partKey) {
          tmp$ret$3 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$3 = -1;
    }
    var generatorPartIndex = tmp$ret$3;
    var tmp;
    if (!(element.connector == null) && !(element.connectorOnHost == null)) {
      tmp = new AssemblyPartSnapInfo(element.connectorOnHost, element.connector);
    } else {
      tmp = null;
    }
    var snapInfo = tmp;
    if (generatorPartIndex > -1) {
      var generatorPart = catalogParts.p2(generatorPartIndex);
      var tmp_0;
      if (!(element.children == null)) {
        var tmp0_safe_receiver = catalog.findProductDTO(generatorPart.id);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.template;
        var childCatalogSize = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.size;
        tmp_0 = Companion_getInstance_21().mapGeneratorPartsToTemplateChildren(catalog, catalogParts, element.children, childCatalogSize);
      } else {
        tmp_0 = new Pair(null, null);
      }
      var _destruct__k2r9zo = tmp_0;
      var children = _destruct__k2r9zo.tf();
      var childrenParts = _destruct__k2r9zo.uf();
      if (childrenParts == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        partsMap.s2(childrenParts);
      }
      var tmp_1;
      if (!(element.position == null)) {
        var tmp_2;
        if (!(catalogSize == null)) {
          tmp_2 = element.position.applyToBox(Companion_getInstance_1().fromSize$default(catalogSize.vector));
        } else {
          tmp_2 = element.position.absoluteTransform;
        }
        tmp_1 = tmp_2;
      } else if (!(element.transform == null)) {
        tmp_1 = new Transform(new Vector(element.transform[0], element.transform[1], element.transform[2]), Companion_getInstance_3().s2w(new Degrees(element.transform[3]), new Degrees(element.transform[4]), new Degrees(element.transform[5])));
      } else {
        tmp_1 = Companion_getInstance_2().c1x_1;
      }
      var transform = tmp_1;
      var tmp3_elvis_lhs = element.locked;
      var assemblyPart = new AssemblyPart(element.partKey, transform, snapInfo, children, tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      var key = element.partKey;
      var value = generatorPart.id;
      partsMap.q2(key, value);
      assemblyParts.h(assemblyPart);
    } else {
      var tmp4_safe_receiver = element.position;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.absoluteTransform;
      var transform_0 = tmp5_elvis_lhs == null ? Companion_getInstance_2().c1x_1 : tmp5_elvis_lhs;
      var tmp6_elvis_lhs = element.locked;
      var assemblyPart_0 = new AssemblyPart(element.partKey, transform_0, snapInfo, null, tmp6_elvis_lhs == null ? true : tmp6_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      var key_0 = element.partKey;
      partsMap.q2(key_0, '');
      assemblyParts.h(assemblyPart_0);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$5 = copyToArray(assemblyParts);
  return new Pair(tmp$ret$5, partsMap);
};
protoOf(Companion_14).z18 = function () {
  return $serializer_getInstance_11();
};
var Companion_instance_24;
function Companion_getInstance_21() {
  if (Companion_instance_24 == null)
    new Companion_14();
  return Companion_instance_24;
}
function $serializer_8() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.AssemblyTemplate', this, 1);
  tmp0_serialDesc.lw('children', false);
  this.z5i_1 = tmp0_serialDesc;
}
protoOf($serializer_8).a5j = function (encoder, value) {
  var tmp0_desc = this.z5i_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_21().y5i_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.children);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_8).ul = function (encoder, value) {
  return this.a5j(encoder, value instanceof AssemblyTemplate ? value : THROW_CCE());
};
protoOf($serializer_8).vl = function (decoder) {
  var tmp0_desc = this.z5i_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  var tmp7_cached = Companion_getInstance_21().y5i_1;
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return AssemblyTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_8).tl = function () {
  return this.z5i_1;
};
protoOf($serializer_8).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_21().y5i_1[0]];
};
var $serializer_instance_8;
function $serializer_getInstance_11() {
  if ($serializer_instance_8 == null)
    new $serializer_8();
  return $serializer_instance_8;
}
function AssemblyTemplate_init_$Init$(seen0, children, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_11().z5i_1);
  }
  $this.children = children;
  var tmp = $this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var indexedObject = $this.children;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp_0 = sum;
    // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.<init>.<anonymous>' call
    sum = tmp_0 + element.hashCode() | 0;
  }
  tmp.c5i_1 = sum;
  return $this;
}
function AssemblyTemplate_init_$Create$(seen0, children, serializationConstructorMarker) {
  return AssemblyTemplate_init_$Init$(seen0, children, serializationConstructorMarker, objectCreate(protoOf(AssemblyTemplate)));
}
function AssemblyTemplate(children) {
  Companion_getInstance_21();
  this.children = children;
  var tmp = this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var indexedObject = this.children;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp_0 = sum;
    // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate._hashCode.<anonymous>' call
    sum = tmp_0 + element.hashCode() | 0;
  }
  tmp.c5i_1 = sum;
}
protoOf(AssemblyTemplate).i1m = function () {
  return this.children;
};
protoOf(AssemblyTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof AssemblyTemplate))
    THROW_CCE();
  if (!(other.children.length === this.children.length))
    return false;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var indexedObject = this.children;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var item = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.equals.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    if (!item.equals(other.children[tmp1]))
      return false;
  }
  return true;
};
protoOf(AssemblyTemplate).hashCode = function () {
  return this.c5i_1;
};
protoOf(AssemblyTemplate).inherit = function (extendedAssembly) {
  var tmp;
  if (extendedAssembly == null) {
    tmp = this;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = extendedAssembly.children;
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.inherit.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var indexedObject = this.children;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = indexedObject[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.inherit.<anonymous>.<anonymous>' call
          if (element_0.partKey === element.partKey) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    var combinedChildren = plus_1(this.children, destination);
    tmp = new AssemblyTemplate(combinedChildren);
  }
  return tmp;
};
protoOf(AssemblyTemplate).tf = function () {
  return this.children;
};
protoOf(AssemblyTemplate).b5j = function (children) {
  return new AssemblyTemplate(children);
};
protoOf(AssemblyTemplate).copy = function (children, $super) {
  children = children === VOID ? this.children : children;
  return this.b5j(children);
};
protoOf(AssemblyTemplate).toString = function () {
  return 'AssemblyTemplate(children=' + toString(this.children) + ')';
};
function CustomSerializer_0() {
  CustomSerializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.AutoAdaptHostTemplate', null, 1);
  tmp0_serialDesc.lw('hostZone', true);
  this.c5j_1 = tmp0_serialDesc;
}
protoOf(CustomSerializer_0).vl = function (decoder) {
  var template = null;
  try {
    var value = decoder.oo();
    if (value) {
      template = new AutoAdaptHostTemplate(new DynamicRangeDimension(0.0, 0.0, VOID, 0.0, VOID, 0.0, 0.0, 0.0));
    }
  } catch ($p) {
    if ($p instanceof SerializationException) {
      var e = $p;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var $this$run = decoder.bp(this.c5j_1);
      var i = $this$run.sp(CustomSerializer_getInstance_0().c5j_1);
      if (!(i === -1)) {
        var hostZone = $this$run.op(CustomSerializer_getInstance_0().c5j_1, i, Companion_getInstance_26().z18());
        template = new AutoAdaptHostTemplate(hostZone);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'AutoAdaptHost: error found in JSON.';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      $this$run.cp(CustomSerializer_getInstance_0().c5j_1);
    } else {
      throw $p;
    }
  }
  return template;
};
protoOf(CustomSerializer_0).tl = function () {
  return this.c5j_1;
};
protoOf(CustomSerializer_0).e5j = function (encoder, value) {
  var tmp0_desc = this.c5j_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.hostZone == null)) {
    tmp1_output.uq(tmp0_desc, 0, Companion_getInstance_26(), value.hostZone);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf(CustomSerializer_0).ul = function (encoder, value) {
  return this.e5j(encoder, (value == null ? true : value instanceof AutoAdaptHostTemplate) ? value : THROW_CCE());
};
protoOf(CustomSerializer_0).z18 = function () {
  return CustomSerializer_getInstance_0();
};
var CustomSerializer_instance_0;
function CustomSerializer_getInstance_0() {
  if (CustomSerializer_instance_0 == null)
    new CustomSerializer_0();
  return CustomSerializer_instance_0;
}
function AutoAdaptHostTemplate(hostZone) {
  CustomSerializer_getInstance_0();
  hostZone = hostZone === VOID ? null : hostZone;
  this.hostZone = hostZone;
}
protoOf(AutoAdaptHostTemplate).d3w = function () {
  return this.hostZone;
};
protoOf(AutoAdaptHostTemplate).tf = function () {
  return this.hostZone;
};
protoOf(AutoAdaptHostTemplate).f5j = function (hostZone) {
  return new AutoAdaptHostTemplate(hostZone);
};
protoOf(AutoAdaptHostTemplate).copy = function (hostZone, $super) {
  hostZone = hostZone === VOID ? this.hostZone : hostZone;
  return this.f5j(hostZone);
};
protoOf(AutoAdaptHostTemplate).toString = function () {
  return 'AutoAdaptHostTemplate(hostZone=' + toString_0(this.hostZone) + ')';
};
protoOf(AutoAdaptHostTemplate).hashCode = function () {
  return this.hostZone == null ? 0 : this.hostZone.hashCode();
};
protoOf(AutoAdaptHostTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AutoAdaptHostTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof AutoAdaptHostTemplate ? other : THROW_CCE();
  if (!equals(this.hostZone, tmp0_other_with_cast.hostZone))
    return false;
  return true;
};
function BoundItemTemplate$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('id', PrimitiveSerialDescriptor('id', STRING_getInstance()));
  $this$buildClassSerialDescriptor.hm('type', PrimitiveSerialDescriptor('type', STRING_getInstance()));
  $this$buildClassSerialDescriptor.hm('layer', PrimitiveSerialDescriptor('layer', STRING_getInstance()));
  $this$buildClassSerialDescriptor.hm('dimension', Companion_getInstance_26().d5j_1);
  $this$buildClassSerialDescriptor.hm('margin', MarginTemplateSerializer_getInstance().g5j_1);
  $this$buildClassSerialDescriptor.hm('padding', MarginTemplateSerializer_getInstance().g5j_1);
  $this$buildClassSerialDescriptor.hm('compartment', Companion_getInstance_23().h5j_1);
  return Unit_instance;
}
function Companion_15() {
  Companion_instance_25 = this;
  var tmp = this;
  tmp.i5j_1 = buildClassSerialDescriptor('BoundItemTemplate', [], BoundItemTemplate$Companion$descriptor$lambda);
}
protoOf(Companion_15).tl = function () {
  return this.i5j_1;
};
protoOf(Companion_15).vl = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.i5j_1;
  var composite = decoder.bp(descriptor);
  // Inline function 'com.ikea.range.dynamic.template.Companion.deserialize.<anonymous>' call
  var id = '';
  var type = 'box';
  var layer = 'collision';
  var dimension = null;
  var margin = null;
  var padding = null;
  var compartment = null;
  loop: while (true) {
    var index = composite.sp(Companion_getInstance_22().i5j_1);
    switch (index) {
      case 0:
        id = composite.lp(Companion_getInstance_22().i5j_1, 0);
        break;
      case 1:
        type = composite.lp(Companion_getInstance_22().i5j_1, 1);
        break;
      case 2:
        layer = composite.lp(Companion_getInstance_22().i5j_1, 2);
        break;
      case 3:
        dimension = composite.op(Companion_getInstance_22().i5j_1, 3, Companion_getInstance_26().z18());
        break;
      case 4:
        margin = composite.op(Companion_getInstance_22().i5j_1, 4, MarginTemplateSerializer_getInstance().z18());
        break;
      case 5:
        padding = composite.op(Companion_getInstance_22().i5j_1, 5, MarginTemplateSerializer_getInstance().z18());
        break;
      case 6:
        compartment = composite.op(Companion_getInstance_22().i5j_1, 6, Companion_getInstance_23().z18());
        break;
      case -1:
        break loop;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Unexpected index: ' + index;
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  var result = new BoundItemTemplate(dimension, id, type, layer, margin, padding, compartment);
  composite.cp(descriptor);
  return result;
};
protoOf(Companion_15).j5j = function (encoder, value) {
  var enc = encoder.bp(this.i5j_1);
  enc.qq(this.i5j_1, 0, value.id);
  enc.qq(this.i5j_1, 1, value.type);
  enc.qq(this.i5j_1, 2, value.layer);
  var tmp0_safe_receiver = value.dimension;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    enc.sq(Companion_getInstance_22().i5j_1, 3, Companion_getInstance_26().z18(), tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = value.margin;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    enc.sq(Companion_getInstance_22().i5j_1, 4, MarginTemplateSerializer_getInstance().z18(), tmp1_safe_receiver);
  }
  var tmp2_safe_receiver = value.padding;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    enc.sq(Companion_getInstance_22().i5j_1, 5, MarginTemplateSerializer_getInstance().z18(), tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = value.compartment;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    enc.sq(Companion_getInstance_22().i5j_1, 6, Companion_getInstance_23().z18(), tmp3_safe_receiver);
  }
  enc.cp(this.i5j_1);
};
protoOf(Companion_15).ul = function (encoder, value) {
  return this.j5j(encoder, value instanceof BoundItemTemplate ? value : THROW_CCE());
};
protoOf(Companion_15).z18 = function () {
  return Companion_getInstance_22();
};
var Companion_instance_25;
function Companion_getInstance_22() {
  if (Companion_instance_25 == null)
    new Companion_15();
  return Companion_instance_25;
}
function BoundItemTemplate(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId) {
  Companion_getInstance_22();
  dimension = dimension === VOID ? null : dimension;
  type = type === VOID ? 'box' : type;
  layer = layer === VOID ? 'collision' : layer;
  margin = margin === VOID ? null : margin;
  padding = padding === VOID ? null : padding;
  compartment = compartment === VOID ? null : compartment;
  sourceTemplateId = sourceTemplateId === VOID ? '' : sourceTemplateId;
  this.dimension = dimension;
  this.id = id;
  this.type = type;
  this.layer = layer;
  this.margin = margin;
  this.padding = padding;
  this.compartment = compartment;
  this.sourceTemplateId = sourceTemplateId;
  this.l5f_1 = 0;
}
protoOf(BoundItemTemplate).k5j = function () {
  return this.dimension;
};
protoOf(BoundItemTemplate).n1s = function () {
  return this.id;
};
protoOf(BoundItemTemplate).w2a = function () {
  return this.type;
};
protoOf(BoundItemTemplate).l49 = function () {
  return this.layer;
};
protoOf(BoundItemTemplate).k48 = function () {
  return this.margin;
};
protoOf(BoundItemTemplate).l5j = function () {
  return this.padding;
};
protoOf(BoundItemTemplate).m5j = function () {
  return this.compartment;
};
protoOf(BoundItemTemplate).n5j = function (_set____db54di) {
  this.sourceTemplateId = _set____db54di;
};
protoOf(BoundItemTemplate).o5j = function () {
  return this.sourceTemplateId;
};
protoOf(BoundItemTemplate).getPolyhedronsForSize = function (size) {
  var tmp;
  if (this.type === 'frame') {
    var tmp_0 = Companion_getInstance_4();
    var tmp0_safe_receiver = this.margin;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toMargin();
    var tmp_1 = tmp1_elvis_lhs == null ? new Margin() : tmp1_elvis_lhs;
    var tmp_2 = ensureNotNull(this.padding).toMargin();
    var tmp2_safe_receiver = this.compartment;
    var tmp_3;
    if (tmp2_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.getPolyhedronsForSize.<anonymous>' call
      var tmp0_elvis_lhs = tmp2_safe_receiver.width;
      var tmp_4 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs_0 = tmp2_safe_receiver.height;
      tmp_3 = new Size(tmp_4, tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0);
    }
    var tmp_5 = tmp_0.h3c(size, tmp_1, tmp_2, tmp_3);
    tmp = isArray(tmp_5) ? tmp_5 : THROW_CCE();
  } else {
    var tmp_6;
    if (this.dimension == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.getPolyhedronsForSize.<anonymous>' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_6 = [this.dimension.getPolyhedronForSize(size)];
    }
    var tmp4_elvis_lhs = tmp_6;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      var tmp5_width = size.b2y_1;
      var tmp6_height = size.c2y_1;
      var tmp7_depth = size.d2y_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_7 = [(new DynamicRangeDimension(VOID, VOID, tmp7_depth, VOID, tmp6_height, VOID, VOID, VOID, tmp5_width)).getPolyhedronForSize(size)];
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp = tmp_7;
  }
  return tmp;
};
protoOf(BoundItemTemplate).getPolyhedronForSize = function (size) {
  var tmp;
  if (this.dimension == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.getPolyhedronForSize.<anonymous>' call
    tmp = this.dimension.getPolyhedronForSize(size);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_width = size.b2y_1;
    var tmp3_height = size.c2y_1;
    var tmp4_depth = size.d2y_1;
    tmp_0 = (new DynamicRangeDimension(VOID, VOID, tmp4_depth, VOID, tmp3_height, VOID, VOID, VOID, tmp2_width)).getPolyhedronForSize(size);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
};
protoOf(BoundItemTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof BoundItemTemplate))
    THROW_CCE();
  if (!equals(this.dimension, other.dimension))
    return false;
  if (!(this.id === other.id))
    return false;
  return true;
};
protoOf(BoundItemTemplate).hashCode = function () {
  if (this.l5f_1 === 0) {
    var tmp = this;
    var tmp0_safe_receiver = this.dimension;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    tmp.l5f_1 = imul(31, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + getStringHashCode(this.id) | 0;
  }
  return this.l5f_1;
};
protoOf(BoundItemTemplate).clone = function () {
  var tmp0_safe_receiver = this.dimension;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clone();
  var tmp1_safe_receiver = this.margin;
  var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.clone();
  var tmp2_safe_receiver = this.padding;
  var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.clone();
  var tmp3_safe_receiver = this.compartment;
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.clone.<anonymous>' call
    tmp_2 = new Compartment(tmp3_safe_receiver.width, tmp3_safe_receiver.height);
  }
  return new BoundItemTemplate(tmp, this.id, this.type, this.layer, tmp_0, tmp_1, tmp_2, this.sourceTemplateId);
};
protoOf(BoundItemTemplate).tf = function () {
  return this.dimension;
};
protoOf(BoundItemTemplate).uf = function () {
  return this.id;
};
protoOf(BoundItemTemplate).m1m = function () {
  return this.type;
};
protoOf(BoundItemTemplate).n1m = function () {
  return this.layer;
};
protoOf(BoundItemTemplate).o1m = function () {
  return this.margin;
};
protoOf(BoundItemTemplate).p1m = function () {
  return this.padding;
};
protoOf(BoundItemTemplate).q1m = function () {
  return this.compartment;
};
protoOf(BoundItemTemplate).l2e = function () {
  return this.sourceTemplateId;
};
protoOf(BoundItemTemplate).p5j = function (dimension, id, type, layer, margin, padding, compartment, sourceTemplateId) {
  return new BoundItemTemplate(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId);
};
protoOf(BoundItemTemplate).copy = function (dimension, id, type, layer, margin, padding, compartment, sourceTemplateId, $super) {
  dimension = dimension === VOID ? this.dimension : dimension;
  id = id === VOID ? this.id : id;
  type = type === VOID ? this.type : type;
  layer = layer === VOID ? this.layer : layer;
  margin = margin === VOID ? this.margin : margin;
  padding = padding === VOID ? this.padding : padding;
  compartment = compartment === VOID ? this.compartment : compartment;
  sourceTemplateId = sourceTemplateId === VOID ? this.sourceTemplateId : sourceTemplateId;
  return this.p5j(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId);
};
protoOf(BoundItemTemplate).toString = function () {
  return 'BoundItemTemplate(dimension=' + toString_0(this.dimension) + ', id=' + this.id + ', type=' + this.type + ', layer=' + this.layer + ', margin=' + toString_0(this.margin) + ', padding=' + toString_0(this.padding) + ', compartment=' + toString_0(this.compartment) + ', sourceTemplateId=' + this.sourceTemplateId + ')';
};
function inherit(_this__u8e3s4, extendedBounds) {
  var tmp;
  if (extendedBounds == null) {
    tmp = _this__u8e3s4;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = extendedBounds.length;
    while (inductionVariable < last) {
      var element = extendedBounds[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = _this__u8e3s4.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = _this__u8e3s4[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>.<anonymous>' call
          if (element_0.id === element.id) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_1(_this__u8e3s4, destination);
  }
  return tmp;
}
function getPolyhedronForSize(_this__u8e3s4, size) {
  try {
    var tmp;
    if (size.equals(new Size())) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      var ids = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$_0();
      var inductionVariable = 0;
      var last = _this__u8e3s4.length;
      while (inductionVariable < last) {
        var element = _this__u8e3s4[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.getPolyhedronForSize.<anonymous>' call
        var b = toList(element.getPolyhedronsForSize(size));
        if (b.o() > 1) {
          var inductionVariable_0 = 1;
          var last_0 = b.o();
          if (inductionVariable_0 <= last_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              ids.h(element.id + ':' + i);
            }
             while (!(i === last_0));
        } else {
          ids.h(element.id);
        }
        var list = b;
        addAll(destination, list);
      }
      var polyhedra = copyToArray(destination);
      var tmp_0;
      // Inline function 'kotlin.collections.isEmpty' call
      if (polyhedra.length === 0) {
        tmp_0 = null;
      } else {
        if (polyhedra.length === 1) {
          tmp_0 = polyhedra[0];
        } else {
          tmp_0 = merge(polyhedra);
        }
      }
      var polyhedron = tmp_0;
      var tmp_1;
      if (polyhedron == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.getPolyhedronForSize.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$6 = copyToArray(ids);
        tmp_1 = new Pair(polyhedron, tmp$ret$6);
      }
      return tmp_1;
    }
    return tmp;
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = 'Specification of bounds not valid';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
}
function Compartment$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('width', PrimitiveSerialDescriptor('width', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('height', PrimitiveSerialDescriptor('height', DOUBLE_getInstance()));
  return Unit_instance;
}
function Companion_16() {
  Companion_instance_26 = this;
  var tmp = this;
  tmp.h5j_1 = buildClassSerialDescriptor('Compartment', [], Compartment$Companion$descriptor$lambda);
}
protoOf(Companion_16).tl = function () {
  return this.h5j_1;
};
protoOf(Companion_16).q5j = function (encoder, value) {
  var enc = encoder.bp(this.h5j_1);
  if (value.width == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (!isNaN_0(value.width)) {
      enc.oq(Companion_getInstance_23().h5j_1, 0, value.width);
    }
  }
  if (value.height == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (!isNaN_0(value.height)) {
      enc.oq(Companion_getInstance_23().h5j_1, 1, value.height);
    }
  }
  enc.cp(this.h5j_1);
};
protoOf(Companion_16).ul = function (encoder, value) {
  return this.q5j(encoder, value instanceof Compartment ? value : THROW_CCE());
};
protoOf(Companion_16).vl = function (decoder) {
  var tmp0_desc = this.h5j_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.pp(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.pp(tmp0_desc, 1, DoubleSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.pp(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.pp(tmp0_desc, 1, DoubleSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  if (!(0 === (0 & tmp3_bitMask0))) {
    throwMissingFieldException(tmp3_bitMask0, 0, tmp0_desc);
  }
  if (0 === (tmp3_bitMask0 & 1))
    tmp4_local0 = NaN;
  if (0 === (tmp3_bitMask0 & 2))
    tmp5_local1 = NaN;
  return new Compartment(tmp4_local0, tmp5_local1);
};
protoOf(Companion_16).z18 = function () {
  return Companion_getInstance_23();
};
var Companion_instance_26;
function Companion_getInstance_23() {
  if (Companion_instance_26 == null)
    new Companion_16();
  return Companion_instance_26;
}
function Compartment(width, height) {
  Companion_getInstance_23();
  width = width === VOID ? NaN : width;
  height = height === VOID ? NaN : height;
  this.width = width;
  this.height = height;
}
protoOf(Compartment).t2u = function () {
  return this.width;
};
protoOf(Compartment).u2u = function () {
  return this.height;
};
protoOf(Compartment).tf = function () {
  return this.width;
};
protoOf(Compartment).uf = function () {
  return this.height;
};
protoOf(Compartment).r5j = function (width, height) {
  return new Compartment(width, height);
};
protoOf(Compartment).copy = function (width, height, $super) {
  width = width === VOID ? this.width : width;
  height = height === VOID ? this.height : height;
  return this.r5j(width, height);
};
protoOf(Compartment).toString = function () {
  return 'Compartment(width=' + this.width + ', height=' + this.height + ')';
};
protoOf(Compartment).hashCode = function () {
  var result = this.width == null ? 0 : getNumberHashCode(this.width);
  result = imul(result, 31) + (this.height == null ? 0 : getNumberHashCode(this.height)) | 0;
  return result;
};
protoOf(Compartment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Compartment))
    return false;
  var tmp0_other_with_cast = other instanceof Compartment ? other : THROW_CCE();
  if (!equals(this.width, tmp0_other_with_cast.width))
    return false;
  if (!equals(this.height, tmp0_other_with_cast.height))
    return false;
  return true;
};
function inheritProductStructure($this, originalTemplate, extendedProductStructureTemplate) {
  if (extendedProductStructureTemplate == null)
    return originalTemplate;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable = 0;
  var last = extendedProductStructureTemplate.length;
  while (inductionVariable < last) {
    var element = extendedProductStructureTemplate[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.dynamic.template.ComponentsTemplate.inheritProductStructure.<anonymous>' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.none' call
      var inductionVariable_0 = 0;
      var last_0 = originalTemplate.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = originalTemplate[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.ComponentsTemplate.inheritProductStructure.<anonymous>.<anonymous>' call
        if (element_0.partKey === element.partKey) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    if (tmp$ret$1) {
      destination.h(element);
    }
  }
  var noneSameProductStructures = destination;
  return plus_1(originalTemplate, noneSameProductStructures);
}
function Companion_17() {
  Companion_instance_27 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.s5j_1 = [new ReferenceArraySerializer(getKClass(BoundItemTemplate), Companion_getInstance_22()), new ReferenceArraySerializer(getKClass(BoundItemTemplate), Companion_getInstance_22()), new ReferenceArraySerializer(getKClass(ConnectorItemTemplate), Companion_getInstance_25()), null, null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().mb(), new ReferenceArraySerializer(PrimitiveClasses_getInstance().jb(), IntSerializer_getInstance())), null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, new ReferenceArraySerializer(getKClass(ProductStructureItemTemplate), $serializer_getInstance_19()), new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance())];
}
protoOf(Companion_17).t5j = function (primary, secondary) {
  if (primary == null)
    return secondary;
  if (secondary == null)
    return primary;
  return plus_0(secondary, primary);
};
protoOf(Companion_17).z18 = function () {
  return $serializer_getInstance_12();
};
var Companion_instance_27;
function Companion_getInstance_24() {
  if (Companion_instance_27 == null)
    new Companion_17();
  return Companion_instance_27;
}
function $serializer_9() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.ComponentsTemplate', this, 31);
  tmp0_serialDesc.lw('bounds', true);
  tmp0_serialDesc.lw('functionalZones', true);
  tmp0_serialDesc.lw('connectors', true);
  tmp0_serialDesc.lw('assembly', true);
  tmp0_serialDesc.lw('selectable', true);
  tmp0_serialDesc.lw('outlineable', true);
  tmp0_serialDesc.lw('draggable', true);
  tmp0_serialDesc.lw('allowedDoorPairs', true);
  tmp0_serialDesc.lw('autoAdaptHost', true);
  tmp0_serialDesc.lw('communicationSize', true);
  tmp0_serialDesc.lw('door', true);
  tmp0_serialDesc.lw('doorFront', true);
  tmp0_serialDesc.lw('handle', true);
  tmp0_serialDesc.lw('drawer', true);
  tmp0_serialDesc.lw('frame', true);
  tmp0_serialDesc.lw('leg', true);
  tmp0_serialDesc.lw('light', true);
  tmp0_serialDesc.lw('outlined', true);
  tmp0_serialDesc.lw('propping', true);
  tmp0_serialDesc.lw('alwaysHangDown', true);
  tmp0_serialDesc.lw('serializeEntity', true);
  tmp0_serialDesc.lw('placementZoneByHeight', true);
  tmp0_serialDesc.lw('functionalMargin', true);
  tmp0_serialDesc.lw('recommendedInitialPositionFromFloor', true);
  tmp0_serialDesc.lw('visualLightSource', true);
  tmp0_serialDesc.lw('model3D', true);
  tmp0_serialDesc.lw('product', true);
  tmp0_serialDesc.lw('dragSurfaces', true);
  tmp0_serialDesc.lw('dragProjectionPoint', true);
  tmp0_serialDesc.lw('productStructure', true);
  tmp0_serialDesc.lw('meta', true);
  this.u5j_1 = tmp0_serialDesc;
}
protoOf($serializer_9).v5j = function (encoder, value) {
  var tmp0_desc = this.u5j_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_24().s5j_1;
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.bounds == null)) {
    tmp1_output.uq(tmp0_desc, 0, tmp2_cached[0], value.bounds);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.functionalZones == null)) {
    tmp1_output.uq(tmp0_desc, 1, tmp2_cached[1], value.functionalZones);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.connectors == null)) {
    tmp1_output.uq(tmp0_desc, 2, tmp2_cached[2], value.connectors);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.assembly == null)) {
    tmp1_output.uq(tmp0_desc, 3, $serializer_getInstance_11(), value.assembly);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.selectable == null)) {
    tmp1_output.uq(tmp0_desc, 4, BooleanSerializer_getInstance(), value.selectable);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !(value.outlineable == null)) {
    tmp1_output.uq(tmp0_desc, 5, BooleanSerializer_getInstance(), value.outlineable);
  }
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.draggable == null)) {
    tmp1_output.uq(tmp0_desc, 6, BooleanSerializer_getInstance(), value.draggable);
  }
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.allowedDoorPairs == null)) {
    tmp1_output.uq(tmp0_desc, 7, tmp2_cached[7], value.allowedDoorPairs);
  }
  if (tmp1_output.yq(tmp0_desc, 8) ? true : !(value.autoAdaptHost == null)) {
    tmp1_output.uq(tmp0_desc, 8, CustomSerializer_getInstance_0(), value.autoAdaptHost);
  }
  if (tmp1_output.yq(tmp0_desc, 9) ? true : !(value.communicationSize == null)) {
    tmp1_output.uq(tmp0_desc, 9, $serializer_getInstance(), value.communicationSize);
  }
  if (tmp1_output.yq(tmp0_desc, 10) ? true : !(value.door == null)) {
    tmp1_output.uq(tmp0_desc, 10, BooleanSerializer_getInstance(), value.door);
  }
  if (tmp1_output.yq(tmp0_desc, 11) ? true : !(value.doorFront == null)) {
    tmp1_output.uq(tmp0_desc, 11, BooleanSerializer_getInstance(), value.doorFront);
  }
  if (tmp1_output.yq(tmp0_desc, 12) ? true : !(value.handle == null)) {
    tmp1_output.uq(tmp0_desc, 12, BooleanSerializer_getInstance(), value.handle);
  }
  if (tmp1_output.yq(tmp0_desc, 13) ? true : !(value.drawer == null)) {
    tmp1_output.uq(tmp0_desc, 13, BooleanSerializer_getInstance(), value.drawer);
  }
  if (tmp1_output.yq(tmp0_desc, 14) ? true : !(value.frame == null)) {
    tmp1_output.uq(tmp0_desc, 14, BooleanSerializer_getInstance(), value.frame);
  }
  if (tmp1_output.yq(tmp0_desc, 15) ? true : !(value.leg == null)) {
    tmp1_output.uq(tmp0_desc, 15, BooleanSerializer_getInstance(), value.leg);
  }
  if (tmp1_output.yq(tmp0_desc, 16) ? true : !(value.light == null)) {
    tmp1_output.uq(tmp0_desc, 16, $serializer_getInstance_14(), value.light);
  }
  if (tmp1_output.yq(tmp0_desc, 17) ? true : !(value.outlined == null)) {
    tmp1_output.uq(tmp0_desc, 17, BooleanSerializer_getInstance(), value.outlined);
  }
  if (tmp1_output.yq(tmp0_desc, 18) ? true : !(value.propping == null)) {
    tmp1_output.uq(tmp0_desc, 18, BooleanSerializer_getInstance(), value.propping);
  }
  if (tmp1_output.yq(tmp0_desc, 19) ? true : !(value.alwaysHangDown == null)) {
    tmp1_output.uq(tmp0_desc, 19, BooleanSerializer_getInstance(), value.alwaysHangDown);
  }
  if (tmp1_output.yq(tmp0_desc, 20) ? true : !(value.serializeEntity == null)) {
    tmp1_output.uq(tmp0_desc, 20, BooleanSerializer_getInstance(), value.serializeEntity);
  }
  if (tmp1_output.yq(tmp0_desc, 21) ? true : !(value.placementZoneByHeight == null)) {
    tmp1_output.uq(tmp0_desc, 21, $serializer_getInstance_16(), value.placementZoneByHeight);
  }
  if (tmp1_output.yq(tmp0_desc, 22) ? true : !(value.functionalMargin == null)) {
    tmp1_output.uq(tmp0_desc, 22, MarginTemplateSerializer_getInstance(), value.functionalMargin);
  }
  if (tmp1_output.yq(tmp0_desc, 23) ? true : !(value.recommendedInitialPositionFromFloor == null)) {
    tmp1_output.uq(tmp0_desc, 23, IntSerializer_getInstance(), value.recommendedInitialPositionFromFloor);
  }
  if (tmp1_output.yq(tmp0_desc, 24) ? true : !(value.visualLightSource == null)) {
    tmp1_output.uq(tmp0_desc, 24, $serializer_getInstance_17(), value.visualLightSource);
  }
  if (tmp1_output.yq(tmp0_desc, 25) ? true : !(value.model3D == null)) {
    tmp1_output.uq(tmp0_desc, 25, $serializer_getInstance_15(), value.model3D);
  }
  if (tmp1_output.yq(tmp0_desc, 26) ? true : !(value.product == null)) {
    tmp1_output.uq(tmp0_desc, 26, $serializer_getInstance_9(), value.product);
  }
  if (tmp1_output.yq(tmp0_desc, 27) ? true : !(value.dragSurfaces == null)) {
    tmp1_output.uq(tmp0_desc, 27, CustomSerializer_getInstance_1(), value.dragSurfaces);
  }
  if (tmp1_output.yq(tmp0_desc, 28) ? true : !(value.dragProjectionPoint == null)) {
    tmp1_output.uq(tmp0_desc, 28, PositionTemplateSerializer_getInstance(), value.dragProjectionPoint);
  }
  if (tmp1_output.yq(tmp0_desc, 29) ? true : !(value.productStructure == null)) {
    tmp1_output.uq(tmp0_desc, 29, tmp2_cached[29], value.productStructure);
  }
  if (tmp1_output.yq(tmp0_desc, 30) ? true : !(value.meta == null)) {
    tmp1_output.uq(tmp0_desc, 30, tmp2_cached[30], value.meta);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_9).ul = function (encoder, value) {
  return this.v5j(encoder, value instanceof ComponentsTemplate ? value : THROW_CCE());
};
protoOf($serializer_9).vl = function (decoder) {
  var tmp0_desc = this.u5j_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_local12 = null;
  var tmp17_local13 = null;
  var tmp18_local14 = null;
  var tmp19_local15 = null;
  var tmp20_local16 = null;
  var tmp21_local17 = null;
  var tmp22_local18 = null;
  var tmp23_local19 = null;
  var tmp24_local20 = null;
  var tmp25_local21 = null;
  var tmp26_local22 = null;
  var tmp27_local23 = null;
  var tmp28_local24 = null;
  var tmp29_local25 = null;
  var tmp30_local26 = null;
  var tmp31_local27 = null;
  var tmp32_local28 = null;
  var tmp33_local29 = null;
  var tmp34_local30 = null;
  var tmp36_input = decoder.bp(tmp0_desc);
  var tmp37_cached = Companion_getInstance_24().s5j_1;
  if (tmp36_input.rp()) {
    tmp4_local0 = tmp36_input.pp(tmp0_desc, 0, tmp37_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp36_input.pp(tmp0_desc, 1, tmp37_cached[1], tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp36_input.pp(tmp0_desc, 2, tmp37_cached[2], tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp36_input.pp(tmp0_desc, 3, $serializer_getInstance_11(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp36_input.pp(tmp0_desc, 4, BooleanSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp36_input.pp(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp36_input.pp(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp36_input.pp(tmp0_desc, 7, tmp37_cached[7], tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp36_input.pp(tmp0_desc, 8, CustomSerializer_getInstance_0(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp36_input.pp(tmp0_desc, 9, $serializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp36_input.pp(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp36_input.pp(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp36_input.pp(tmp0_desc, 12, BooleanSerializer_getInstance(), tmp16_local12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp36_input.pp(tmp0_desc, 13, BooleanSerializer_getInstance(), tmp17_local13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp36_input.pp(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp18_local14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp36_input.pp(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp19_local15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp36_input.pp(tmp0_desc, 16, $serializer_getInstance_14(), tmp20_local16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp21_local17 = tmp36_input.pp(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp21_local17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    tmp22_local18 = tmp36_input.pp(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp22_local18);
    tmp3_bitMask0 = tmp3_bitMask0 | 262144;
    tmp23_local19 = tmp36_input.pp(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp23_local19);
    tmp3_bitMask0 = tmp3_bitMask0 | 524288;
    tmp24_local20 = tmp36_input.pp(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp24_local20);
    tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    tmp25_local21 = tmp36_input.pp(tmp0_desc, 21, $serializer_getInstance_16(), tmp25_local21);
    tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    tmp26_local22 = tmp36_input.pp(tmp0_desc, 22, MarginTemplateSerializer_getInstance(), tmp26_local22);
    tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    tmp27_local23 = tmp36_input.pp(tmp0_desc, 23, IntSerializer_getInstance(), tmp27_local23);
    tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    tmp28_local24 = tmp36_input.pp(tmp0_desc, 24, $serializer_getInstance_17(), tmp28_local24);
    tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
    tmp29_local25 = tmp36_input.pp(tmp0_desc, 25, $serializer_getInstance_15(), tmp29_local25);
    tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
    tmp30_local26 = tmp36_input.pp(tmp0_desc, 26, $serializer_getInstance_9(), tmp30_local26);
    tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    tmp31_local27 = tmp36_input.pp(tmp0_desc, 27, CustomSerializer_getInstance_1(), tmp31_local27);
    tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
    tmp32_local28 = tmp36_input.pp(tmp0_desc, 28, PositionTemplateSerializer_getInstance(), tmp32_local28);
    tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
    tmp33_local29 = tmp36_input.pp(tmp0_desc, 29, tmp37_cached[29], tmp33_local29);
    tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
    tmp34_local30 = tmp36_input.pp(tmp0_desc, 30, tmp37_cached[30], tmp34_local30);
    tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp36_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp36_input.pp(tmp0_desc, 0, tmp37_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp36_input.pp(tmp0_desc, 1, tmp37_cached[1], tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp36_input.pp(tmp0_desc, 2, tmp37_cached[2], tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp36_input.pp(tmp0_desc, 3, $serializer_getInstance_11(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp36_input.pp(tmp0_desc, 4, BooleanSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp36_input.pp(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp36_input.pp(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp36_input.pp(tmp0_desc, 7, tmp37_cached[7], tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp36_input.pp(tmp0_desc, 8, CustomSerializer_getInstance_0(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp36_input.pp(tmp0_desc, 9, $serializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp36_input.pp(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp36_input.pp(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp36_input.pp(tmp0_desc, 12, BooleanSerializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp36_input.pp(tmp0_desc, 13, BooleanSerializer_getInstance(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp36_input.pp(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp36_input.pp(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp36_input.pp(tmp0_desc, 16, $serializer_getInstance_14(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp21_local17 = tmp36_input.pp(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        case 18:
          tmp22_local18 = tmp36_input.pp(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          break;
        case 19:
          tmp23_local19 = tmp36_input.pp(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp23_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          break;
        case 20:
          tmp24_local20 = tmp36_input.pp(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp24_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          break;
        case 21:
          tmp25_local21 = tmp36_input.pp(tmp0_desc, 21, $serializer_getInstance_16(), tmp25_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          break;
        case 22:
          tmp26_local22 = tmp36_input.pp(tmp0_desc, 22, MarginTemplateSerializer_getInstance(), tmp26_local22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          break;
        case 23:
          tmp27_local23 = tmp36_input.pp(tmp0_desc, 23, IntSerializer_getInstance(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          break;
        case 24:
          tmp28_local24 = tmp36_input.pp(tmp0_desc, 24, $serializer_getInstance_17(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          break;
        case 25:
          tmp29_local25 = tmp36_input.pp(tmp0_desc, 25, $serializer_getInstance_15(), tmp29_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          break;
        case 26:
          tmp30_local26 = tmp36_input.pp(tmp0_desc, 26, $serializer_getInstance_9(), tmp30_local26);
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          break;
        case 27:
          tmp31_local27 = tmp36_input.pp(tmp0_desc, 27, CustomSerializer_getInstance_1(), tmp31_local27);
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
          break;
        case 28:
          tmp32_local28 = tmp36_input.pp(tmp0_desc, 28, PositionTemplateSerializer_getInstance(), tmp32_local28);
          tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
          break;
        case 29:
          tmp33_local29 = tmp36_input.pp(tmp0_desc, 29, tmp37_cached[29], tmp33_local29);
          tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
          break;
        case 30:
          tmp34_local30 = tmp36_input.pp(tmp0_desc, 30, tmp37_cached[30], tmp34_local30);
          tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp36_input.cp(tmp0_desc);
  return ComponentsTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, tmp32_local28, tmp33_local29, tmp34_local30, null);
};
protoOf($serializer_9).tl = function () {
  return this.u5j_1;
};
protoOf($serializer_9).ex = function () {
  var tmp0_cached = Companion_getInstance_24().s5j_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable($serializer_getInstance_11()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[7]), get_nullable(CustomSerializer_getInstance_0()), get_nullable($serializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_14()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_16()), get_nullable(MarginTemplateSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable($serializer_getInstance_17()), get_nullable($serializer_getInstance_15()), get_nullable($serializer_getInstance_9()), get_nullable(CustomSerializer_getInstance_1()), get_nullable(PositionTemplateSerializer_getInstance()), get_nullable(tmp0_cached[29]), get_nullable(tmp0_cached[30])];
};
var $serializer_instance_9;
function $serializer_getInstance_12() {
  if ($serializer_instance_9 == null)
    new $serializer_9();
  return $serializer_instance_9;
}
function ComponentsTemplate_init_$Init$(seen0, bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, meta, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_12().u5j_1);
  }
  if (0 === (seen0 & 1))
    $this.bounds = null;
  else
    $this.bounds = bounds;
  if (0 === (seen0 & 2))
    $this.functionalZones = null;
  else
    $this.functionalZones = functionalZones;
  if (0 === (seen0 & 4))
    $this.connectors = null;
  else
    $this.connectors = connectors;
  if (0 === (seen0 & 8))
    $this.assembly = null;
  else
    $this.assembly = assembly;
  if (0 === (seen0 & 16))
    $this.selectable = null;
  else
    $this.selectable = selectable;
  if (0 === (seen0 & 32))
    $this.outlineable = null;
  else
    $this.outlineable = outlineable;
  if (0 === (seen0 & 64))
    $this.draggable = null;
  else
    $this.draggable = draggable;
  if (0 === (seen0 & 128))
    $this.allowedDoorPairs = null;
  else
    $this.allowedDoorPairs = allowedDoorPairs;
  if (0 === (seen0 & 256))
    $this.autoAdaptHost = null;
  else
    $this.autoAdaptHost = autoAdaptHost;
  if (0 === (seen0 & 512))
    $this.communicationSize = null;
  else
    $this.communicationSize = communicationSize;
  if (0 === (seen0 & 1024))
    $this.door = null;
  else
    $this.door = door;
  if (0 === (seen0 & 2048))
    $this.doorFront = null;
  else
    $this.doorFront = doorFront;
  if (0 === (seen0 & 4096))
    $this.handle = null;
  else
    $this.handle = handle;
  if (0 === (seen0 & 8192))
    $this.drawer = null;
  else
    $this.drawer = drawer;
  if (0 === (seen0 & 16384))
    $this.frame = null;
  else
    $this.frame = frame;
  if (0 === (seen0 & 32768))
    $this.leg = null;
  else
    $this.leg = leg;
  if (0 === (seen0 & 65536))
    $this.light = null;
  else
    $this.light = light;
  if (0 === (seen0 & 131072))
    $this.outlined = null;
  else
    $this.outlined = outlined;
  if (0 === (seen0 & 262144))
    $this.propping = null;
  else
    $this.propping = propping;
  if (0 === (seen0 & 524288))
    $this.alwaysHangDown = null;
  else
    $this.alwaysHangDown = alwaysHangDown;
  if (0 === (seen0 & 1048576))
    $this.serializeEntity = null;
  else
    $this.serializeEntity = serializeEntity;
  if (0 === (seen0 & 2097152))
    $this.placementZoneByHeight = null;
  else
    $this.placementZoneByHeight = placementZoneByHeight;
  if (0 === (seen0 & 4194304))
    $this.functionalMargin = null;
  else
    $this.functionalMargin = functionalMargin;
  if (0 === (seen0 & 8388608))
    $this.recommendedInitialPositionFromFloor = null;
  else
    $this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
  if (0 === (seen0 & 16777216))
    $this.visualLightSource = null;
  else
    $this.visualLightSource = visualLightSource;
  if (0 === (seen0 & 33554432))
    $this.model3D = null;
  else
    $this.model3D = model3D;
  if (0 === (seen0 & 67108864))
    $this.product = null;
  else
    $this.product = product;
  if (0 === (seen0 & 134217728))
    $this.dragSurfaces = null;
  else
    $this.dragSurfaces = dragSurfaces;
  if (0 === (seen0 & 268435456))
    $this.dragProjectionPoint = null;
  else
    $this.dragProjectionPoint = dragProjectionPoint;
  if (0 === (seen0 & 536870912))
    $this.productStructure = null;
  else
    $this.productStructure = productStructure;
  if (0 === (seen0 & 1073741824))
    $this.meta = null;
  else
    $this.meta = meta;
  $this.g5e_1 = 0;
  return $this;
}
function ComponentsTemplate_init_$Create$(seen0, bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, meta, serializationConstructorMarker) {
  return ComponentsTemplate_init_$Init$(seen0, bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, meta, serializationConstructorMarker, objectCreate(protoOf(ComponentsTemplate)));
}
function ComponentsTemplate(bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure) {
  Companion_getInstance_24();
  bounds = bounds === VOID ? null : bounds;
  functionalZones = functionalZones === VOID ? null : functionalZones;
  connectors = connectors === VOID ? null : connectors;
  assembly = assembly === VOID ? null : assembly;
  selectable = selectable === VOID ? null : selectable;
  outlineable = outlineable === VOID ? null : outlineable;
  draggable = draggable === VOID ? null : draggable;
  allowedDoorPairs = allowedDoorPairs === VOID ? null : allowedDoorPairs;
  autoAdaptHost = autoAdaptHost === VOID ? null : autoAdaptHost;
  communicationSize = communicationSize === VOID ? null : communicationSize;
  door = door === VOID ? null : door;
  doorFront = doorFront === VOID ? null : doorFront;
  handle = handle === VOID ? null : handle;
  drawer = drawer === VOID ? null : drawer;
  frame = frame === VOID ? null : frame;
  leg = leg === VOID ? null : leg;
  light = light === VOID ? null : light;
  outlined = outlined === VOID ? null : outlined;
  propping = propping === VOID ? null : propping;
  alwaysHangDown = alwaysHangDown === VOID ? null : alwaysHangDown;
  serializeEntity = serializeEntity === VOID ? null : serializeEntity;
  placementZoneByHeight = placementZoneByHeight === VOID ? null : placementZoneByHeight;
  functionalMargin = functionalMargin === VOID ? null : functionalMargin;
  recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor === VOID ? null : recommendedInitialPositionFromFloor;
  visualLightSource = visualLightSource === VOID ? null : visualLightSource;
  model3D = model3D === VOID ? null : model3D;
  product = product === VOID ? null : product;
  dragSurfaces = dragSurfaces === VOID ? null : dragSurfaces;
  dragProjectionPoint = dragProjectionPoint === VOID ? null : dragProjectionPoint;
  productStructure = productStructure === VOID ? null : productStructure;
  this.bounds = bounds;
  this.functionalZones = functionalZones;
  this.connectors = connectors;
  this.assembly = assembly;
  this.selectable = selectable;
  this.outlineable = outlineable;
  this.draggable = draggable;
  this.allowedDoorPairs = allowedDoorPairs;
  this.autoAdaptHost = autoAdaptHost;
  this.communicationSize = communicationSize;
  this.door = door;
  this.doorFront = doorFront;
  this.handle = handle;
  this.drawer = drawer;
  this.frame = frame;
  this.leg = leg;
  this.light = light;
  this.outlined = outlined;
  this.propping = propping;
  this.alwaysHangDown = alwaysHangDown;
  this.serializeEntity = serializeEntity;
  this.placementZoneByHeight = placementZoneByHeight;
  this.functionalMargin = functionalMargin;
  this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
  this.visualLightSource = visualLightSource;
  this.model3D = model3D;
  this.product = product;
  this.dragSurfaces = dragSurfaces;
  this.dragProjectionPoint = dragProjectionPoint;
  this.productStructure = productStructure;
  this.meta = null;
  this.g5e_1 = 0;
}
protoOf(ComponentsTemplate).w5j = function (_set____db54di) {
  this.bounds = _set____db54di;
};
protoOf(ComponentsTemplate).x5j = function () {
  return this.bounds;
};
protoOf(ComponentsTemplate).y5j = function (_set____db54di) {
  this.functionalZones = _set____db54di;
};
protoOf(ComponentsTemplate).z5j = function () {
  return this.functionalZones;
};
protoOf(ComponentsTemplate).a5k = function (_set____db54di) {
  this.connectors = _set____db54di;
};
protoOf(ComponentsTemplate).t2c = function () {
  return this.connectors;
};
protoOf(ComponentsTemplate).b5k = function (_set____db54di) {
  this.assembly = _set____db54di;
};
protoOf(ComponentsTemplate).c5k = function () {
  return this.assembly;
};
protoOf(ComponentsTemplate).d5k = function (_set____db54di) {
  this.selectable = _set____db54di;
};
protoOf(ComponentsTemplate).e5k = function () {
  return this.selectable;
};
protoOf(ComponentsTemplate).f5k = function (_set____db54di) {
  this.outlineable = _set____db54di;
};
protoOf(ComponentsTemplate).g5k = function () {
  return this.outlineable;
};
protoOf(ComponentsTemplate).h5k = function (_set____db54di) {
  this.draggable = _set____db54di;
};
protoOf(ComponentsTemplate).i5k = function () {
  return this.draggable;
};
protoOf(ComponentsTemplate).j5k = function (_set____db54di) {
  this.allowedDoorPairs = _set____db54di;
};
protoOf(ComponentsTemplate).k5k = function () {
  return this.allowedDoorPairs;
};
protoOf(ComponentsTemplate).l5k = function (_set____db54di) {
  this.autoAdaptHost = _set____db54di;
};
protoOf(ComponentsTemplate).m5k = function () {
  return this.autoAdaptHost;
};
protoOf(ComponentsTemplate).n5k = function (_set____db54di) {
  this.communicationSize = _set____db54di;
};
protoOf(ComponentsTemplate).o5k = function () {
  return this.communicationSize;
};
protoOf(ComponentsTemplate).p5k = function (_set____db54di) {
  this.door = _set____db54di;
};
protoOf(ComponentsTemplate).q5k = function () {
  return this.door;
};
protoOf(ComponentsTemplate).r5k = function (_set____db54di) {
  this.doorFront = _set____db54di;
};
protoOf(ComponentsTemplate).s5k = function () {
  return this.doorFront;
};
protoOf(ComponentsTemplate).t5k = function (_set____db54di) {
  this.handle = _set____db54di;
};
protoOf(ComponentsTemplate).u5k = function () {
  return this.handle;
};
protoOf(ComponentsTemplate).v5k = function (_set____db54di) {
  this.drawer = _set____db54di;
};
protoOf(ComponentsTemplate).w5k = function () {
  return this.drawer;
};
protoOf(ComponentsTemplate).x5k = function (_set____db54di) {
  this.frame = _set____db54di;
};
protoOf(ComponentsTemplate).y5k = function () {
  return this.frame;
};
protoOf(ComponentsTemplate).z5k = function (_set____db54di) {
  this.leg = _set____db54di;
};
protoOf(ComponentsTemplate).a5l = function () {
  return this.leg;
};
protoOf(ComponentsTemplate).b5l = function (_set____db54di) {
  this.light = _set____db54di;
};
protoOf(ComponentsTemplate).c5l = function () {
  return this.light;
};
protoOf(ComponentsTemplate).d5l = function (_set____db54di) {
  this.outlined = _set____db54di;
};
protoOf(ComponentsTemplate).e5l = function () {
  return this.outlined;
};
protoOf(ComponentsTemplate).f5l = function (_set____db54di) {
  this.propping = _set____db54di;
};
protoOf(ComponentsTemplate).r4a = function () {
  return this.propping;
};
protoOf(ComponentsTemplate).g5l = function (_set____db54di) {
  this.alwaysHangDown = _set____db54di;
};
protoOf(ComponentsTemplate).h5l = function () {
  return this.alwaysHangDown;
};
protoOf(ComponentsTemplate).i5l = function (_set____db54di) {
  this.serializeEntity = _set____db54di;
};
protoOf(ComponentsTemplate).j5l = function () {
  return this.serializeEntity;
};
protoOf(ComponentsTemplate).k5l = function (_set____db54di) {
  this.placementZoneByHeight = _set____db54di;
};
protoOf(ComponentsTemplate).l5l = function () {
  return this.placementZoneByHeight;
};
protoOf(ComponentsTemplate).m5l = function (_set____db54di) {
  this.functionalMargin = _set____db54di;
};
protoOf(ComponentsTemplate).n5l = function () {
  return this.functionalMargin;
};
protoOf(ComponentsTemplate).o5l = function (_set____db54di) {
  this.recommendedInitialPositionFromFloor = _set____db54di;
};
protoOf(ComponentsTemplate).p5l = function () {
  return this.recommendedInitialPositionFromFloor;
};
protoOf(ComponentsTemplate).q5l = function (_set____db54di) {
  this.visualLightSource = _set____db54di;
};
protoOf(ComponentsTemplate).r5l = function () {
  return this.visualLightSource;
};
protoOf(ComponentsTemplate).s5l = function (_set____db54di) {
  this.model3D = _set____db54di;
};
protoOf(ComponentsTemplate).t5l = function () {
  return this.model3D;
};
protoOf(ComponentsTemplate).u5l = function (_set____db54di) {
  this.product = _set____db54di;
};
protoOf(ComponentsTemplate).d5i = function () {
  return this.product;
};
protoOf(ComponentsTemplate).v5l = function (_set____db54di) {
  this.dragSurfaces = _set____db54di;
};
protoOf(ComponentsTemplate).w5l = function () {
  return this.dragSurfaces;
};
protoOf(ComponentsTemplate).x5l = function (_set____db54di) {
  this.dragProjectionPoint = _set____db54di;
};
protoOf(ComponentsTemplate).y5l = function () {
  return this.dragProjectionPoint;
};
protoOf(ComponentsTemplate).z5l = function (_set____db54di) {
  this.productStructure = _set____db54di;
};
protoOf(ComponentsTemplate).a5m = function () {
  return this.productStructure;
};
protoOf(ComponentsTemplate).t5e = function (_set____db54di) {
  this.meta = _set____db54di;
};
protoOf(ComponentsTemplate).u5e = function () {
  return this.meta;
};
protoOf(ComponentsTemplate).inherit = function (extendedComponents) {
  // Inline function 'kotlin.also' call
  var tmp0_safe_receiver = this.bounds;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : inherit(tmp0_safe_receiver, extendedComponents.bounds);
  var tmp = tmp1_elvis_lhs == null ? extendedComponents.bounds : tmp1_elvis_lhs;
  var tmp2_safe_receiver = this.functionalZones;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : inherit(tmp2_safe_receiver, extendedComponents.functionalZones);
  var tmp_0 = tmp3_elvis_lhs == null ? extendedComponents.functionalZones : tmp3_elvis_lhs;
  var tmp4_safe_receiver = this.connectors;
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : inherit_0(tmp4_safe_receiver, extendedComponents.connectors);
  var tmp_1 = tmp5_elvis_lhs == null ? extendedComponents.connectors : tmp5_elvis_lhs;
  var tmp6_safe_receiver = this.assembly;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.inherit(extendedComponents.assembly);
  var tmp_2 = tmp7_elvis_lhs == null ? extendedComponents.assembly : tmp7_elvis_lhs;
  var tmp8_elvis_lhs = this.selectable;
  var tmp_3 = tmp8_elvis_lhs == null ? extendedComponents.selectable : tmp8_elvis_lhs;
  var tmp9_elvis_lhs = this.outlineable;
  var tmp_4 = tmp9_elvis_lhs == null ? extendedComponents.outlineable : tmp9_elvis_lhs;
  var tmp10_elvis_lhs = this.draggable;
  var tmp_5 = tmp10_elvis_lhs == null ? extendedComponents.draggable : tmp10_elvis_lhs;
  var tmp11_elvis_lhs = this.allowedDoorPairs;
  var tmp_6 = tmp11_elvis_lhs == null ? extendedComponents.allowedDoorPairs : tmp11_elvis_lhs;
  var tmp12_elvis_lhs = this.autoAdaptHost;
  var tmp_7 = tmp12_elvis_lhs == null ? extendedComponents.autoAdaptHost : tmp12_elvis_lhs;
  var tmp13_elvis_lhs = this.communicationSize;
  var tmp_8 = tmp13_elvis_lhs == null ? extendedComponents.communicationSize : tmp13_elvis_lhs;
  var tmp14_elvis_lhs = this.door;
  var tmp_9 = tmp14_elvis_lhs == null ? extendedComponents.door : tmp14_elvis_lhs;
  var tmp15_elvis_lhs = this.doorFront;
  var tmp_10 = tmp15_elvis_lhs == null ? extendedComponents.doorFront : tmp15_elvis_lhs;
  var tmp16_elvis_lhs = this.handle;
  var tmp_11 = tmp16_elvis_lhs == null ? extendedComponents.handle : tmp16_elvis_lhs;
  var tmp17_elvis_lhs = this.drawer;
  var tmp_12 = tmp17_elvis_lhs == null ? extendedComponents.drawer : tmp17_elvis_lhs;
  var tmp18_elvis_lhs = this.frame;
  var tmp_13 = tmp18_elvis_lhs == null ? extendedComponents.frame : tmp18_elvis_lhs;
  var tmp19_elvis_lhs = this.leg;
  var tmp_14 = tmp19_elvis_lhs == null ? extendedComponents.leg : tmp19_elvis_lhs;
  var tmp20_elvis_lhs = this.light;
  var tmp_15 = tmp20_elvis_lhs == null ? extendedComponents.light : tmp20_elvis_lhs;
  var tmp21_elvis_lhs = this.outlined;
  var tmp_16 = tmp21_elvis_lhs == null ? extendedComponents.outlined : tmp21_elvis_lhs;
  var tmp22_elvis_lhs = this.propping;
  var tmp_17 = tmp22_elvis_lhs == null ? extendedComponents.propping : tmp22_elvis_lhs;
  var tmp23_elvis_lhs = this.alwaysHangDown;
  var tmp_18 = tmp23_elvis_lhs == null ? extendedComponents.alwaysHangDown : tmp23_elvis_lhs;
  var tmp24_elvis_lhs = this.serializeEntity;
  var tmp_19 = tmp24_elvis_lhs == null ? extendedComponents.serializeEntity : tmp24_elvis_lhs;
  var tmp25_elvis_lhs = this.placementZoneByHeight;
  var tmp_20 = tmp25_elvis_lhs == null ? extendedComponents.placementZoneByHeight : tmp25_elvis_lhs;
  var tmp26_elvis_lhs = this.functionalMargin;
  var tmp_21 = tmp26_elvis_lhs == null ? extendedComponents.functionalMargin : tmp26_elvis_lhs;
  var tmp27_elvis_lhs = this.recommendedInitialPositionFromFloor;
  var tmp_22 = tmp27_elvis_lhs == null ? extendedComponents.recommendedInitialPositionFromFloor : tmp27_elvis_lhs;
  var tmp28_elvis_lhs = this.visualLightSource;
  var tmp_23 = tmp28_elvis_lhs == null ? extendedComponents.visualLightSource : tmp28_elvis_lhs;
  var tmp29_elvis_lhs = this.dragSurfaces;
  var tmp_24 = tmp29_elvis_lhs == null ? extendedComponents.dragSurfaces : tmp29_elvis_lhs;
  var tmp30_elvis_lhs = this.dragProjectionPoint;
  var tmp_25 = tmp30_elvis_lhs == null ? extendedComponents.dragProjectionPoint : tmp30_elvis_lhs;
  var tmp31_safe_receiver = this.productStructure;
  var tmp_26;
  if (tmp31_safe_receiver == null) {
    tmp_26 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.template.ComponentsTemplate.inherit.<anonymous>' call
    tmp_26 = inheritProductStructure(this, tmp31_safe_receiver, extendedComponents.productStructure);
  }
  var tmp32_elvis_lhs = tmp_26;
  var this_0 = new ComponentsTemplate(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, VOID, VOID, tmp_24, tmp_25, tmp32_elvis_lhs == null ? extendedComponents.productStructure : tmp32_elvis_lhs);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.range.dynamic.template.ComponentsTemplate.inherit.<anonymous>' call
  this_0.meta = Companion_getInstance_24().t5j(this.meta, extendedComponents.meta);
  return this_0;
};
protoOf(ComponentsTemplate).equals = function (other) {
  return other === this;
};
protoOf(ComponentsTemplate).hashCode = function () {
  if (this.g5e_1 === 0) {
    var tmp = this;
    var tmp0_safe_receiver = this.communicationSize;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.product;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    tmp.g5e_1 = (tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0) + 1 | 0;
  }
  return this.g5e_1;
};
protoOf(ComponentsTemplate).getPolyhedronForSize = function (size) {
  var tmp0_safe_receiver = this.bounds;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : getPolyhedronForSize(tmp0_safe_receiver, size);
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rf_1;
};
protoOf(ComponentsTemplate).tf = function () {
  return this.bounds;
};
protoOf(ComponentsTemplate).uf = function () {
  return this.functionalZones;
};
protoOf(ComponentsTemplate).m1m = function () {
  return this.connectors;
};
protoOf(ComponentsTemplate).n1m = function () {
  return this.assembly;
};
protoOf(ComponentsTemplate).o1m = function () {
  return this.selectable;
};
protoOf(ComponentsTemplate).p1m = function () {
  return this.outlineable;
};
protoOf(ComponentsTemplate).q1m = function () {
  return this.draggable;
};
protoOf(ComponentsTemplate).l2e = function () {
  return this.allowedDoorPairs;
};
protoOf(ComponentsTemplate).m2e = function () {
  return this.autoAdaptHost;
};
protoOf(ComponentsTemplate).n2e = function () {
  return this.communicationSize;
};
protoOf(ComponentsTemplate).o2e = function () {
  return this.door;
};
protoOf(ComponentsTemplate).p2e = function () {
  return this.doorFront;
};
protoOf(ComponentsTemplate).p2g = function () {
  return this.handle;
};
protoOf(ComponentsTemplate).q2g = function () {
  return this.drawer;
};
protoOf(ComponentsTemplate).b5m = function () {
  return this.frame;
};
protoOf(ComponentsTemplate).c5m = function () {
  return this.leg;
};
protoOf(ComponentsTemplate).d5m = function () {
  return this.light;
};
protoOf(ComponentsTemplate).e5m = function () {
  return this.outlined;
};
protoOf(ComponentsTemplate).f5m = function () {
  return this.propping;
};
protoOf(ComponentsTemplate).g5m = function () {
  return this.alwaysHangDown;
};
protoOf(ComponentsTemplate).h5m = function () {
  return this.serializeEntity;
};
protoOf(ComponentsTemplate).i5m = function () {
  return this.placementZoneByHeight;
};
protoOf(ComponentsTemplate).j5m = function () {
  return this.functionalMargin;
};
protoOf(ComponentsTemplate).k5m = function () {
  return this.recommendedInitialPositionFromFloor;
};
protoOf(ComponentsTemplate).l5m = function () {
  return this.visualLightSource;
};
protoOf(ComponentsTemplate).m5m = function () {
  return this.model3D;
};
protoOf(ComponentsTemplate).n5m = function () {
  return this.product;
};
protoOf(ComponentsTemplate).o5m = function () {
  return this.dragSurfaces;
};
protoOf(ComponentsTemplate).p5m = function () {
  return this.dragProjectionPoint;
};
protoOf(ComponentsTemplate).q5m = function () {
  return this.productStructure;
};
protoOf(ComponentsTemplate).r5m = function (bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure) {
  return new ComponentsTemplate(bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure);
};
protoOf(ComponentsTemplate).copy = function (bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, $super) {
  bounds = bounds === VOID ? this.bounds : bounds;
  functionalZones = functionalZones === VOID ? this.functionalZones : functionalZones;
  connectors = connectors === VOID ? this.connectors : connectors;
  assembly = assembly === VOID ? this.assembly : assembly;
  selectable = selectable === VOID ? this.selectable : selectable;
  outlineable = outlineable === VOID ? this.outlineable : outlineable;
  draggable = draggable === VOID ? this.draggable : draggable;
  allowedDoorPairs = allowedDoorPairs === VOID ? this.allowedDoorPairs : allowedDoorPairs;
  autoAdaptHost = autoAdaptHost === VOID ? this.autoAdaptHost : autoAdaptHost;
  communicationSize = communicationSize === VOID ? this.communicationSize : communicationSize;
  door = door === VOID ? this.door : door;
  doorFront = doorFront === VOID ? this.doorFront : doorFront;
  handle = handle === VOID ? this.handle : handle;
  drawer = drawer === VOID ? this.drawer : drawer;
  frame = frame === VOID ? this.frame : frame;
  leg = leg === VOID ? this.leg : leg;
  light = light === VOID ? this.light : light;
  outlined = outlined === VOID ? this.outlined : outlined;
  propping = propping === VOID ? this.propping : propping;
  alwaysHangDown = alwaysHangDown === VOID ? this.alwaysHangDown : alwaysHangDown;
  serializeEntity = serializeEntity === VOID ? this.serializeEntity : serializeEntity;
  placementZoneByHeight = placementZoneByHeight === VOID ? this.placementZoneByHeight : placementZoneByHeight;
  functionalMargin = functionalMargin === VOID ? this.functionalMargin : functionalMargin;
  recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor === VOID ? this.recommendedInitialPositionFromFloor : recommendedInitialPositionFromFloor;
  visualLightSource = visualLightSource === VOID ? this.visualLightSource : visualLightSource;
  model3D = model3D === VOID ? this.model3D : model3D;
  product = product === VOID ? this.product : product;
  dragSurfaces = dragSurfaces === VOID ? this.dragSurfaces : dragSurfaces;
  dragProjectionPoint = dragProjectionPoint === VOID ? this.dragProjectionPoint : dragProjectionPoint;
  productStructure = productStructure === VOID ? this.productStructure : productStructure;
  return this.r5m(bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure);
};
protoOf(ComponentsTemplate).toString = function () {
  return 'ComponentsTemplate(bounds=' + toString(this.bounds) + ', functionalZones=' + toString(this.functionalZones) + ', connectors=' + toString(this.connectors) + ', assembly=' + toString_0(this.assembly) + ', selectable=' + this.selectable + ', outlineable=' + this.outlineable + ', draggable=' + this.draggable + ', allowedDoorPairs=' + toString(this.allowedDoorPairs) + ', autoAdaptHost=' + toString_0(this.autoAdaptHost) + ', communicationSize=' + toString_0(this.communicationSize) + ', door=' + this.door + ', doorFront=' + this.doorFront + ', handle=' + this.handle + ', drawer=' + this.drawer + ', frame=' + this.frame + ', leg=' + this.leg + ', light=' + toString_0(this.light) + ', outlined=' + this.outlined + ', propping=' + this.propping + ', alwaysHangDown=' + this.alwaysHangDown + ', serializeEntity=' + this.serializeEntity + ', placementZoneByHeight=' + toString_0(this.placementZoneByHeight) + ', functionalMargin=' + toString_0(this.functionalMargin) + ', recommendedInitialPositionFromFloor=' + this.recommendedInitialPositionFromFloor + ', visualLightSource=' + toString_0(this.visualLightSource) + ', model3D=' + toString_0(this.model3D) + ', product=' + toString_0(this.product) + ', dragSurfaces=' + toString_0(this.dragSurfaces) + ', dragProjectionPoint=' + toString_0(this.dragProjectionPoint) + ', productStructure=' + toString(this.productStructure) + ')';
};
function ConnectorItemTemplate$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('name', PrimitiveSerialDescriptor('name', STRING_getInstance()));
  $this$buildClassSerialDescriptor.hm('type', PrimitiveSerialDescriptor('type', STRING_getInstance()));
  $this$buildClassSerialDescriptor.hm('position', PositionTemplateSerializer_getInstance().t5m_1);
  $this$buildClassSerialDescriptor.hm('lastPosition', PositionTemplateSerializer_getInstance().t5m_1);
  $this$buildClassSerialDescriptor.hm('spacing', PrimitiveSerialDescriptor('type', STRING_getInstance()));
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer = serializer(StringCompanionObject_instance);
  var tmp$ret$0 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer);
  $this$buildClassSerialDescriptor.hm('offers', tmp$ret$0.tl());
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer_0 = serializer(StringCompanionObject_instance);
  var tmp$ret$1 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer_0);
  $this$buildClassSerialDescriptor.hm('demands', tmp$ret$1.tl());
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer_1 = serializer(StringCompanionObject_instance);
  var tmp$ret$2 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer_1);
  $this$buildClassSerialDescriptor.hm('tags', tmp$ret$2.tl());
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer_2 = PositionTemplateSerializer_getInstance().z18();
  var tmp$ret$3 = ArraySerializer(getKClass(PositionTemplate), elementSerializer_2);
  $this$buildClassSerialDescriptor.hm('vertices', tmp$ret$3.tl());
  $this$buildClassSerialDescriptor.hm('required', PrimitiveSerialDescriptor('required', BOOLEAN_getInstance()));
  $this$buildClassSerialDescriptor.hm('priority', PrimitiveSerialDescriptor('priority', INT_getInstance()));
  $this$buildClassSerialDescriptor.hm('activationDistance', PrimitiveSerialDescriptor('activationDistance', INT_getInstance()));
  $this$buildClassSerialDescriptor.hm('requireUpwardParent', PrimitiveSerialDescriptor('requireUpwardParent', BOOLEAN_getInstance()));
  $this$buildClassSerialDescriptor.hm('requireDownwardParent', PrimitiveSerialDescriptor('requireDownwardParent', BOOLEAN_getInstance()));
  $this$buildClassSerialDescriptor.hm('rotationDegreeOfFreedom', PrimitiveSerialDescriptor('type', STRING_getInstance()));
  return Unit_instance;
}
function _get_allPositions__bakiw2($this) {
  return $this.m5f_1;
}
function _get_firstPosition__de1tzc($this) {
  return $this.n5f_1;
}
function createConnector($this, type, size) {
  var tmp5_key = $this.name;
  var tmp6_transform = new Transform(Companion_getInstance_5().ZERO, _get_firstPosition__de1tzc($this).rotation);
  var tmp0_safe_receiver = $this.activationDistance;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
  var tmp7_activationDistance = tmp1_elvis_lhs == null ? type === Companion_instance_1.m2b_1 ? Companion_instance_0.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_0.DEFAULT_GUEST_ACTIVATION_DISTANCE : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = $this.priority;
  var tmp8_priority = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp3_subject = $this.rotationDegreeOfFreedom.toUpperCase();
  var tmp;
  if (tmp3_subject === RotationDegreeOfFreedom_NONE_getInstance().toString()) {
    tmp = RotationDegreeOfFreedom_NONE_getInstance().u2_1;
  } else if (tmp3_subject === RotationDegreeOfFreedom_ONE_getInstance().toString()) {
    tmp = RotationDegreeOfFreedom_ONE_getInstance().u2_1;
  } else {
    throw new NotImplementedError($this.rotationDegreeOfFreedom);
  }
  var tmp9_rotationalDegreeOfFreedom = tmp;
  var tmp4_elvis_lhs = $this.required;
  var tmp10_required = tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs;
  var pointConnector = new PointConnector(tmp5_key, type, tmp6_transform, tmp8_priority, tmp7_activationDistance, VOID, VOID, VOID, VOID, VOID, tmp9_rotationalDegreeOfFreedom, tmp10_required);
  return createRepositionedConnector($this, pointConnector, size);
}
function createSeriesConnector($this, type, size) {
  var tmp = Companion_getInstance_5().ZERO;
  var tmp_0 = Companion_getInstance_5().UP;
  var tmp_1 = _get_firstPosition__de1tzc($this).absoluteTransform.rotation;
  var tmp0_elvis_lhs = $this.priority;
  var tmp_2 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp1_safe_receiver = $this.activationDistance;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
  var tmp_3 = tmp2_elvis_lhs == null ? type === Companion_instance_1.m2b_1 ? Companion_instance_0.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_0.DEFAULT_GUEST_ACTIVATION_DISTANCE : tmp2_elvis_lhs;
  var tmp_4 = ensureNotNull($this.spacing);
  var tmp3_elvis_lhs = $this.required;
  var seriesConnector = new PointSeriesConnector($this.name, type, tmp, tmp_0, tmp_1, tmp_2, tmp_3, VOID, VOID, VOID, VOID, VOID, tmp_4, tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
  return createRepositionedConnector($this, seriesConnector, size);
}
function createEdgeConnector($this, type, size) {
  var tmp = Companion_getInstance_5().ZERO;
  var tmp_0 = Companion_getInstance_5().UP;
  var tmp_1 = _get_firstPosition__de1tzc($this).absoluteTransform.rotation;
  var tmp0_elvis_lhs = $this.priority;
  var tmp_2 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp1_safe_receiver = $this.activationDistance;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
  var tmp_3 = tmp2_elvis_lhs == null ? type === Companion_instance_1.m2b_1 ? Companion_instance_0.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_0.DEFAULT_GUEST_ACTIVATION_DISTANCE : tmp2_elvis_lhs;
  var tmp3_elvis_lhs = $this.required;
  var edgeConnector = new EdgeConnector($this.name, type, tmp, tmp_0, tmp_1, tmp_2, tmp_3, VOID, VOID, VOID, VOID, tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
  return createRepositionedConnector($this, edgeConnector, size);
}
function createSurfaceConnector($this, type, size) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = _get_allPositions__bakiw2($this);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.createSurfaceConnector.<anonymous>' call
      if (!element.rotation.equals(Companion_getInstance_3().q2b_1)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    var tmp = Companion_getInstance_25().logger;
    tmp.warn(ConnectorItemTemplate$createSurfaceConnector$lambda);
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [Companion_getInstance_5().LEFT, Companion_getInstance_5().UP, Companion_getInstance_5().RIGHT];
  var tmp0_elvis_lhs = $this.priority;
  var tmp_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp1_safe_receiver = $this.activationDistance;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
  var tmp_2 = tmp2_elvis_lhs == null ? type === Companion_instance_1.m2b_1 ? Companion_instance_0.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_0.DEFAULT_GUEST_ACTIVATION_DISTANCE : tmp2_elvis_lhs;
  var tmp3_elvis_lhs = $this.required;
  var surfaceConnector = new SurfaceConnector($this.name, type, tmp_0, tmp_1, tmp_2, VOID, VOID, VOID, VOID, tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
  var tmp_3 = createRepositionedConnector($this, surfaceConnector, size);
  var tmp4_elvis_lhs = tmp_3 instanceof SurfaceConnector ? tmp_3 : null;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    var message = 'A surface connector cannot not magically transform itself to a non SurfaceConnector';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  surfaceConnector = tmp_4;
  if (surfaceConnector.vertices.length > 3) {
    var vertices = surfaceConnector.vertices;
    var plane = Companion_instance_2.createFromPoints(vertices[0], vertices[1], vertices[2]);
    var inductionVariable_0 = 3;
    var last_0 = _get_allPositions__bakiw2($this).length;
    if (inductionVariable_0 < last_0)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var point = vertices[i];
        if (!plane.contains(point, 0.1)) {
          var tmp_5 = Companion_getInstance_25().logger;
          tmp_5.error(ConnectorItemTemplate$createSurfaceConnector$lambda_0(vertices, plane, point));
        }
      }
       while (inductionVariable_0 < last_0);
  }
  return surfaceConnector;
}
function createRepositionedConnector($this, connector, size) {
  var relativeConnectorInfo = $this.createRelativeConnectorData(size);
  var aabbFromSize = Companion_getInstance_1().fromSize$default(size.vector);
  return Companion_instance_3.c2h(connector, relativeConnectorInfo, aabbFromSize);
}
function addTags($this, connector, tags) {
  if (tags == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tags.length;
    while (inductionVariable < last) {
      var element = tags[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.addTags.<anonymous>' call
      connector.withTag(element);
    }
  }
}
function addConnectorTags($this, connector, comSize, family, templateRef) {
  var tmp0_safe_receiver = $this.demands;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.addConnectorTags.<anonymous>' call
    connector.setDemands(convertMagicLabels($this, tmp0_safe_receiver, comSize, family, templateRef).slice());
  }
  var tmp1_safe_receiver = $this.offers;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.addConnectorTags.<anonymous>' call
    connector.setOffers(convertMagicLabels($this, tmp1_safe_receiver, comSize, family, templateRef).slice());
  }
  if (!($this.requireUpwardParent == null) && $this.requireUpwardParent) {
    connector.withTag(ConnectorTagConstants_instance.w2b_1);
  }
  if (!($this.requireDownwardParent == null) && $this.requireDownwardParent) {
    connector.withTag(ConnectorTagConstants_instance.x2b_1);
  }
  return connector;
}
function convertMagicLabels($this, labels, comSize, family, templateRef) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = labels.length;
  while (inductionVariable < last) {
    var element = labels[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.convertMagicLabels.<anonymous>' call
    switch (element) {
      case 'surface':
        var tmp$ret$0 = null;
        break;
      case 'family':
        tmp$ret$0 = 'family:' + family;
        break;
      case 'id':
        tmp$ret$0 = 'id:' + templateRef;
        break;
      case 'w':
        tmp$ret$0 = 'w:' + numberToInt(comSize.b2y_1);
        break;
      case 'h':
        tmp$ret$0 = 'h:' + numberToInt(comSize.c2y_1);
        break;
      case 'd':
        tmp$ret$0 = 'd:' + numberToInt(comSize.d2y_1);
        break;
      default:
        tmp$ret$0 = element;
        break;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return copyToArray(destination);
}
function Companion_18() {
  Companion_instance_28 = this;
  this.logger = LoggerState_getInstance().g1v('ConnectorItemTemplate');
  var tmp = this;
  tmp.w5m_1 = buildClassSerialDescriptor('ConnectorItemTemplate', [], ConnectorItemTemplate$Companion$descriptor$lambda);
}
protoOf(Companion_18).l1k = function () {
  return this.logger;
};
protoOf(Companion_18).tl = function () {
  return this.w5m_1;
};
protoOf(Companion_18).vl = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.w5m_1;
  var composite = decoder.bp(descriptor);
  // Inline function 'com.ikea.range.dynamic.template.Companion.deserialize.<anonymous>' call
  var name = '';
  var type = 'internal';
  var position = PositionTemplateSerializer_getInstance().IDENTITY;
  var lastPosition = null;
  var spacing = null;
  var offers = null;
  var demands = null;
  var tags = null;
  var vertices = null;
  var required = false;
  var priority = null;
  var activationDistance = null;
  var requireUpwardParent = false;
  var requireDownwardParent = false;
  var rotationDegreeOfFreedom = RotationDegreeOfFreedom_NONE_getInstance().toString();
  loop: while (true) {
    var index = composite.sp(Companion_getInstance_25().w5m_1);
    switch (index) {
      case 0:
        name = composite.lp(Companion_getInstance_25().w5m_1, 0);
        break;
      case 1:
        type = composite.lp(Companion_getInstance_25().w5m_1, 1);
        break;
      case 2:
        position = composite.op(Companion_getInstance_25().w5m_1, 2, PositionTemplateSerializer_getInstance().z18());
        break;
      case 3:
        lastPosition = composite.op(Companion_getInstance_25().w5m_1, 3, PositionTemplateSerializer_getInstance().z18());
        break;
      case 4:
        spacing = composite.jp(Companion_getInstance_25().w5m_1, 4);
        break;
      case 5:
        var tmp = Companion_getInstance_25().w5m_1;
        // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call

        var elementSerializer = serializer(StringCompanionObject_instance);
        var tmp$ret$0 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer);
        offers = composite.op(tmp, 5, tmp$ret$0);
        break;
      case 6:
        var tmp_0 = Companion_getInstance_25().w5m_1;
        // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call

        var elementSerializer_0 = serializer(StringCompanionObject_instance);
        var tmp$ret$1 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer_0);
        demands = composite.op(tmp_0, 6, tmp$ret$1);
        break;
      case 7:
        var tmp_1 = Companion_getInstance_25().w5m_1;
        // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call

        var elementSerializer_1 = serializer(StringCompanionObject_instance);
        var tmp$ret$2 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer_1);
        tags = composite.op(tmp_1, 7, tmp$ret$2);
        break;
      case 8:
        var tmp_2 = Companion_getInstance_25().w5m_1;
        // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call

        var elementSerializer_2 = PositionTemplateSerializer_getInstance().z18();
        var tmp$ret$3 = ArraySerializer(getKClass(PositionTemplate), elementSerializer_2);
        vertices = composite.op(tmp_2, 8, tmp$ret$3);
        break;
      case 9:
        required = composite.dp(Companion_getInstance_25().w5m_1, 9);
        break;
      case 10:
        priority = composite.gp(Companion_getInstance_25().w5m_1, 10);
        break;
      case 11:
        activationDistance = composite.gp(Companion_getInstance_25().w5m_1, 11);
        break;
      case 12:
        requireUpwardParent = composite.dp(Companion_getInstance_25().w5m_1, 12);
        break;
      case 13:
        requireDownwardParent = composite.dp(Companion_getInstance_25().w5m_1, 13);
        break;
      case 14:
        rotationDegreeOfFreedom = composite.lp(Companion_getInstance_25().w5m_1, 14);
        break;
      case -1:
        break loop;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Unexpected index: ' + index;
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  var result = new ConnectorItemTemplate(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, VOID, VOID, required, requireUpwardParent, requireDownwardParent, VOID, rotationDegreeOfFreedom);
  composite.cp(descriptor);
  return result;
};
protoOf(Companion_18).x5m = function (encoder, value) {
  var enc = encoder.bp(this.w5m_1);
  enc.qq(this.w5m_1, 0, value.name);
  enc.qq(this.w5m_1, 1, value.type);
  if (value.vertices == null) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var it = value.position;
    enc.sq(Companion_getInstance_25().w5m_1, 2, PositionTemplateSerializer_getInstance().z18(), it);
    var tmp0_safe_receiver = value.lastPosition;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      enc.sq(Companion_getInstance_25().w5m_1, 3, PositionTemplateSerializer_getInstance().z18(), tmp0_safe_receiver);
    }
    if (value.spacing == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      if (value.spacing > 0.0) {
        enc.oq(Companion_getInstance_25().w5m_1, 4, value.spacing);
      }
    }
  }
  var tmp2_safe_receiver = value.offers;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp = Companion_getInstance_25().w5m_1;
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer = serializer(StringCompanionObject_instance);
    var tmp$ret$3 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer);
    enc.sq(tmp, 5, tmp$ret$3, tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = value.demands;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0 = Companion_getInstance_25().w5m_1;
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer_0 = serializer(StringCompanionObject_instance);
    var tmp$ret$5 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer_0);
    enc.sq(tmp_0, 6, tmp$ret$5, tmp3_safe_receiver);
  }
  var tmp4_safe_receiver = value.tags;
  if (tmp4_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_1 = Companion_getInstance_25().w5m_1;
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer_1 = serializer(StringCompanionObject_instance);
    var tmp$ret$7 = ArraySerializer(PrimitiveClasses_getInstance().nb(), elementSerializer_1);
    enc.sq(tmp_1, 7, tmp$ret$7, tmp4_safe_receiver);
  }
  var tmp5_safe_receiver = value.vertices;
  if (tmp5_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2 = Companion_getInstance_25().w5m_1;
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer_2 = PositionTemplateSerializer_getInstance().z18();
    var tmp$ret$9 = ArraySerializer(getKClass(PositionTemplate), elementSerializer_2);
    enc.sq(tmp_2, 8, tmp$ret$9, tmp5_safe_receiver);
  }
  var tmp6_safe_receiver = value.required;
  if (tmp6_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp6_safe_receiver) {
      enc.iq(Companion_getInstance_25().w5m_1, 9, tmp6_safe_receiver);
    }
  }
  var tmp7_safe_receiver = value.priority;
  if (tmp7_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(tmp7_safe_receiver === 0)) {
      enc.lq(Companion_getInstance_25().w5m_1, 10, tmp7_safe_receiver);
    }
  }
  var tmp8_safe_receiver = value.activationDistance;
  if (tmp8_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (value.type === 'host' && !(tmp8_safe_receiver === 0)) {
      enc.lq(Companion_getInstance_25().w5m_1, 11, tmp8_safe_receiver);
    } else if (value.type === 'guest' && !(tmp8_safe_receiver === 200)) {
      enc.lq(Companion_getInstance_25().w5m_1, 11, tmp8_safe_receiver);
    } else {
      enc.lq(Companion_getInstance_25().w5m_1, 11, tmp8_safe_receiver);
    }
  }
  enc.qq(this.w5m_1, 14, value.rotationDegreeOfFreedom);
  enc.cp(this.w5m_1);
};
protoOf(Companion_18).ul = function (encoder, value) {
  return this.x5m(encoder, value instanceof ConnectorItemTemplate ? value : THROW_CCE());
};
protoOf(Companion_18).z18 = function () {
  return Companion_getInstance_25();
};
var Companion_instance_28;
function Companion_getInstance_25() {
  if (Companion_instance_28 == null)
    new Companion_18();
  return Companion_instance_28;
}
function ConnectorItemTemplate$createSurfaceConnector$lambda() {
  return 'Rotation was specified on one or more vertices that defines a surface. A surface connector will determine its rotation by the normal of the surface, therefor the rotation implicitly specified will be ignored.';
}
function ConnectorItemTemplate$createSurfaceConnector$lambda_0($vertices, $plane, $point) {
  return function () {
    return 'All vertices specified for a surface was not in the same plane ' + $vertices + ' plane ' + $plane.toString() + ', point ' + $point.toString();
  };
}
function ConnectorItemTemplate(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom) {
  Companion_getInstance_25();
  lastPosition = lastPosition === VOID ? null : lastPosition;
  position = position === VOID ? PositionTemplateSerializer_getInstance().IDENTITY : position;
  vertices = vertices === VOID ? null : vertices;
  priority = priority === VOID ? null : priority;
  spacing = spacing === VOID ? null : spacing;
  activationDistance = activationDistance === VOID ? null : activationDistance;
  tags = tags === VOID ? null : tags;
  demands = demands === VOID ? null : demands;
  offers = offers === VOID ? null : offers;
  type = type === VOID ? 'internal' : type;
  axis = axis === VOID ? 'Y' : axis;
  angle = angle === VOID ? 0.0 : angle;
  required = required === VOID ? false : required;
  requireUpwardParent = requireUpwardParent === VOID ? false : requireUpwardParent;
  requireDownwardParent = requireDownwardParent === VOID ? false : requireDownwardParent;
  sourceTemplateId = sourceTemplateId === VOID ? '' : sourceTemplateId;
  rotationDegreeOfFreedom = rotationDegreeOfFreedom === VOID ? RotationDegreeOfFreedom_NONE_getInstance().toString() : rotationDegreeOfFreedom;
  this.lastPosition = lastPosition;
  this.name = name;
  this.position = position;
  this.vertices = vertices;
  this.priority = priority;
  this.spacing = spacing;
  this.activationDistance = activationDistance;
  this.tags = tags;
  this.demands = demands;
  this.offers = offers;
  this.type = type;
  this.axis = axis;
  this.angle = angle;
  this.required = required;
  this.requireUpwardParent = requireUpwardParent;
  this.requireDownwardParent = requireDownwardParent;
  this.sourceTemplateId = sourceTemplateId;
  this.rotationDegreeOfFreedom = rotationDegreeOfFreedom;
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.m5f_1 = [];
  this.n5f_1 = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()));
  var tmp_0 = this;
  var tmp_1;
  if (!(this.vertices == null)) {
    tmp_1 = this.vertices;
  } else {
    // Inline function 'kotlin.collections.mutableListOf' call
    var mutablePositions = ArrayList_init_$Create$_0();
    mutablePositions.h(this.position);
    if (!(this.lastPosition == null)) {
      mutablePositions.h(this.lastPosition);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_1 = copyToArray(mutablePositions);
  }
  tmp_0.m5f_1 = tmp_1;
  var tmp_2 = this;
  var tmp0_elvis_lhs = firstOrNull(this.m5f_1);
  var tmp_3;
  if (tmp0_elvis_lhs == null) {
    var message = 'IllegalState: A connector requires position or vertexPositions';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_3 = tmp0_elvis_lhs;
  }
  tmp_2.n5f_1 = tmp_3;
  this.o5f_1 = 0;
}
protoOf(ConnectorItemTemplate).y5m = function () {
  return this.lastPosition;
};
protoOf(ConnectorItemTemplate).v2 = function () {
  return this.name;
};
protoOf(ConnectorItemTemplate).f2w = function () {
  return this.position;
};
protoOf(ConnectorItemTemplate).d2i = function () {
  return this.vertices;
};
protoOf(ConnectorItemTemplate).n28 = function () {
  return this.priority;
};
protoOf(ConnectorItemTemplate).z5m = function () {
  return this.spacing;
};
protoOf(ConnectorItemTemplate).h2b = function () {
  return this.activationDistance;
};
protoOf(ConnectorItemTemplate).v2c = function () {
  return this.tags;
};
protoOf(ConnectorItemTemplate).a5n = function () {
  return this.demands;
};
protoOf(ConnectorItemTemplate).q3l = function () {
  return this.offers;
};
protoOf(ConnectorItemTemplate).w2a = function () {
  return this.type;
};
protoOf(ConnectorItemTemplate).p2u = function () {
  return this.axis;
};
protoOf(ConnectorItemTemplate).q2u = function () {
  return this.angle;
};
protoOf(ConnectorItemTemplate).x2a = function () {
  return this.required;
};
protoOf(ConnectorItemTemplate).b5n = function () {
  return this.requireUpwardParent;
};
protoOf(ConnectorItemTemplate).c5n = function () {
  return this.requireDownwardParent;
};
protoOf(ConnectorItemTemplate).n5j = function (_set____db54di) {
  this.sourceTemplateId = _set____db54di;
};
protoOf(ConnectorItemTemplate).o5j = function () {
  return this.sourceTemplateId;
};
protoOf(ConnectorItemTemplate).d5n = function () {
  return this.rotationDegreeOfFreedom;
};
protoOf(ConnectorItemTemplate).isHost = function () {
  return this.type === 'host';
};
protoOf(ConnectorItemTemplate).isRelativeToBounds = function () {
  return _get_firstPosition__de1tzc(this).origin.kotlinRelativeTo.equals(OriginRelativeTo_BOUND_getInstance());
};
protoOf(ConnectorItemTemplate).getConnectorForSize = function (size, applyLabels) {
  var tmp;
  switch (this.type) {
    case 'guest':
      tmp = createConnector(this, Companion_instance_1.l2b_1, size);
      break;
    case 'host':
      tmp = !(this.vertices == null) ? createSurfaceConnector(this, Companion_instance_1.m2b_1, size) : !(this.lastPosition == null) && !(this.spacing == null) ? createSeriesConnector(this, Companion_instance_1.m2b_1, size) : !(this.lastPosition == null) && this.spacing == null ? createEdgeConnector(this, Companion_instance_1.m2b_1, size) : createConnector(this, Companion_instance_1.m2b_1, size);
      break;
    case 'align':
      tmp = this.lastPosition == null ? createConnector(this, Companion_instance_1.n2b_1, size) : this.spacing == null ? createEdgeConnector(this, Companion_instance_1.n2b_1, size) : createSeriesConnector(this, Companion_instance_1.n2b_1, size);
      break;
    case 'internal':
      tmp = createConnector(this, Companion_instance_1.o2b_1, size);
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Connection type ' + this.type + ' not implemented';
      throw IllegalStateException_init_$Create$(toString(message));
  }
  var connector = tmp;
  applyLabels(connector);
  addTags(this, connector, this.tags);
  return connector;
};
protoOf(ConnectorItemTemplate).applyMagicLabels = function (connector, comSize, family, templateRef) {
  addConnectorTags(this, connector, comSize, family, templateRef);
};
protoOf(ConnectorItemTemplate).createRelativeConnectorData = function (size) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = _get_allPositions__bakiw2(this);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.createRelativeConnectorData.<anonymous>' call
    var position = item.relativeTransform.getPosition(size);
    var tmp$ret$0 = new RelativeBoxOffset(item.origin.relation, position);
    destination.h(tmp$ret$0);
  }
  var relativePositions = copyToArray(destination);
  return new RelativeConnectorData(this.name, relativePositions);
};
protoOf(ConnectorItemTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ConnectorItemTemplate))
    THROW_CCE();
  if (!(this.name === other.name))
    return false;
  if (!this.position.equals(other.position))
    return false;
  return true;
};
protoOf(ConnectorItemTemplate).hashCode = function () {
  if (this.o5f_1 === 0) {
    this.o5f_1 = imul(31, getStringHashCode(this.name)) + this.position.hashCode() | 0;
  }
  return this.o5f_1;
};
protoOf(ConnectorItemTemplate).tf = function () {
  return this.lastPosition;
};
protoOf(ConnectorItemTemplate).uf = function () {
  return this.name;
};
protoOf(ConnectorItemTemplate).m1m = function () {
  return this.position;
};
protoOf(ConnectorItemTemplate).n1m = function () {
  return this.vertices;
};
protoOf(ConnectorItemTemplate).o1m = function () {
  return this.priority;
};
protoOf(ConnectorItemTemplate).p1m = function () {
  return this.spacing;
};
protoOf(ConnectorItemTemplate).q1m = function () {
  return this.activationDistance;
};
protoOf(ConnectorItemTemplate).l2e = function () {
  return this.tags;
};
protoOf(ConnectorItemTemplate).m2e = function () {
  return this.demands;
};
protoOf(ConnectorItemTemplate).n2e = function () {
  return this.offers;
};
protoOf(ConnectorItemTemplate).o2e = function () {
  return this.type;
};
protoOf(ConnectorItemTemplate).p2e = function () {
  return this.axis;
};
protoOf(ConnectorItemTemplate).p2g = function () {
  return this.angle;
};
protoOf(ConnectorItemTemplate).q2g = function () {
  return this.required;
};
protoOf(ConnectorItemTemplate).b5m = function () {
  return this.requireUpwardParent;
};
protoOf(ConnectorItemTemplate).c5m = function () {
  return this.requireDownwardParent;
};
protoOf(ConnectorItemTemplate).d5m = function () {
  return this.sourceTemplateId;
};
protoOf(ConnectorItemTemplate).e5m = function () {
  return this.rotationDegreeOfFreedom;
};
protoOf(ConnectorItemTemplate).e5n = function (lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom) {
  return new ConnectorItemTemplate(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom);
};
protoOf(ConnectorItemTemplate).copy = function (lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom, $super) {
  lastPosition = lastPosition === VOID ? this.lastPosition : lastPosition;
  name = name === VOID ? this.name : name;
  position = position === VOID ? this.position : position;
  vertices = vertices === VOID ? this.vertices : vertices;
  priority = priority === VOID ? this.priority : priority;
  spacing = spacing === VOID ? this.spacing : spacing;
  activationDistance = activationDistance === VOID ? this.activationDistance : activationDistance;
  tags = tags === VOID ? this.tags : tags;
  demands = demands === VOID ? this.demands : demands;
  offers = offers === VOID ? this.offers : offers;
  type = type === VOID ? this.type : type;
  axis = axis === VOID ? this.axis : axis;
  angle = angle === VOID ? this.angle : angle;
  required = required === VOID ? this.required : required;
  requireUpwardParent = requireUpwardParent === VOID ? this.requireUpwardParent : requireUpwardParent;
  requireDownwardParent = requireDownwardParent === VOID ? this.requireDownwardParent : requireDownwardParent;
  sourceTemplateId = sourceTemplateId === VOID ? this.sourceTemplateId : sourceTemplateId;
  rotationDegreeOfFreedom = rotationDegreeOfFreedom === VOID ? this.rotationDegreeOfFreedom : rotationDegreeOfFreedom;
  return this.e5n(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom);
};
protoOf(ConnectorItemTemplate).toString = function () {
  return 'ConnectorItemTemplate(lastPosition=' + toString_0(this.lastPosition) + ', name=' + this.name + ', position=' + this.position.toString() + ', vertices=' + toString(this.vertices) + ', priority=' + this.priority + ', spacing=' + this.spacing + ', activationDistance=' + this.activationDistance + ', tags=' + toString(this.tags) + ', demands=' + toString(this.demands) + ', offers=' + toString(this.offers) + ', type=' + this.type + ', axis=' + this.axis + ', angle=' + this.angle + ', required=' + this.required + ', requireUpwardParent=' + this.requireUpwardParent + ', requireDownwardParent=' + this.requireDownwardParent + ', sourceTemplateId=' + this.sourceTemplateId + ', rotationDegreeOfFreedom=' + this.rotationDegreeOfFreedom + ')';
};
function getConnectorsForSize(_this__u8e3s4, size, comSize, family, templateRef) {
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (_this__u8e3s4.length === 0) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(_this__u8e3s4.length);
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var item = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.getConnectorsForSize.<anonymous>' call
      var tmp$ret$2 = item.getConnectorForSize(size, getConnectorsForSize$lambda(item, comSize, family, templateRef));
      destination.h(tmp$ret$2);
    }
    tmp = copyToArray(destination);
  }
  return tmp;
}
function inherit_0(_this__u8e3s4, extendedConnectors) {
  var tmp;
  if (extendedConnectors == null) {
    tmp = _this__u8e3s4;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = extendedConnectors.length;
    while (inductionVariable < last) {
      var element = extendedConnectors[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = _this__u8e3s4.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = _this__u8e3s4[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>.<anonymous>' call
          if (element_0.name === element.name) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_1(_this__u8e3s4, destination);
  }
  return tmp;
}
function getConnectorsForSize$lambda($connectorItem, $comSize, $family, $templateRef) {
  return function (it) {
    $connectorItem.applyMagicLabels(it, $comSize, $family, $templateRef);
    return Unit_instance;
  };
}
function calculateAxis($this, max, min, length, maxLength) {
  return isNaN_0(max) && isNaN_0(min) ? 0.0 : isNaN_0(max) ? -maxLength / 2.0 + length / 2.0 + min : maxLength / 2.0 - length / 2.0 - max;
}
function Dimension$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('width', PrimitiveSerialDescriptor('width', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('left', PrimitiveSerialDescriptor('left', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('right', PrimitiveSerialDescriptor('right', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('height', PrimitiveSerialDescriptor('height', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('top', PrimitiveSerialDescriptor('top', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('bottom', PrimitiveSerialDescriptor('bottom', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('depth', PrimitiveSerialDescriptor('depth', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('front', PrimitiveSerialDescriptor('front', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('back', PrimitiveSerialDescriptor('back', DOUBLE_getInstance()));
  return Unit_instance;
}
function Companion_19() {
  Companion_instance_29 = this;
  var tmp = this;
  tmp.d5j_1 = buildClassSerialDescriptor('Dimension', [], Dimension$Companion$descriptor$lambda);
}
protoOf(Companion_19).tl = function () {
  return this.d5j_1;
};
protoOf(Companion_19).vl = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.d5j_1;
  var composite = decoder.bp(descriptor);
  // Inline function 'com.ikea.range.dynamic.template.Companion.deserialize.<anonymous>' call
  var width = NaN;
  var left = NaN;
  var right = NaN;
  var height = NaN;
  var top = NaN;
  var bottom = NaN;
  var depth = NaN;
  var front = NaN;
  var back = NaN;
  loop: while (true) {
    var index = composite.sp(Companion_getInstance_26().d5j_1);
    switch (index) {
      case 0:
        width = composite.jp(Companion_getInstance_26().d5j_1, 0);
        break;
      case 1:
        left = composite.jp(Companion_getInstance_26().d5j_1, 1);
        break;
      case 2:
        right = composite.jp(Companion_getInstance_26().d5j_1, 2);
        break;
      case 3:
        height = composite.jp(Companion_getInstance_26().d5j_1, 3);
        break;
      case 4:
        top = composite.jp(Companion_getInstance_26().d5j_1, 4);
        break;
      case 5:
        bottom = composite.jp(Companion_getInstance_26().d5j_1, 5);
        break;
      case 6:
        depth = composite.jp(Companion_getInstance_26().d5j_1, 6);
        break;
      case 7:
        front = composite.jp(Companion_getInstance_26().d5j_1, 7);
        break;
      case 8:
        back = composite.jp(Companion_getInstance_26().d5j_1, 8);
        break;
      case -1:
        break loop;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Unexpected index: ' + index;
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  if (isNaN_0(width) && isNaN_0(left))
    left = 0.0;
  if (isNaN_0(width) && isNaN_0(right))
    right = 0.0;
  if (isNaN_0(height) && isNaN_0(top))
    top = 0.0;
  if (isNaN_0(height) && isNaN_0(bottom))
    bottom = 0.0;
  if (isNaN_0(depth) && isNaN_0(front))
    front = 0.0;
  if (isNaN_0(depth) && isNaN_0(back))
    back = 0.0;
  var result = new DynamicRangeDimension(back, bottom, depth, front, height, left, right, top, width);
  composite.cp(descriptor);
  return result;
};
protoOf(Companion_19).f5n = function (encoder, value) {
  var enc = encoder.bp(this.d5j_1);
  if (!isNaN_0(value.width)) {
    enc.oq(this.d5j_1, 0, value.width);
  }
  if (!isNaN_0(value.left)) {
    enc.oq(this.d5j_1, 1, value.left);
  }
  if (!isNaN_0(value.right)) {
    enc.oq(this.d5j_1, 2, value.right);
  }
  if (!isNaN_0(value.height)) {
    enc.oq(this.d5j_1, 3, value.height);
  }
  if (!isNaN_0(value.top)) {
    enc.oq(this.d5j_1, 4, value.top);
  }
  if (!isNaN_0(value.bottom)) {
    enc.oq(this.d5j_1, 5, value.bottom);
  }
  if (!isNaN_0(value.depth)) {
    enc.oq(this.d5j_1, 6, value.depth);
  }
  if (!isNaN_0(value.front)) {
    enc.oq(this.d5j_1, 7, value.front);
  }
  if (!isNaN_0(value.back)) {
    enc.oq(this.d5j_1, 8, value.back);
  }
  enc.cp(this.d5j_1);
};
protoOf(Companion_19).ul = function (encoder, value) {
  return this.f5n(encoder, value instanceof DynamicRangeDimension ? value : THROW_CCE());
};
protoOf(Companion_19).z18 = function () {
  return Companion_getInstance_26();
};
var Companion_instance_29;
function Companion_getInstance_26() {
  if (Companion_instance_29 == null)
    new Companion_19();
  return Companion_instance_29;
}
function Dimension$lambda(this$0) {
  return function () {
    return "Properties 'width' (" + this$0.width + "), 'left' (" + this$0.left + ") and 'right' (" + this$0.right + ') are conflicting';
  };
}
function Dimension$lambda_0(this$0) {
  return function () {
    return "Properties 'height' (" + this$0.height + "), 'top' (" + this$0.top + ") and 'bottom' (" + this$0.bottom + ') are conflicting';
  };
}
function Dimension$lambda_1(this$0) {
  return function () {
    return "Properties 'depth' (" + this$0.depth + "), 'front' (" + this$0.front + ") and 'back' (" + this$0.back + ') are conflicting';
  };
}
function DynamicRangeDimension(back, bottom, depth, front, height, left, right, top, width) {
  Companion_getInstance_26();
  back = back === VOID ? NaN : back;
  bottom = bottom === VOID ? NaN : bottom;
  depth = depth === VOID ? NaN : depth;
  front = front === VOID ? NaN : front;
  height = height === VOID ? NaN : height;
  left = left === VOID ? NaN : left;
  right = right === VOID ? NaN : right;
  top = top === VOID ? NaN : top;
  width = width === VOID ? NaN : width;
  this.back = back;
  this.bottom = bottom;
  this.depth = depth;
  this.front = front;
  this.height = height;
  this.left = left;
  this.right = right;
  this.top = top;
  this.width = width;
  this.g5n_1 = LoggerState_getInstance().g1v('Dimension');
  if (!isNaN_0(this.width) && !isNaN_0(this.left) && !isNaN_0(this.right)) {
    this.g5n_1.warn(Dimension$lambda(this));
  }
  if (!isNaN_0(this.height) && !isNaN_0(this.top) && !isNaN_0(this.bottom)) {
    this.g5n_1.warn(Dimension$lambda_0(this));
  }
  if (!isNaN_0(this.depth) && !isNaN_0(this.front) && !isNaN_0(this.back)) {
    this.g5n_1.warn(Dimension$lambda_1(this));
  }
}
protoOf(DynamicRangeDimension).f2v = function () {
  return this.back;
};
protoOf(DynamicRangeDimension).d2v = function () {
  return this.bottom;
};
protoOf(DynamicRangeDimension).v2u = function () {
  return this.depth;
};
protoOf(DynamicRangeDimension).g2v = function () {
  return this.front;
};
protoOf(DynamicRangeDimension).u2u = function () {
  return this.height;
};
protoOf(DynamicRangeDimension).e2v = function () {
  return this.left;
};
protoOf(DynamicRangeDimension).c2v = function () {
  return this.right;
};
protoOf(DynamicRangeDimension).b2v = function () {
  return this.top;
};
protoOf(DynamicRangeDimension).t2u = function () {
  return this.width;
};
protoOf(DynamicRangeDimension).getPolyhedronForSize = function (size) {
  var w = isNaN_0(this.width) ? size.b2y_1 - this.right - this.left : this.width;
  var h = isNaN_0(this.height) ? size.c2y_1 - this.top - this.bottom : this.height;
  var d = isNaN_0(this.depth) ? size.d2y_1 - this.back - this.front : this.depth;
  var x = calculateAxis(Companion_getInstance_26(), this.right, this.left, w, size.b2y_1);
  var y = calculateAxis(Companion_getInstance_26(), this.top, this.bottom, h, size.c2y_1);
  var z = -calculateAxis(Companion_getInstance_26(), this.back, this.front, d, size.d2y_1);
  return fromSizeAndCenter(new Vector(w, h, d), new Vector(x, y, z));
};
protoOf(DynamicRangeDimension).clone = function () {
  return this.copy();
};
protoOf(DynamicRangeDimension).tf = function () {
  return this.back;
};
protoOf(DynamicRangeDimension).uf = function () {
  return this.bottom;
};
protoOf(DynamicRangeDimension).m1m = function () {
  return this.depth;
};
protoOf(DynamicRangeDimension).n1m = function () {
  return this.front;
};
protoOf(DynamicRangeDimension).o1m = function () {
  return this.height;
};
protoOf(DynamicRangeDimension).p1m = function () {
  return this.left;
};
protoOf(DynamicRangeDimension).q1m = function () {
  return this.right;
};
protoOf(DynamicRangeDimension).l2e = function () {
  return this.top;
};
protoOf(DynamicRangeDimension).m2e = function () {
  return this.width;
};
protoOf(DynamicRangeDimension).h5n = function (back, bottom, depth, front, height, left, right, top, width) {
  return new DynamicRangeDimension(back, bottom, depth, front, height, left, right, top, width);
};
protoOf(DynamicRangeDimension).copy = function (back, bottom, depth, front, height, left, right, top, width, $super) {
  back = back === VOID ? this.back : back;
  bottom = bottom === VOID ? this.bottom : bottom;
  depth = depth === VOID ? this.depth : depth;
  front = front === VOID ? this.front : front;
  height = height === VOID ? this.height : height;
  left = left === VOID ? this.left : left;
  right = right === VOID ? this.right : right;
  top = top === VOID ? this.top : top;
  width = width === VOID ? this.width : width;
  return this.h5n(back, bottom, depth, front, height, left, right, top, width);
};
protoOf(DynamicRangeDimension).toString = function () {
  return 'Dimension(back=' + this.back + ', bottom=' + this.bottom + ', depth=' + this.depth + ', front=' + this.front + ', height=' + this.height + ', left=' + this.left + ', right=' + this.right + ', top=' + this.top + ', width=' + this.width + ')';
};
protoOf(DynamicRangeDimension).hashCode = function () {
  var result = getNumberHashCode(this.back);
  result = imul(result, 31) + getNumberHashCode(this.bottom) | 0;
  result = imul(result, 31) + getNumberHashCode(this.depth) | 0;
  result = imul(result, 31) + getNumberHashCode(this.front) | 0;
  result = imul(result, 31) + getNumberHashCode(this.height) | 0;
  result = imul(result, 31) + getNumberHashCode(this.left) | 0;
  result = imul(result, 31) + getNumberHashCode(this.right) | 0;
  result = imul(result, 31) + getNumberHashCode(this.top) | 0;
  result = imul(result, 31) + getNumberHashCode(this.width) | 0;
  return result;
};
protoOf(DynamicRangeDimension).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DynamicRangeDimension))
    return false;
  var tmp0_other_with_cast = other instanceof DynamicRangeDimension ? other : THROW_CCE();
  if (!equals(this.back, tmp0_other_with_cast.back))
    return false;
  if (!equals(this.bottom, tmp0_other_with_cast.bottom))
    return false;
  if (!equals(this.depth, tmp0_other_with_cast.depth))
    return false;
  if (!equals(this.front, tmp0_other_with_cast.front))
    return false;
  if (!equals(this.height, tmp0_other_with_cast.height))
    return false;
  if (!equals(this.left, tmp0_other_with_cast.left))
    return false;
  if (!equals(this.right, tmp0_other_with_cast.right))
    return false;
  if (!equals(this.top, tmp0_other_with_cast.top))
    return false;
  if (!equals(this.width, tmp0_other_with_cast.width))
    return false;
  return true;
};
function get_logger() {
  _init_properties_DragSurfaceTemplate_kt__pafc5d();
  return logger;
}
var logger;
function createPolyhedronFromVertices($this, vertices, size) {
  var aabbFromSize = Companion_getInstance_1().fromSize$default(size.vector);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(vertices.length);
  var inductionVariable = 0;
  var last = vertices.length;
  while (inductionVariable < last) {
    var item = vertices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.createPolyhedronFromVertices.<anonymous>' call
    var position = item.relativeTransform.getPosition(size);
    var tmp$ret$0 = new RelativeBoxOffset(item.origin.relation, position);
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.createPolyhedronFromVertices.<anonymous>' call
    var tmp$ret$3 = item_0.applyToBox(aabbFromSize);
    destination_0.h(tmp$ret$3);
  }
  var absoluteVertices = copyToArray(destination_0);
  return Companion_getInstance_4().i3c(absoluteVertices);
}
function Companion_20() {
  Companion_instance_30 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i5n_1 = [null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().nb(), StringSerializer_getInstance()), new ReferenceArraySerializer(getKClass(PositionTemplate), PositionTemplateSerializer_getInstance())];
}
protoOf(Companion_20).z18 = function () {
  return $serializer_getInstance_13();
};
var Companion_instance_30;
function Companion_getInstance_27() {
  if (Companion_instance_30 == null)
    new Companion_20();
  return Companion_instance_30;
}
function $serializer_10() {
  $serializer_instance_10 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.DragSurfaceTemplate', this, 5);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('type', true);
  tmp0_serialDesc.lw('dimension', true);
  tmp0_serialDesc.lw('connectors', true);
  tmp0_serialDesc.lw('vertices', true);
  this.j5n_1 = tmp0_serialDesc;
}
protoOf($serializer_10).k5n = function (encoder, value) {
  var tmp0_desc = this.j5n_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_27().i5n_1;
  tmp1_output.qq(tmp0_desc, 0, value.id);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.type === 'box')) {
    tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.dimension == null)) {
    tmp1_output.uq(tmp0_desc, 2, Companion_getInstance_26(), value.dimension);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.connectors == null)) {
    tmp1_output.uq(tmp0_desc, 3, tmp2_cached[3], value.connectors);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.vertices == null)) {
    tmp1_output.uq(tmp0_desc, 4, tmp2_cached[4], value.vertices);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_10).ul = function (encoder, value) {
  return this.k5n(encoder, value instanceof DragSurfaceTemplate ? value : THROW_CCE());
};
protoOf($serializer_10).vl = function (decoder) {
  var tmp0_desc = this.j5n_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.bp(tmp0_desc);
  var tmp10_cached = Companion_getInstance_27().i5n_1;
  if (tmp9_input.rp()) {
    tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.pp(tmp0_desc, 2, Companion_getInstance_26(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.pp(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.pp(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.pp(tmp0_desc, 2, Companion_getInstance_26(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.pp(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.pp(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.cp(tmp0_desc);
  return DragSurfaceTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_10).tl = function () {
  return this.j5n_1;
};
protoOf($serializer_10).ex = function () {
  var tmp0_cached = Companion_getInstance_27().i5n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(Companion_getInstance_26()), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4])];
};
var $serializer_instance_10;
function $serializer_getInstance_13() {
  if ($serializer_instance_10 == null)
    new $serializer_10();
  return $serializer_instance_10;
}
function DragSurfaceTemplate_init_$Init$(seen0, id, type, dimension, connectors, vertices, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_13().j5n_1);
  }
  $this.id = id;
  if (0 === (seen0 & 2))
    $this.type = 'box';
  else
    $this.type = type;
  if (0 === (seen0 & 4))
    $this.dimension = null;
  else
    $this.dimension = dimension;
  if (0 === (seen0 & 8))
    $this.connectors = null;
  else
    $this.connectors = connectors;
  if (0 === (seen0 & 16))
    $this.vertices = null;
  else
    $this.vertices = vertices;
  return $this;
}
function DragSurfaceTemplate_init_$Create$(seen0, id, type, dimension, connectors, vertices, serializationConstructorMarker) {
  return DragSurfaceTemplate_init_$Init$(seen0, id, type, dimension, connectors, vertices, serializationConstructorMarker, objectCreate(protoOf(DragSurfaceTemplate)));
}
function DragSurfaceTemplate$generateDragSurface$lambda() {
  return 'No vertices was specified for type=surface';
}
function DragSurfaceTemplate$generateDragSurface$lambda_0(this$0) {
  return function () {
    return 'Unsupported type ' + this$0.type;
  };
}
function DragSurfaceTemplate(id, type, dimension, connectors, vertices) {
  Companion_getInstance_27();
  type = type === VOID ? 'box' : type;
  dimension = dimension === VOID ? null : dimension;
  connectors = connectors === VOID ? null : connectors;
  vertices = vertices === VOID ? null : vertices;
  this.id = id;
  this.type = type;
  this.dimension = dimension;
  this.connectors = connectors;
  this.vertices = vertices;
}
protoOf(DragSurfaceTemplate).n1s = function () {
  return this.id;
};
protoOf(DragSurfaceTemplate).w2a = function () {
  return this.type;
};
protoOf(DragSurfaceTemplate).k5j = function () {
  return this.dimension;
};
protoOf(DragSurfaceTemplate).t2c = function () {
  return this.connectors;
};
protoOf(DragSurfaceTemplate).d2i = function () {
  return this.vertices;
};
protoOf(DragSurfaceTemplate).generateDragSurface = function (size) {
  var tmp;
  switch (this.type) {
    case 'box':
      var tmp_0;
      if (this.dimension == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
        tmp_0 = this.dimension.getPolyhedronForSize(size);
      }

      var tmp2_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp2_elvis_lhs == null) {
        var tmp3_width = size.b2y_1;
        var tmp4_height = size.c2y_1;
        var tmp5_depth = size.d2y_1;
        tmp_1 = (new DynamicRangeDimension(VOID, VOID, tmp5_depth, VOID, tmp4_height, VOID, VOID, VOID, tmp3_width)).getPolyhedronForSize(size);
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }

      tmp = tmp_1;
      break;
    case 'surface':
      var tmp$ret$5;
      $l$block: {
        // Inline function 'com.ikea.core.utils.orElse' call
        var tmp_2;
        if (this.vertices == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
          tmp_2 = createPolyhedronFromVertices(this, this.vertices, size);
        }
        var this_0 = tmp_2;
        if (this_0 == null) {
          // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
          var tmp_3 = get_logger();
          tmp_3.error(DragSurfaceTemplate$generateDragSurface$lambda);
          tmp$ret$5 = null;
          break $l$block;
        }
        tmp$ret$5 = this_0;
      }

      tmp = tmp$ret$5;
      break;
    default:
      var tmp_4 = get_logger();
      tmp_4.error(DragSurfaceTemplate$generateDragSurface$lambda_0(this));
      tmp = null;
      break;
  }
  var polyhedron = tmp;
  var tmp_5;
  if (polyhedron == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
    tmp_5 = new DragSurface(polyhedron, this.connectors);
  }
  return tmp_5;
};
protoOf(DragSurfaceTemplate).tf = function () {
  return this.id;
};
protoOf(DragSurfaceTemplate).uf = function () {
  return this.type;
};
protoOf(DragSurfaceTemplate).m1m = function () {
  return this.dimension;
};
protoOf(DragSurfaceTemplate).n1m = function () {
  return this.connectors;
};
protoOf(DragSurfaceTemplate).o1m = function () {
  return this.vertices;
};
protoOf(DragSurfaceTemplate).l5n = function (id, type, dimension, connectors, vertices) {
  return new DragSurfaceTemplate(id, type, dimension, connectors, vertices);
};
protoOf(DragSurfaceTemplate).copy = function (id, type, dimension, connectors, vertices, $super) {
  id = id === VOID ? this.id : id;
  type = type === VOID ? this.type : type;
  dimension = dimension === VOID ? this.dimension : dimension;
  connectors = connectors === VOID ? this.connectors : connectors;
  vertices = vertices === VOID ? this.vertices : vertices;
  return this.l5n(id, type, dimension, connectors, vertices);
};
protoOf(DragSurfaceTemplate).toString = function () {
  return 'DragSurfaceTemplate(id=' + this.id + ', type=' + this.type + ', dimension=' + toString_0(this.dimension) + ', connectors=' + toString(this.connectors) + ', vertices=' + toString(this.vertices) + ')';
};
protoOf(DragSurfaceTemplate).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + (this.type == null ? 0 : getStringHashCode(this.type)) | 0;
  result = imul(result, 31) + (this.dimension == null ? 0 : this.dimension.hashCode()) | 0;
  result = imul(result, 31) + (this.connectors == null ? 0 : hashCode(this.connectors)) | 0;
  result = imul(result, 31) + (this.vertices == null ? 0 : hashCode(this.vertices)) | 0;
  return result;
};
protoOf(DragSurfaceTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DragSurfaceTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof DragSurfaceTemplate ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.type == tmp0_other_with_cast.type))
    return false;
  if (!equals(this.dimension, tmp0_other_with_cast.dimension))
    return false;
  if (!equals(this.connectors, tmp0_other_with_cast.connectors))
    return false;
  if (!equals(this.vertices, tmp0_other_with_cast.vertices))
    return false;
  return true;
};
function CustomSerializer_1() {
  CustomSerializer_instance_1 = this;
  var tmp = this;
  // Inline function 'kotlinx.serialization.descriptors.listSerialDescriptor' call
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer_0(createKType(getKClass(DragSurfaceTemplate), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_0, KSerializer) ? this_0 : THROW_CCE();
  tmp.m5n_1 = listSerialDescriptor(tmp$ret$1.tl());
}
protoOf(CustomSerializer_1).tl = function () {
  return this.m5n_1;
};
protoOf(CustomSerializer_1).vl = function (decoder) {
  try {
    var sameAsCollider = decoder.oo();
    return new DragSurfacesTemplate(sameAsCollider);
  } catch ($p) {
    if ($p instanceof SerializationException) {
      var e = $p;
      // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
      var descriptor = this.m5n_1;
      var composite = decoder.bp(descriptor);
      // Inline function 'com.ikea.range.dynamic.template.CustomSerializer.deserialize.<anonymous>' call
      // Inline function 'kotlin.collections.mutableListOf' call
      var surfaces = ArrayList_init_$Create$_0();
      loop: while (true) {
        var index = composite.sp(CustomSerializer_getInstance_1().m5n_1);
        if (index === -1)
          break loop;
        else {
          surfaces.h(composite.op(CustomSerializer_getInstance_1().m5n_1, index, Companion_getInstance_27().z18()));
        }
      }
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$1 = copyToArray(surfaces);
      var result = new DragSurfacesTemplate(false, tmp$ret$1);
      composite.cp(descriptor);
      return result;
    } else {
      throw $p;
    }
  }
};
protoOf(CustomSerializer_1).n5n = function (encoder, value) {
  if (value.sameAsCollider) {
    encoder.xp(true);
  } else {
    var enc = encoder.bp(this.m5n_1);
    var tmp0_safe_receiver = value.surfaces;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.CustomSerializer.serialize.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        enc.sq(CustomSerializer_getInstance_1().m5n_1, tmp1, Companion_getInstance_27().z18(), item);
      }
    }
    enc.cp(this.m5n_1);
  }
};
protoOf(CustomSerializer_1).ul = function (encoder, value) {
  return this.n5n(encoder, value instanceof DragSurfacesTemplate ? value : THROW_CCE());
};
protoOf(CustomSerializer_1).z18 = function () {
  return CustomSerializer_getInstance_1();
};
var CustomSerializer_instance_1;
function CustomSerializer_getInstance_1() {
  if (CustomSerializer_instance_1 == null)
    new CustomSerializer_1();
  return CustomSerializer_instance_1;
}
function DragSurfacesTemplate(sameAsCollider, surfaces) {
  CustomSerializer_getInstance_1();
  surfaces = surfaces === VOID ? null : surfaces;
  this.sameAsCollider = sameAsCollider;
  this.surfaces = surfaces;
}
protoOf(DragSurfacesTemplate).o5n = function () {
  return this.sameAsCollider;
};
protoOf(DragSurfacesTemplate).n2i = function () {
  return this.surfaces;
};
protoOf(DragSurfacesTemplate).generateDragSurface = function (size, collider) {
  var tmp;
  if (this.sameAsCollider) {
    var tmp_0;
    if (collider == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.DragSurfacesTemplate.generateDragSurface.<anonymous>' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [new DragSurface(collider, null)];
    }
    tmp = tmp_0;
  } else {
    var tmp1_safe_receiver = this.surfaces;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.range.dynamic.template.DragSurfacesTemplate.generateDragSurface.<anonymous>' call
        var tmp0_safe_receiver = element.generateDragSurface(size);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver);
        }
      }
      tmp_1 = destination;
    }
    var tmp2_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_2 = copyToArray(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_2;
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_3 = [];
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var polyhedronForSurfaces = tmp_3;
    var tmp_4;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(polyhedronForSurfaces.length === 0)) {
      tmp_4 = polyhedronForSurfaces;
    } else {
      tmp_4 = null;
    }
    tmp = tmp_4;
  }
  return tmp;
};
protoOf(DragSurfacesTemplate).tf = function () {
  return this.sameAsCollider;
};
protoOf(DragSurfacesTemplate).uf = function () {
  return this.surfaces;
};
protoOf(DragSurfacesTemplate).p5n = function (sameAsCollider, surfaces) {
  return new DragSurfacesTemplate(sameAsCollider, surfaces);
};
protoOf(DragSurfacesTemplate).copy = function (sameAsCollider, surfaces, $super) {
  sameAsCollider = sameAsCollider === VOID ? this.sameAsCollider : sameAsCollider;
  surfaces = surfaces === VOID ? this.surfaces : surfaces;
  return this.p5n(sameAsCollider, surfaces);
};
protoOf(DragSurfacesTemplate).toString = function () {
  return 'DragSurfacesTemplate(sameAsCollider=' + this.sameAsCollider + ', surfaces=' + toString(this.surfaces) + ')';
};
protoOf(DragSurfacesTemplate).hashCode = function () {
  var result = getBooleanHashCode(this.sameAsCollider);
  result = imul(result, 31) + (this.surfaces == null ? 0 : hashCode(this.surfaces)) | 0;
  return result;
};
protoOf(DragSurfacesTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DragSurfacesTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof DragSurfacesTemplate ? other : THROW_CCE();
  if (!(this.sameAsCollider === tmp0_other_with_cast.sameAsCollider))
    return false;
  if (!equals(this.surfaces, tmp0_other_with_cast.surfaces))
    return false;
  return true;
};
var properties_initialized_DragSurfaceTemplate_kt_d8qnnn;
function _init_properties_DragSurfaceTemplate_kt__pafc5d() {
  if (!properties_initialized_DragSurfaceTemplate_kt_d8qnnn) {
    properties_initialized_DragSurfaceTemplate_kt_d8qnnn = true;
    logger = LoggerState_getInstance().g1v('DragSurfaceTemplate');
  }
}
function DynamicRangeUtils$Companion$StrictPretty$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function DynamicRangeUtils$Companion$AssemblyPretty$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  $this$Json.p17_1 = false;
  return Unit_instance;
}
function DynamicRangeUtils$Companion$createConnector$lambda($template, $comSize, $family, $templateId) {
  return function (it) {
    $template.applyMagicLabels(it, new Size($comSize[0], $comSize[1], $comSize[2]), $family, $templateId);
    return Unit_instance;
  };
}
function DynamicRangeUtils$Companion$getMeta$1() {
}
function Companion_21() {
  Companion_instance_31 = this;
  var tmp = this;
  tmp.q5n_1 = Json(VOID, DynamicRangeUtils$Companion$StrictPretty$lambda);
  var tmp_0 = this;
  tmp_0.r5n_1 = Json(VOID, DynamicRangeUtils$Companion$AssemblyPretty$lambda);
}
protoOf(Companion_21).s5n = function (connectorJson, size, comSize, family, templateId) {
  // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
  var this_0 = this.q5n_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = this_0.qp();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer_1(this_1, createKType(getKClass(ConnectorItemTemplate), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
  var template = this_0.w16(tmp$ret$1, connectorJson);
  var tmp = new Size(size[0], size[1], size[2]);
  return template.getConnectorForSize(tmp, DynamicRangeUtils$Companion$createConnector$lambda(template, comSize, family, templateId));
};
protoOf(Companion_21).t5n = function (margin) {
  var tmp0_top = margin[0];
  var tmp1_bottom = margin[1];
  var tmp2_left = margin[2];
  var tmp3_right = margin[3];
  var tmp4_front = margin[4];
  var tmp5_back = margin[5];
  return new Margin(tmp0_top, tmp3_right, tmp1_bottom, tmp2_left, tmp5_back, tmp4_front);
};
protoOf(Companion_21).u5n = function (assembly) {
  // Inline function 'kotlinx.serialization.encodeToString' call
  var this_0 = this.r5n_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = this_0.qp();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer_1(this_1, createKType(getKClass(AssemblyTemplate), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
  return this_0.v16(tmp$ret$1, assembly);
};
protoOf(Companion_21).v5n = function (bounds) {
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer = Companion_getInstance_22().z18();
  var tmp$ret$0 = ArraySerializer(getKClass(BoundItemTemplate), elementSerializer);
  return this.q5n_1.v16(tmp$ret$0, bounds);
};
protoOf(Companion_21).w5n = function (connectors) {
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer = Companion_getInstance_25();
  var tmp$ret$0 = ArraySerializer(getKClass(ConnectorItemTemplate), elementSerializer);
  return this.q5n_1.v16(tmp$ret$0, connectors);
};
protoOf(Companion_21).x5n = function (json) {
  return Default_getInstance().w16(Companion_getInstance_21().z18(), json);
};
protoOf(Companion_21).y5n = function (json) {
  var tmp = Default_getInstance();
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer = Companion_getInstance_22().z18();
  var tmp$ret$0 = ArraySerializer(getKClass(BoundItemTemplate), elementSerializer);
  return tmp.w16(tmp$ret$0, json);
};
protoOf(Companion_21).z5n = function (json) {
  var tmp = Default_getInstance();
  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
  var elementSerializer = Companion_getInstance_25().z18();
  var tmp$ret$0 = ArraySerializer(getKClass(ConnectorItemTemplate), elementSerializer);
  return tmp.w16(tmp$ret$0, json);
};
protoOf(Companion_21).a5o = function (template) {
  try {
    return this.q5n_1.v16(Companion_getInstance_11().z18(), template);
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_0(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
protoOf(Companion_21).b5o = function (dto) {
  var meta = dto.meta;
  var tmp;
  if (!(meta == null)) {
    tmp = parseMeta(meta);
  } else {
    tmp = new DynamicRangeUtils$Companion$getMeta$1();
  }
  return tmp;
};
var Companion_instance_31;
function Companion_getInstance_28() {
  if (Companion_instance_31 == null)
    new Companion_21();
  return Companion_instance_31;
}
function createConnector_0(connectorJson, size, comSize, family, templateId) {
  return Companion_getInstance_28().s5n(connectorJson, size, comSize, family, templateId);
}
function arrayToMargin(margin) {
  return Companion_getInstance_28().t5n(margin);
}
function assemblyToJson(assembly) {
  return Companion_getInstance_28().u5n(assembly);
}
function boundsToJson(bounds) {
  return Companion_getInstance_28().v5n(bounds);
}
function connectorsToJson(connectors) {
  return Companion_getInstance_28().w5n(connectors);
}
function jsonToAssembly(json) {
  return Companion_getInstance_28().x5n(json);
}
function jsonToBounds(json) {
  return Companion_getInstance_28().y5n(json);
}
function jsonToConnectors(json) {
  return Companion_getInstance_28().z5n(json);
}
function productTemplateToJson(template) {
  return Companion_getInstance_28().a5o(template);
}
function getMeta(dto) {
  return Companion_getInstance_28().b5o(dto);
}
function DynamicRangeUtils() {
  Companion_getInstance_28();
}
function Companion_22() {
}
protoOf(Companion_22).z18 = function () {
  return $serializer_getInstance_14();
};
var Companion_instance_32;
function Companion_getInstance_29() {
  return Companion_instance_32;
}
function $serializer_11() {
  $serializer_instance_11 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.LightTemplate', this, 1);
  tmp0_serialDesc.lw('type', true);
  this.c5o_1 = tmp0_serialDesc;
}
protoOf($serializer_11).d5o = function (encoder, value) {
  var tmp0_desc = this.c5o_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.type == null)) {
    tmp1_output.uq(tmp0_desc, 0, StringSerializer_getInstance(), value.type);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_11).ul = function (encoder, value) {
  return this.d5o(encoder, value instanceof LightTemplate ? value : THROW_CCE());
};
protoOf($serializer_11).vl = function (decoder) {
  var tmp0_desc = this.c5o_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return LightTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_11).tl = function () {
  return this.c5o_1;
};
protoOf($serializer_11).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_11;
function $serializer_getInstance_14() {
  if ($serializer_instance_11 == null)
    new $serializer_11();
  return $serializer_instance_11;
}
function LightTemplate_init_$Init$(seen0, type, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_14().c5o_1);
  }
  if (0 === (seen0 & 1))
    $this.type = null;
  else
    $this.type = type;
  return $this;
}
function LightTemplate_init_$Create$(seen0, type, serializationConstructorMarker) {
  return LightTemplate_init_$Init$(seen0, type, serializationConstructorMarker, objectCreate(protoOf(LightTemplate)));
}
function LightTemplate(type) {
  type = type === VOID ? null : type;
  this.type = type;
}
protoOf(LightTemplate).w2a = function () {
  return this.type;
};
protoOf(LightTemplate).tf = function () {
  return this.type;
};
protoOf(LightTemplate).e5o = function (type) {
  return new LightTemplate(type);
};
protoOf(LightTemplate).copy = function (type, $super) {
  type = type === VOID ? this.type : type;
  return this.e5o(type);
};
protoOf(LightTemplate).toString = function () {
  return 'LightTemplate(type=' + this.type + ')';
};
protoOf(LightTemplate).hashCode = function () {
  return this.type == null ? 0 : getStringHashCode(this.type);
};
protoOf(LightTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LightTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof LightTemplate ? other : THROW_CCE();
  if (!(this.type == tmp0_other_with_cast.type))
    return false;
  return true;
};
function d(_this__u8e3s4, $this, key) {
  var tmp0_safe_receiver = _this__u8e3s4.d19(key);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_double(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
}
function encodeNonZeroDoubleElement(_this__u8e3s4, $this, descriptor, index, value) {
  if (!(value === 0.0)) {
    _this__u8e3s4.oq(descriptor, index, value);
  }
}
function MarginTemplate$MarginTemplateSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('top', PrimitiveSerialDescriptor('top', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('bottom', PrimitiveSerialDescriptor('bottom', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('left', PrimitiveSerialDescriptor('left', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('right', PrimitiveSerialDescriptor('right', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('front', PrimitiveSerialDescriptor('front', DOUBLE_getInstance()));
  $this$buildClassSerialDescriptor.hm('back', PrimitiveSerialDescriptor('back', DOUBLE_getInstance()));
  return Unit_instance;
}
function MarginTemplateSerializer() {
  MarginTemplateSerializer_instance = this;
  var tmp = this;
  tmp.g5j_1 = buildClassSerialDescriptor('MarginTemplate', [], MarginTemplate$MarginTemplateSerializer$descriptor$lambda);
}
protoOf(MarginTemplateSerializer).vl = function (decoder) {
  var element = decoder.ap(Companion_instance_8.z18());
  var tmp;
  if (element instanceof JsonObject) {
    var top = d(element, this, 'top');
    var bottom = d(element, this, 'bottom');
    var left = d(element, this, 'left');
    var right = d(element, this, 'right');
    var front = d(element, this, 'front');
    var back = d(element, this, 'back');
    tmp = new MarginTemplate(top, bottom, left, right, front, back);
  } else {
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_jsonArray(element);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.range.dynamic.template.MarginTemplateSerializer.deserialize.<anonymous>' call
      var tmp$ret$0 = get_double(get_jsonPrimitive(item));
      destination.h(tmp$ret$0);
    }
    var array = destination;
    tmp = new MarginTemplate(array.q(0), array.q(1), array.q(2), array.q(3), array.q(4), array.q(5));
  }
  return tmp;
};
protoOf(MarginTemplateSerializer).tl = function () {
  return this.g5j_1;
};
protoOf(MarginTemplateSerializer).f5o = function (encoder, value) {
  var enc = encoder.bp(this.g5j_1);
  encodeNonZeroDoubleElement(enc, this, this.g5j_1, 0, value.top);
  encodeNonZeroDoubleElement(enc, this, this.g5j_1, 1, value.bottom);
  encodeNonZeroDoubleElement(enc, this, this.g5j_1, 2, value.left);
  encodeNonZeroDoubleElement(enc, this, this.g5j_1, 3, value.right);
  encodeNonZeroDoubleElement(enc, this, this.g5j_1, 4, value.front);
  encodeNonZeroDoubleElement(enc, this, this.g5j_1, 5, value.back);
  enc.cp(this.g5j_1);
};
protoOf(MarginTemplateSerializer).ul = function (encoder, value) {
  return this.f5o(encoder, value instanceof MarginTemplate ? value : THROW_CCE());
};
protoOf(MarginTemplateSerializer).z18 = function () {
  return MarginTemplateSerializer_getInstance();
};
var MarginTemplateSerializer_instance;
function MarginTemplateSerializer_getInstance() {
  if (MarginTemplateSerializer_instance == null)
    new MarginTemplateSerializer();
  return MarginTemplateSerializer_instance;
}
function MarginTemplate(top, bottom, left, right, front, back) {
  MarginTemplateSerializer_getInstance();
  top = top === VOID ? 0.0 : top;
  bottom = bottom === VOID ? 0.0 : bottom;
  left = left === VOID ? 0.0 : left;
  right = right === VOID ? 0.0 : right;
  front = front === VOID ? 0.0 : front;
  back = back === VOID ? 0.0 : back;
  this.top = top;
  this.bottom = bottom;
  this.left = left;
  this.right = right;
  this.front = front;
  this.back = back;
}
protoOf(MarginTemplate).b2v = function () {
  return this.top;
};
protoOf(MarginTemplate).d2v = function () {
  return this.bottom;
};
protoOf(MarginTemplate).e2v = function () {
  return this.left;
};
protoOf(MarginTemplate).c2v = function () {
  return this.right;
};
protoOf(MarginTemplate).g2v = function () {
  return this.front;
};
protoOf(MarginTemplate).f2v = function () {
  return this.back;
};
protoOf(MarginTemplate).toMargin = function () {
  return new Margin(this.top, this.right, this.bottom, this.left, this.back, this.front);
};
protoOf(MarginTemplate).clone = function () {
  return this.copy();
};
protoOf(MarginTemplate).tf = function () {
  return this.top;
};
protoOf(MarginTemplate).uf = function () {
  return this.bottom;
};
protoOf(MarginTemplate).m1m = function () {
  return this.left;
};
protoOf(MarginTemplate).n1m = function () {
  return this.right;
};
protoOf(MarginTemplate).o1m = function () {
  return this.front;
};
protoOf(MarginTemplate).p1m = function () {
  return this.back;
};
protoOf(MarginTemplate).h2v = function (top, bottom, left, right, front, back) {
  return new MarginTemplate(top, bottom, left, right, front, back);
};
protoOf(MarginTemplate).copy = function (top, bottom, left, right, front, back, $super) {
  top = top === VOID ? this.top : top;
  bottom = bottom === VOID ? this.bottom : bottom;
  left = left === VOID ? this.left : left;
  right = right === VOID ? this.right : right;
  front = front === VOID ? this.front : front;
  back = back === VOID ? this.back : back;
  return this.h2v(top, bottom, left, right, front, back);
};
protoOf(MarginTemplate).toString = function () {
  return 'MarginTemplate(top=' + this.top + ', bottom=' + this.bottom + ', left=' + this.left + ', right=' + this.right + ', front=' + this.front + ', back=' + this.back + ')';
};
protoOf(MarginTemplate).hashCode = function () {
  var result = getNumberHashCode(this.top);
  result = imul(result, 31) + getNumberHashCode(this.bottom) | 0;
  result = imul(result, 31) + getNumberHashCode(this.left) | 0;
  result = imul(result, 31) + getNumberHashCode(this.right) | 0;
  result = imul(result, 31) + getNumberHashCode(this.front) | 0;
  result = imul(result, 31) + getNumberHashCode(this.back) | 0;
  return result;
};
protoOf(MarginTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MarginTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof MarginTemplate ? other : THROW_CCE();
  if (!equals(this.top, tmp0_other_with_cast.top))
    return false;
  if (!equals(this.bottom, tmp0_other_with_cast.bottom))
    return false;
  if (!equals(this.left, tmp0_other_with_cast.left))
    return false;
  if (!equals(this.right, tmp0_other_with_cast.right))
    return false;
  if (!equals(this.front, tmp0_other_with_cast.front))
    return false;
  if (!equals(this.back, tmp0_other_with_cast.back))
    return false;
  return true;
};
function Companion_23() {
}
protoOf(Companion_23).z18 = function () {
  return $serializer_getInstance_15();
};
var Companion_instance_33;
function Companion_getInstance_30() {
  return Companion_instance_33;
}
function $serializer_12() {
  $serializer_instance_12 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.Model3DTemplate', this, 3);
  tmp0_serialDesc.lw('modelURI', false);
  tmp0_serialDesc.lw('modelRootURL', true);
  tmp0_serialDesc.lw('modelTransform', true);
  this.g5o_1 = tmp0_serialDesc;
}
protoOf($serializer_12).h5o = function (encoder, value) {
  var tmp0_desc = this.g5o_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.modelURI);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.modelRootURL == null)) {
    tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.modelRootURL);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.modelTransform == null)) {
    tmp1_output.uq(tmp0_desc, 2, $serializer_getInstance_0(), value.modelTransform);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_12).ul = function (encoder, value) {
  return this.h5o(encoder, value instanceof Model3DTemplate ? value : THROW_CCE());
};
protoOf($serializer_12).vl = function (decoder) {
  var tmp0_desc = this.g5o_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return Model3DTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_12).tl = function () {
  return this.g5o_1;
};
protoOf($serializer_12).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_0())];
};
var $serializer_instance_12;
function $serializer_getInstance_15() {
  if ($serializer_instance_12 == null)
    new $serializer_12();
  return $serializer_instance_12;
}
function Model3DTemplate_init_$Init$(seen0, modelURI, modelRootURL, modelTransform, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_15().g5o_1);
  }
  $this.modelURI = modelURI;
  if (0 === (seen0 & 2))
    $this.modelRootURL = null;
  else
    $this.modelRootURL = modelRootURL;
  if (0 === (seen0 & 4))
    $this.modelTransform = null;
  else
    $this.modelTransform = modelTransform;
  return $this;
}
function Model3DTemplate_init_$Create$(seen0, modelURI, modelRootURL, modelTransform, serializationConstructorMarker) {
  return Model3DTemplate_init_$Init$(seen0, modelURI, modelRootURL, modelTransform, serializationConstructorMarker, objectCreate(protoOf(Model3DTemplate)));
}
function Model3DTemplate(modelURI, modelRootURL, modelTransform) {
  modelRootURL = modelRootURL === VOID ? null : modelRootURL;
  modelTransform = modelTransform === VOID ? null : modelTransform;
  this.modelURI = modelURI;
  this.modelRootURL = modelRootURL;
  this.modelTransform = modelTransform;
}
protoOf(Model3DTemplate).m5e = function () {
  return this.modelURI;
};
protoOf(Model3DTemplate).i5o = function () {
  return this.modelRootURL;
};
protoOf(Model3DTemplate).s5g = function () {
  return this.modelTransform;
};
protoOf(Model3DTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof Model3DTemplate))
    THROW_CCE();
  if (!(this.modelURI === other.modelURI))
    return false;
  if (!(this.modelRootURL == other.modelRootURL))
    return false;
  return true;
};
protoOf(Model3DTemplate).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.modelRootURL;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
};
protoOf(Model3DTemplate).tf = function () {
  return this.modelURI;
};
protoOf(Model3DTemplate).uf = function () {
  return this.modelRootURL;
};
protoOf(Model3DTemplate).m1m = function () {
  return this.modelTransform;
};
protoOf(Model3DTemplate).j5o = function (modelURI, modelRootURL, modelTransform) {
  return new Model3DTemplate(modelURI, modelRootURL, modelTransform);
};
protoOf(Model3DTemplate).copy = function (modelURI, modelRootURL, modelTransform, $super) {
  modelURI = modelURI === VOID ? this.modelURI : modelURI;
  modelRootURL = modelRootURL === VOID ? this.modelRootURL : modelRootURL;
  modelTransform = modelTransform === VOID ? this.modelTransform : modelTransform;
  return this.j5o(modelURI, modelRootURL, modelTransform);
};
protoOf(Model3DTemplate).toString = function () {
  return 'Model3DTemplate(modelURI=' + this.modelURI + ', modelRootURL=' + this.modelRootURL + ', modelTransform=' + toString_0(this.modelTransform) + ')';
};
function parseRelativeTo($this, element) {
  var tmp = "Could not parse field 'relativeTo' as OriginRelativeTo from object: " + element.toString();
  return parseAndCatch(tmp, OriginTemplate$CustomSerializer$parseRelativeTo$lambda(element));
}
function parseOrigin($this, element) {
  var tmp = "Could not parse field 'relation' as RelationOrigin from object: " + element.toString();
  return parseAndCatch(tmp, OriginTemplate$CustomSerializer$parseOrigin$lambda(element));
}
function parseSimpleOrigin($this, element) {
  var tmp = 'Could not parse origin as RelationOrigin from object: ' + element.toString();
  return parseAndCatch(tmp, OriginTemplate$CustomSerializer$parseSimpleOrigin$lambda(element));
}
function OriginTemplate$CustomSerializer$jsonParser$lambda($this$Json) {
  $this$Json.s17_1 = true;
  return Unit_instance;
}
function OriginTemplate$CustomSerializer$parseRelativeTo$lambda($element) {
  return function () {
    return CustomSerializer_getInstance_2().jsonParser.w16(Companion_getInstance_35().z18(), toString_0($element.d19('relativeTo')));
  };
}
function OriginTemplate$CustomSerializer$parseOrigin$lambda($element) {
  return function () {
    return CustomSerializer_getInstance_2().jsonParser.w16(RelationOriginSerializer_getInstance(), toString_0($element.d19('relation')));
  };
}
function OriginTemplate$CustomSerializer$parseSimpleOrigin$lambda($element) {
  return function () {
    return CustomSerializer_getInstance_2().jsonParser.w16(RelationOriginSerializer_getInstance(), $element.toString());
  };
}
function OriginTemplate$CustomSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('relation', Companion_instance_4.z18().tl());
  $this$buildClassSerialDescriptor.hm('relativeTo', Companion_getInstance_2().z18().tl());
  return Unit_instance;
}
function CustomSerializer_2() {
  CustomSerializer_instance_2 = this;
  var tmp = this;
  tmp.jsonParser = Json(VOID, OriginTemplate$CustomSerializer$jsonParser$lambda);
  var tmp_0 = this;
  tmp_0.k5o_1 = buildClassSerialDescriptor('OriginTemplate', [], OriginTemplate$CustomSerializer$descriptor$lambda);
}
protoOf(CustomSerializer_2).u5f = function () {
  return this.jsonParser;
};
protoOf(CustomSerializer_2).vl = function (decoder) {
  var element = decoder.ap(Companion_instance_8.z18());
  var tmp;
  if (element instanceof JsonObject) {
    tmp = new OriginTemplate(parseOrigin(this, element), parseRelativeTo(this, element));
  } else {
    if (element instanceof JsonPrimitive) {
      tmp = new OriginTemplate(parseSimpleOrigin(this, element), OriginRelativeTo_SIZE_getInstance());
    } else {
      var message = 'Origin malformed in JSON: ' + toString(element);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  return tmp;
};
protoOf(CustomSerializer_2).tl = function () {
  return this.k5o_1;
};
protoOf(CustomSerializer_2).m5o = function (encoder, value) {
  if (!value.relation.equals(new RelationOrigin()) && !value.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance())) {
    var comp = encoder.bp(this.k5o_1);
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = value.kotlinRelativeTo.toString().toLowerCase();
    comp.qq(this.k5o_1, 1, tmp$ret$1);
    comp.qq(this.k5o_1, 0, value.relation.toString());
    comp.cp(this.k5o_1);
  } else if (!value.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance())) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = value.kotlinRelativeTo.toString().toLowerCase();
    encoder.fq(tmp$ret$3);
  } else if (!value.relation.equals(new RelationOrigin())) {
    encoder.fq(value.relation.toString());
  }
};
protoOf(CustomSerializer_2).ul = function (encoder, value) {
  return this.m5o(encoder, value instanceof OriginTemplate ? value : THROW_CCE());
};
protoOf(CustomSerializer_2).z18 = function () {
  return CustomSerializer_getInstance_2();
};
var CustomSerializer_instance_2;
function CustomSerializer_getInstance_2() {
  if (CustomSerializer_instance_2 == null)
    new CustomSerializer_2();
  return CustomSerializer_instance_2;
}
function OriginTemplate(relation, relativeTo) {
  CustomSerializer_getInstance_2();
  this.relation = relation;
  this.kotlinRelativeTo = relativeTo;
  this.isDefault = (this.relation.equals(new RelationOrigin()) && this.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance()));
}
protoOf(OriginTemplate).n5o = function () {
  return this.relation;
};
protoOf(OriginTemplate).o5o = function () {
  return this.kotlinRelativeTo;
};
protoOf(OriginTemplate).p5o = function () {
  return this.isDefault;
};
protoOf(OriginTemplate).d2x = function () {
  return this.kotlinRelativeTo.u2_1;
};
protoOf(OriginTemplate).tf = function () {
  return this.relation;
};
protoOf(OriginTemplate).uf = function () {
  return this.kotlinRelativeTo;
};
protoOf(OriginTemplate).q5o = function (relation, relativeTo) {
  return new OriginTemplate(relation, relativeTo);
};
protoOf(OriginTemplate).copy = function (relation, relativeTo, $super) {
  relation = relation === VOID ? this.relation : relation;
  relativeTo = relativeTo === VOID ? this.kotlinRelativeTo : relativeTo;
  return this.q5o(relation, relativeTo);
};
protoOf(OriginTemplate).toString = function () {
  return 'OriginTemplate(relation=' + this.relation.toString() + ', relativeTo=' + this.kotlinRelativeTo.toString() + ')';
};
protoOf(OriginTemplate).hashCode = function () {
  var result = this.relation.hashCode();
  result = imul(result, 31) + this.kotlinRelativeTo.hashCode() | 0;
  return result;
};
protoOf(OriginTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof OriginTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof OriginTemplate ? other : THROW_CCE();
  if (!this.relation.equals(tmp0_other_with_cast.relation))
    return false;
  if (!this.kotlinRelativeTo.equals(tmp0_other_with_cast.kotlinRelativeTo))
    return false;
  return true;
};
function Companion_24() {
}
protoOf(Companion_24).z18 = function () {
  return $serializer_getInstance_16();
};
var Companion_instance_34;
function Companion_getInstance_31() {
  return Companion_instance_34;
}
function $serializer_13() {
  $serializer_instance_13 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.PlacementZoneByHeightTemplate', this, 2);
  tmp0_serialDesc.lw('minY', false);
  tmp0_serialDesc.lw('maxY', false);
  this.r5o_1 = tmp0_serialDesc;
}
protoOf($serializer_13).s5o = function (encoder, value) {
  var tmp0_desc = this.r5o_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.lq(tmp0_desc, 0, value.minY);
  tmp1_output.lq(tmp0_desc, 1, value.maxY);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_13).ul = function (encoder, value) {
  return this.s5o(encoder, value instanceof PlacementZoneByHeightTemplate ? value : THROW_CCE());
};
protoOf($serializer_13).vl = function (decoder) {
  var tmp0_desc = this.r5o_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_local1 = 0;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.gp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return PlacementZoneByHeightTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_13).tl = function () {
  return this.r5o_1;
};
protoOf($serializer_13).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_13;
function $serializer_getInstance_16() {
  if ($serializer_instance_13 == null)
    new $serializer_13();
  return $serializer_instance_13;
}
function PlacementZoneByHeightTemplate_init_$Init$(seen0, minY, maxY, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_16().r5o_1);
  }
  $this.minY = minY;
  $this.maxY = maxY;
  return $this;
}
function PlacementZoneByHeightTemplate_init_$Create$(seen0, minY, maxY, serializationConstructorMarker) {
  return PlacementZoneByHeightTemplate_init_$Init$(seen0, minY, maxY, serializationConstructorMarker, objectCreate(protoOf(PlacementZoneByHeightTemplate)));
}
function PlacementZoneByHeightTemplate(minY, maxY) {
  this.minY = minY;
  this.maxY = maxY;
}
protoOf(PlacementZoneByHeightTemplate).w4i = function () {
  return this.minY;
};
protoOf(PlacementZoneByHeightTemplate).x4i = function () {
  return this.maxY;
};
protoOf(PlacementZoneByHeightTemplate).tf = function () {
  return this.minY;
};
protoOf(PlacementZoneByHeightTemplate).uf = function () {
  return this.maxY;
};
protoOf(PlacementZoneByHeightTemplate).y4i = function (minY, maxY) {
  return new PlacementZoneByHeightTemplate(minY, maxY);
};
protoOf(PlacementZoneByHeightTemplate).copy = function (minY, maxY, $super) {
  minY = minY === VOID ? this.minY : minY;
  maxY = maxY === VOID ? this.maxY : maxY;
  return this.y4i(minY, maxY);
};
protoOf(PlacementZoneByHeightTemplate).toString = function () {
  return 'PlacementZoneByHeightTemplate(minY=' + this.minY + ', maxY=' + this.maxY + ')';
};
protoOf(PlacementZoneByHeightTemplate).hashCode = function () {
  var result = this.minY;
  result = imul(result, 31) + this.maxY | 0;
  return result;
};
protoOf(PlacementZoneByHeightTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlacementZoneByHeightTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof PlacementZoneByHeightTemplate ? other : THROW_CCE();
  if (!(this.minY === tmp0_other_with_cast.minY))
    return false;
  if (!(this.maxY === tmp0_other_with_cast.maxY))
    return false;
  return true;
};
function parseOrigin_0($this, element) {
  var tmp = "Could not parse field 'origin' as OriginTemplate from object: " + element.toString();
  return parseAndCatch(tmp, PositionTemplate$PositionTemplateSerializer$parseOrigin$lambda(element));
}
function parseRelativeTransform($this, element) {
  var tmp = "Could not parse field 'transform' as RelativeTransform from object: " + toString(element);
  return parseAndCatch(tmp, PositionTemplate$PositionTemplateSerializer$parseRelativeTransform$lambda(element));
}
function parseRelativeTransformAsArray($this, element) {
  var tmp = 'Could not parse RelativeTransform from object: ' + toString(element);
  return parseAndCatch(tmp, PositionTemplate$PositionTemplateSerializer$parseRelativeTransformAsArray$lambda(element));
}
function PositionTemplate$PositionTemplateSerializer$jsonParser$lambda($this$Json) {
  $this$Json.s17_1 = true;
  return Unit_instance;
}
function PositionTemplate$PositionTemplateSerializer$parseOrigin$lambda($element) {
  return function () {
    return PositionTemplateSerializer_getInstance().s5m_1.w16(CustomSerializer_getInstance_2().z18(), toString_0($element.d19('origin')));
  };
}
function PositionTemplate$PositionTemplateSerializer$parseRelativeTransform$lambda($element) {
  return function () {
    var tmp;
    if ($element instanceof JsonArray) {
      var tmp_0 = RelativeTransformDeserializer_instance;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = get_jsonArray($element);
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.parseRelativeTransform.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = get_jsonPrimitive(element).e19();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver);
        }
      }
      tmp = tmp_0.u5o(destination);
    } else {
      tmp = NamedTransformObjectDeserializer_instance.t5o(get_jsonObject($element));
    }
    return tmp;
  };
}
function PositionTemplate$PositionTemplateSerializer$parseRelativeTransformAsArray$lambda($element) {
  return function () {
    var tmp = RelativeTransformDeserializer_instance;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = get_jsonArray($element);
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.parseRelativeTransformAsArray.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = get_jsonPrimitive(element).e19();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return tmp.u5o(destination);
  };
}
function PositionTemplate$PositionTemplateSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('origin', CustomSerializer_getInstance_2().z18().tl());
  $this$buildClassSerialDescriptor.hm('transform', RelativeTransformSerializer_getInstance().z18().tl());
  return Unit_instance;
}
function PositionTemplate_init_$Init$(origin, transform, $this) {
  PositionTemplate.call($this, PositionTemplateSerializer_getInstance().s5m_1.w16(CustomSerializer_getInstance_2().z18(), origin), RelativeTransformFromVector(transform.position, transform.rotation));
  return $this;
}
function PositionTemplateFromString(origin, transform) {
  return PositionTemplate_init_$Init$(origin, transform, objectCreate(protoOf(PositionTemplate)));
}
function PositionTemplateSerializer() {
  PositionTemplateSerializer_instance = this;
  this.IDENTITY = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), new RelativeTransform());
  var tmp = this;
  tmp.s5m_1 = Json(VOID, PositionTemplate$PositionTemplateSerializer$jsonParser$lambda);
  var tmp_0 = this;
  tmp_0.t5m_1 = buildClassSerialDescriptor('PositionTemplate', [], PositionTemplate$PositionTemplateSerializer$descriptor$lambda);
}
protoOf(PositionTemplateSerializer).n2w = function () {
  return this.IDENTITY;
};
protoOf(PositionTemplateSerializer).vl = function (decoder) {
  var element = decoder.ap(Companion_instance_8.z18());
  var tmp;
  if (element instanceof JsonObject) {
    var tmp_0;
    if (element.d19('origin') == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.deserialize.<anonymous>' call
      var tmp0_safe_receiver = element.d19('transform');
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.deserialize.<anonymous>.<anonymous>' call
        tmp_1 = new PositionTemplate(parseOrigin_0(PositionTemplateSerializer_getInstance(), element), parseRelativeTransform(PositionTemplateSerializer_getInstance(), tmp0_safe_receiver));
      }
      var tmp1_elvis_lhs = tmp_1;
      tmp_0 = tmp1_elvis_lhs == null ? new PositionTemplate(parseOrigin_0(PositionTemplateSerializer_getInstance(), element), new RelativeTransform()) : tmp1_elvis_lhs;
    }
    var tmp1_elvis_lhs_0 = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs_0 == null) {
      var tmp2_safe_receiver = element.d19('transform');
      var tmp_3;
      if (tmp2_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.deserialize.<anonymous>' call
        tmp_3 = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), parseRelativeTransform(PositionTemplateSerializer_getInstance(), tmp2_safe_receiver));
      }
      tmp_2 = tmp_3;
    } else {
      tmp_2 = tmp1_elvis_lhs_0;
    }
    var tmp3_elvis_lhs = tmp_2;
    tmp = tmp3_elvis_lhs == null ? new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), parseRelativeTransform(this, element)) : tmp3_elvis_lhs;
  } else {
    if (element instanceof JsonArray) {
      tmp = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), parseRelativeTransformAsArray(this, element));
    } else {
      tmp = new PositionTemplate(new OriginTemplate(this.s5m_1.w16(RelationOriginSerializer_getInstance(), toString(element)), OriginRelativeTo_SIZE_getInstance()), new RelativeTransform());
    }
  }
  return tmp;
};
protoOf(PositionTemplateSerializer).tl = function () {
  return this.t5m_1;
};
protoOf(PositionTemplateSerializer).w5o = function (encoder, value) {
  var transform = !value.u5m_1.position.isOrigin || !value.u5m_1.rotation.equals(Companion_getInstance_3().q2b_1) ? value.u5m_1 : null;
  var origin = !value.origin.isDefault ? value.origin : null;
  if (!(transform == null) && !(origin == null)) {
    var comp = encoder.bp(this.t5m_1);
    comp.sq(this.t5m_1, 0, CustomSerializer_getInstance_2().z18(), origin);
    comp.sq(this.t5m_1, 1, RelativeTransformSerializer_getInstance().z18(), transform);
    comp.cp(this.t5m_1);
  } else if (!(transform == null)) {
    var desc = ListSerializer(Companion_getInstance_37().z18()).tl();
    var comp_0 = encoder.xq(desc, 6);
    RelativeTransformSerializer_getInstance().encodeToArray(comp_0, desc, transform, 0);
    comp_0.cp(this.t5m_1);
  } else if (!(origin == null)) {
    if (origin.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance())) {
      encoder.fq(origin.relation.toString());
    } else {
      var comp_1 = encoder.bp(this.t5m_1);
      comp_1.sq(this.t5m_1, 0, CustomSerializer_getInstance_2().z18(), origin);
      comp_1.cp(this.t5m_1);
    }
  } else {
    encoder.fq('center');
  }
};
protoOf(PositionTemplateSerializer).ul = function (encoder, value) {
  return this.w5o(encoder, value instanceof PositionTemplate ? value : THROW_CCE());
};
protoOf(PositionTemplateSerializer).z18 = function () {
  return PositionTemplateSerializer_getInstance();
};
var PositionTemplateSerializer_instance;
function PositionTemplateSerializer_getInstance() {
  if (PositionTemplateSerializer_instance == null)
    new PositionTemplateSerializer();
  return PositionTemplateSerializer_instance;
}
function PositionTemplate$absoluteTransform$delegate$lambda(this$0) {
  return function () {
    return new Transform(this$0.u5m_1.position.getAbsolutePosition(), this$0.u5m_1.rotation);
  };
}
function PositionTemplate(origin, transform) {
  PositionTemplateSerializer_getInstance();
  transform = transform === VOID ? new RelativeTransform() : transform;
  this.origin = origin;
  this.u5m_1 = transform;
  var tmp = this;
  tmp.v5m_1 = lazy(PositionTemplate$absoluteTransform$delegate$lambda(this));
  this.rotation = this.u5m_1.rotation;
}
protoOf(PositionTemplate).i30 = function () {
  return this.origin;
};
protoOf(PositionTemplate).g1m = function () {
  return this.u5m_1;
};
protoOf(PositionTemplate).c5p = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.v5m_1;
  absoluteTransform$factory();
  return this_0.c2();
};
protoOf(PositionTemplate).m2g = function () {
  return this.rotation;
};
protoOf(PositionTemplate).applyToBox = function (aabb) {
  var tmp0_subject = this.origin.relation.x;
  var tmp = tmp0_subject === Companion_instance_5.f2x_1 ? aabb.min.X + this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).X : tmp0_subject === Companion_instance_5.h2x_1 ? aabb.max.X + this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).X : this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).X;
  var tmp1_subject = this.origin.relation.y;
  var tmp_0 = tmp1_subject === Companion_instance_6.k2x_1 ? aabb.max.Y + this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).Y : tmp1_subject === Companion_instance_6.i2x_1 ? aabb.min.Y + this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).Y : this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).Y;
  var tmp2_subject = this.origin.relation.z;
  return new Transform(new Vector(tmp, tmp_0, tmp2_subject === Companion_instance_7.l2x_1 ? aabb.min.Z + this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).Z : tmp2_subject === Companion_instance_7.n2x_1 ? aabb.max.Z + this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).Z : this.u5m_1.position.getRelativePosition(SizeFromVector(aabb.size)).Z), this.u5m_1.rotation);
};
protoOf(PositionTemplate).tf = function () {
  return this.origin;
};
protoOf(PositionTemplate).d5p = function (origin, transform) {
  return new PositionTemplate(origin, transform);
};
protoOf(PositionTemplate).copy = function (origin, transform, $super) {
  origin = origin === VOID ? this.origin : origin;
  transform = transform === VOID ? this.u5m_1 : transform;
  return this.d5p(origin, transform);
};
protoOf(PositionTemplate).toString = function () {
  return 'PositionTemplate(origin=' + this.origin.toString() + ', transform=' + this.u5m_1.toString() + ')';
};
protoOf(PositionTemplate).hashCode = function () {
  var result = this.origin.hashCode();
  result = imul(result, 31) + this.u5m_1.hashCode() | 0;
  return result;
};
protoOf(PositionTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PositionTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof PositionTemplate ? other : THROW_CCE();
  if (!this.origin.equals(tmp0_other_with_cast.origin))
    return false;
  if (!this.u5m_1.equals(tmp0_other_with_cast.u5m_1))
    return false;
  return true;
};
function absoluteTransform$factory() {
  return getPropertyCallableRef('absoluteTransform', 1, KProperty1, function (receiver) {
    return receiver.absoluteTransform;
  }, null);
}
function Companion_25() {
}
protoOf(Companion_25).z18 = function () {
  return $serializer_getInstance_17();
};
var Companion_instance_35;
function Companion_getInstance_32() {
  return Companion_instance_35;
}
function $serializer_14() {
  $serializer_instance_14 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.VisualLightSourceTemplate', this, 3);
  tmp0_serialDesc.lw('type', true);
  tmp0_serialDesc.lw('intensity', true);
  tmp0_serialDesc.lw('colorTemperature', true);
  this.e5p_1 = tmp0_serialDesc;
}
protoOf($serializer_14).f5p = function (encoder, value) {
  var tmp0_desc = this.e5p_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.type == null)) {
    tmp1_output.uq(tmp0_desc, 0, StringSerializer_getInstance(), value.type);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.intensity == null)) {
    tmp1_output.uq(tmp0_desc, 1, IntSerializer_getInstance(), value.intensity);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.colorTemperature == null)) {
    tmp1_output.uq(tmp0_desc, 2, IntSerializer_getInstance(), value.colorTemperature);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_14).ul = function (encoder, value) {
  return this.f5p(encoder, value instanceof VisualLightSourceTemplate ? value : THROW_CCE());
};
protoOf($serializer_14).vl = function (decoder) {
  var tmp0_desc = this.e5p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return VisualLightSourceTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_14).tl = function () {
  return this.e5p_1;
};
protoOf($serializer_14).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
};
var $serializer_instance_14;
function $serializer_getInstance_17() {
  if ($serializer_instance_14 == null)
    new $serializer_14();
  return $serializer_instance_14;
}
function VisualLightSourceTemplate_init_$Init$(seen0, type, intensity, colorTemperature, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_17().e5p_1);
  }
  if (0 === (seen0 & 1))
    $this.type = null;
  else
    $this.type = type;
  if (0 === (seen0 & 2))
    $this.intensity = null;
  else
    $this.intensity = intensity;
  if (0 === (seen0 & 4))
    $this.colorTemperature = null;
  else
    $this.colorTemperature = colorTemperature;
  return $this;
}
function VisualLightSourceTemplate_init_$Create$(seen0, type, intensity, colorTemperature, serializationConstructorMarker) {
  return VisualLightSourceTemplate_init_$Init$(seen0, type, intensity, colorTemperature, serializationConstructorMarker, objectCreate(protoOf(VisualLightSourceTemplate)));
}
function VisualLightSourceTemplate(type, intensity, colorTemperature) {
  type = type === VOID ? null : type;
  intensity = intensity === VOID ? null : intensity;
  colorTemperature = colorTemperature === VOID ? null : colorTemperature;
  this.type = type;
  this.intensity = intensity;
  this.colorTemperature = colorTemperature;
}
protoOf(VisualLightSourceTemplate).w2a = function () {
  return this.type;
};
protoOf(VisualLightSourceTemplate).l5g = function () {
  return this.intensity;
};
protoOf(VisualLightSourceTemplate).m5g = function () {
  return this.colorTemperature;
};
protoOf(VisualLightSourceTemplate).tf = function () {
  return this.type;
};
protoOf(VisualLightSourceTemplate).uf = function () {
  return this.intensity;
};
protoOf(VisualLightSourceTemplate).m1m = function () {
  return this.colorTemperature;
};
protoOf(VisualLightSourceTemplate).g5p = function (type, intensity, colorTemperature) {
  return new VisualLightSourceTemplate(type, intensity, colorTemperature);
};
protoOf(VisualLightSourceTemplate).copy = function (type, intensity, colorTemperature, $super) {
  type = type === VOID ? this.type : type;
  intensity = intensity === VOID ? this.intensity : intensity;
  colorTemperature = colorTemperature === VOID ? this.colorTemperature : colorTemperature;
  return this.g5p(type, intensity, colorTemperature);
};
protoOf(VisualLightSourceTemplate).toString = function () {
  return 'VisualLightSourceTemplate(type=' + this.type + ', intensity=' + this.intensity + ', colorTemperature=' + this.colorTemperature + ')';
};
protoOf(VisualLightSourceTemplate).hashCode = function () {
  var result = this.type == null ? 0 : getStringHashCode(this.type);
  result = imul(result, 31) + (this.intensity == null ? 0 : this.intensity) | 0;
  result = imul(result, 31) + (this.colorTemperature == null ? 0 : this.colorTemperature) | 0;
  return result;
};
protoOf(VisualLightSourceTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VisualLightSourceTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof VisualLightSourceTemplate ? other : THROW_CCE();
  if (!(this.type == tmp0_other_with_cast.type))
    return false;
  if (!(this.intensity == tmp0_other_with_cast.intensity))
    return false;
  if (!(this.colorTemperature == tmp0_other_with_cast.colorTemperature))
    return false;
  return true;
};
function Companion_26() {
}
protoOf(Companion_26).z18 = function () {
  return $serializer_getInstance_18();
};
var Companion_instance_36;
function Companion_getInstance_33() {
  return Companion_instance_36;
}
function $serializer_15() {
  $serializer_instance_15 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.hierarchy.ProductStructureConnectionTemplate', this, 3);
  tmp0_serialDesc.lw('offeringPartKey', false);
  tmp0_serialDesc.lw('demandingConnector', false);
  tmp0_serialDesc.lw('offeringConnector', false);
  this.h5p_1 = tmp0_serialDesc;
}
protoOf($serializer_15).i5p = function (encoder, value) {
  var tmp0_desc = this.h5p_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.offeringPartKey);
  tmp1_output.qq(tmp0_desc, 1, value.demandingConnector);
  tmp1_output.qq(tmp0_desc, 2, value.offeringConnector);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_15).ul = function (encoder, value) {
  return this.i5p(encoder, value instanceof ProductStructureConnectionTemplate ? value : THROW_CCE());
};
protoOf($serializer_15).vl = function (decoder) {
  var tmp0_desc = this.h5p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return ProductStructureConnectionTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_15).tl = function () {
  return this.h5p_1;
};
protoOf($serializer_15).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_15;
function $serializer_getInstance_18() {
  if ($serializer_instance_15 == null)
    new $serializer_15();
  return $serializer_instance_15;
}
function ProductStructureConnectionTemplate_init_$Init$(seen0, offeringPartKey, demandingConnector, offeringConnector, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_18().h5p_1);
  }
  $this.offeringPartKey = offeringPartKey;
  $this.demandingConnector = demandingConnector;
  $this.offeringConnector = offeringConnector;
  return $this;
}
function ProductStructureConnectionTemplate_init_$Create$(seen0, offeringPartKey, demandingConnector, offeringConnector, serializationConstructorMarker) {
  return ProductStructureConnectionTemplate_init_$Init$(seen0, offeringPartKey, demandingConnector, offeringConnector, serializationConstructorMarker, objectCreate(protoOf(ProductStructureConnectionTemplate)));
}
function ProductStructureConnectionTemplate(offeringPartKey, demandingConnector, offeringConnector) {
  this.offeringPartKey = offeringPartKey;
  this.demandingConnector = demandingConnector;
  this.offeringConnector = offeringConnector;
}
protoOf(ProductStructureConnectionTemplate).p1u = function () {
  return this.offeringPartKey;
};
protoOf(ProductStructureConnectionTemplate).q1u = function () {
  return this.demandingConnector;
};
protoOf(ProductStructureConnectionTemplate).r1u = function () {
  return this.offeringConnector;
};
function Companion_27() {
}
protoOf(Companion_27).z18 = function () {
  return $serializer_getInstance_19();
};
var Companion_instance_37;
function Companion_getInstance_34() {
  return Companion_instance_37;
}
function $serializer_16() {
  $serializer_instance_16 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.hierarchy.ProductStructureItemTemplate', this, 3);
  tmp0_serialDesc.lw('partKey', false);
  tmp0_serialDesc.lw('snap', true);
  tmp0_serialDesc.lw('transform', true);
  this.j5p_1 = tmp0_serialDesc;
}
protoOf($serializer_16).k5p = function (encoder, value) {
  var tmp0_desc = this.j5p_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.partKey);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.snap == null)) {
    tmp1_output.uq(tmp0_desc, 1, $serializer_getInstance_18(), value.snap);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !value.transform.equals(PositionTemplateSerializer_getInstance().IDENTITY)) {
    tmp1_output.sq(tmp0_desc, 2, PositionTemplateSerializer_getInstance(), value.transform);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_16).ul = function (encoder, value) {
  return this.k5p(encoder, value instanceof ProductStructureItemTemplate ? value : THROW_CCE());
};
protoOf($serializer_16).vl = function (decoder) {
  var tmp0_desc = this.j5p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, $serializer_getInstance_18(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.np(tmp0_desc, 2, PositionTemplateSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, $serializer_getInstance_18(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.np(tmp0_desc, 2, PositionTemplateSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return ProductStructureItemTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_16).tl = function () {
  return this.j5p_1;
};
protoOf($serializer_16).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_18()), PositionTemplateSerializer_getInstance()];
};
var $serializer_instance_16;
function $serializer_getInstance_19() {
  if ($serializer_instance_16 == null)
    new $serializer_16();
  return $serializer_instance_16;
}
function ProductStructureItemTemplate_init_$Init$(seen0, partKey, snap, transform, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_19().j5p_1);
  }
  $this.partKey = partKey;
  if (0 === (seen0 & 2))
    $this.snap = null;
  else
    $this.snap = snap;
  if (0 === (seen0 & 4))
    $this.transform = PositionTemplateSerializer_getInstance().IDENTITY;
  else
    $this.transform = transform;
  return $this;
}
function ProductStructureItemTemplate_init_$Create$(seen0, partKey, snap, transform, serializationConstructorMarker) {
  return ProductStructureItemTemplate_init_$Init$(seen0, partKey, snap, transform, serializationConstructorMarker, objectCreate(protoOf(ProductStructureItemTemplate)));
}
function ProductStructureItemTemplate(partKey, snap, transform) {
  snap = snap === VOID ? null : snap;
  transform = transform === VOID ? PositionTemplateSerializer_getInstance().IDENTITY : transform;
  this.partKey = partKey;
  this.snap = snap;
  this.transform = transform;
}
protoOf(ProductStructureItemTemplate).f1m = function () {
  return this.partKey;
};
protoOf(ProductStructureItemTemplate).t1u = function () {
  return this.snap;
};
protoOf(ProductStructureItemTemplate).z2a = function () {
  return this.transform;
};
function _get_$cachedSerializer__te6jhj($this) {
  return $this.l5o_1.c2();
}
function OriginRelativeTo$Companion$_anonymous__8s7o4e() {
  var tmp = values();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = ['bound', 'size'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null];
  return createAnnotatedEnumSerializer('com.ikea.range.dynamic.template.objects.OriginRelativeTo', tmp, tmp_0, tmp$ret$5, null);
}
var OriginRelativeTo_BOUND_instance;
var OriginRelativeTo_SIZE_instance;
function values() {
  return [OriginRelativeTo_BOUND_getInstance(), OriginRelativeTo_SIZE_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'BOUND':
      return OriginRelativeTo_BOUND_getInstance();
    case 'SIZE':
      return OriginRelativeTo_SIZE_getInstance();
    default:
      OriginRelativeTo_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
function Companion_28() {
  Companion_instance_38 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.l5o_1 = lazy_0(tmp_0, OriginRelativeTo$Companion$_anonymous__8s7o4e);
}
protoOf(Companion_28).z18 = function () {
  return _get_$cachedSerializer__te6jhj(this);
};
protoOf(Companion_28).rx = function (typeParamsSerializers) {
  return this.z18();
};
var Companion_instance_38;
function Companion_getInstance_35() {
  OriginRelativeTo_initEntries();
  if (Companion_instance_38 == null)
    new Companion_28();
  return Companion_instance_38;
}
var OriginRelativeTo_entriesInitialized;
function OriginRelativeTo_initEntries() {
  if (OriginRelativeTo_entriesInitialized)
    return Unit_instance;
  OriginRelativeTo_entriesInitialized = true;
  OriginRelativeTo_BOUND_instance = new OriginRelativeTo('BOUND', 0);
  OriginRelativeTo_SIZE_instance = new OriginRelativeTo('SIZE', 1);
  Companion_getInstance_35();
}
function OriginRelativeTo(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function OriginRelativeTo_BOUND_getInstance() {
  OriginRelativeTo_initEntries();
  return OriginRelativeTo_BOUND_instance;
}
function OriginRelativeTo_SIZE_getInstance() {
  OriginRelativeTo_initEntries();
  return OriginRelativeTo_SIZE_instance;
}
function OriginRelativeToImpostor_0() {
  OriginRelativeToImpostor_instance = this;
  this.BOUND = 0;
  this.SIZE = 1;
  this.n5p_1 = values();
}
protoOf(OriginRelativeToImpostor_0).o5p = function () {
  return this.BOUND;
};
protoOf(OriginRelativeToImpostor_0).p5p = function () {
  return this.SIZE;
};
protoOf(OriginRelativeToImpostor_0).toEnum = function (value) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var indexedObject = this.n5p_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.objects.OriginRelativeToImpostor.toEnum.<anonymous>' call
      if (element.u2_1 === value) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
  }
  return tmp$ret$1;
};
var OriginRelativeToImpostor_instance;
function OriginRelativeToImpostor_getInstance() {
  if (OriginRelativeToImpostor_instance == null)
    new OriginRelativeToImpostor_0();
  return OriginRelativeToImpostor_instance;
}
var PositionType_ABSOLUTE_instance;
var PositionType_PERCENTAGE_RELATIVE_SIZE_instance;
function Companion_29() {
  Companion_instance_39 = this;
  this.q5p_1 = values_0();
}
protoOf(Companion_29).getByValue = function (value) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var indexedObject = this.q5p_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.objects.Companion.getByValue.<anonymous>' call
      if (element.u2_1 === value) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
  }
  return tmp$ret$1;
};
var Companion_instance_39;
function Companion_getInstance_36() {
  PositionType_initEntries();
  if (Companion_instance_39 == null)
    new Companion_29();
  return Companion_instance_39;
}
function values_0() {
  return [PositionType_ABSOLUTE_getInstance(), PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance()];
}
function valueOf_0(value) {
  switch (value) {
    case 'ABSOLUTE':
      return PositionType_ABSOLUTE_getInstance();
    case 'PERCENTAGE_RELATIVE_SIZE':
      return PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance();
    default:
      PositionType_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var PositionType_entriesInitialized;
function PositionType_initEntries() {
  if (PositionType_entriesInitialized)
    return Unit_instance;
  PositionType_entriesInitialized = true;
  PositionType_ABSOLUTE_instance = new PositionType('ABSOLUTE', 0);
  PositionType_PERCENTAGE_RELATIVE_SIZE_instance = new PositionType('PERCENTAGE_RELATIVE_SIZE', 1);
  Companion_getInstance_36();
}
function PositionType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function PositionType_ABSOLUTE_getInstance() {
  PositionType_initEntries();
  return PositionType_ABSOLUTE_instance;
}
function PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance() {
  PositionType_initEntries();
  return PositionType_PERCENTAGE_RELATIVE_SIZE_instance;
}
function Companion_30() {
  Companion_instance_40 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.b5p_1 = [null, createSimpleEnumSerializer('com.ikea.range.dynamic.template.objects.PositionType', values_0())];
}
protoOf(Companion_30).fromString = function (s) {
  var tmp;
  if (s == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.filter' call
    // Inline function 'kotlin.text.filterTo' call
    var destination = StringBuilder_init_$Create$();
    var inductionVariable = 0;
    var last = charSequenceLength(s);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = charSequenceGet(s, index);
        // Inline function 'com.ikea.range.dynamic.template.objects.Companion.fromString.<anonymous>' call
        if (!(element === _Char___init__impl__6a9atx(37))) {
          destination.t8(element);
        }
      }
       while (inductionVariable < last);
    tmp = destination.toString();
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toDouble(tmp1_safe_receiver);
  return new PositionValue(tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs, !(s == null) && contains(s, _Char___init__impl__6a9atx(37)) ? PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance() : PositionType_ABSOLUTE_getInstance());
};
protoOf(Companion_30).z18 = function () {
  return $serializer_getInstance_20();
};
var Companion_instance_40;
function Companion_getInstance_37() {
  if (Companion_instance_40 == null)
    new Companion_30();
  return Companion_instance_40;
}
function $serializer_17() {
  $serializer_instance_17 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.objects.PositionValue', this, 2);
  tmp0_serialDesc.lw('value', false);
  tmp0_serialDesc.lw('type', true);
  this.t5p_1 = tmp0_serialDesc;
}
protoOf($serializer_17).u5p = function (encoder, value) {
  var tmp0_desc = this.t5p_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_37().b5p_1;
  tmp1_output.oq(tmp0_desc, 0, value.value);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !value.typeKotlin.equals(PositionType_ABSOLUTE_getInstance())) {
    tmp1_output.sq(tmp0_desc, 1, tmp2_cached[1], value.typeKotlin);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_17).ul = function (encoder, value) {
  return this.u5p(encoder, value instanceof PositionValue ? value : THROW_CCE());
};
protoOf($serializer_17).vl = function (decoder) {
  var tmp0_desc = this.t5p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  var tmp7_cached = Companion_getInstance_37().b5p_1;
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return PositionValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_17).tl = function () {
  return this.t5p_1;
};
protoOf($serializer_17).ex = function () {
  var tmp0_cached = Companion_getInstance_37().b5p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), tmp0_cached[1]];
};
var $serializer_instance_17;
function $serializer_getInstance_20() {
  if ($serializer_instance_17 == null)
    new $serializer_17();
  return $serializer_instance_17;
}
function PositionValue_init_$Init$(seen0, value, type, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_20().t5p_1);
  }
  $this.value = value;
  if (0 === (seen0 & 2))
    $this.typeKotlin = PositionType_ABSOLUTE_getInstance();
  else
    $this.typeKotlin = type;
  return $this;
}
function PositionValue_init_$Create$(seen0, value, type, serializationConstructorMarker) {
  return PositionValue_init_$Init$(seen0, value, type, serializationConstructorMarker, objectCreate(protoOf(PositionValue)));
}
function PositionValue(value, type) {
  Companion_getInstance_37();
  type = type === VOID ? PositionType_ABSOLUTE_getInstance() : type;
  this.value = value;
  this.typeKotlin = type;
}
protoOf(PositionValue).c2 = function () {
  return this.value;
};
protoOf(PositionValue).v5p = function () {
  return this.typeKotlin;
};
protoOf(PositionValue).w2a = function () {
  return this.typeKotlin.u2_1;
};
protoOf(PositionValue).tf = function () {
  return this.value;
};
protoOf(PositionValue).uf = function () {
  return this.typeKotlin;
};
protoOf(PositionValue).w5p = function (value, type) {
  return new PositionValue(value, type);
};
protoOf(PositionValue).copy = function (value, type, $super) {
  value = value === VOID ? this.value : value;
  type = type === VOID ? this.typeKotlin : type;
  return this.w5p(value, type);
};
protoOf(PositionValue).toString = function () {
  return 'PositionValue(value=' + this.value + ', type=' + this.typeKotlin.toString() + ')';
};
protoOf(PositionValue).hashCode = function () {
  var result = getNumberHashCode(this.value);
  result = imul(result, 31) + this.typeKotlin.hashCode() | 0;
  return result;
};
protoOf(PositionValue).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PositionValue))
    return false;
  var tmp0_other_with_cast = other instanceof PositionValue ? other : THROW_CCE();
  if (!equals(this.value, tmp0_other_with_cast.value))
    return false;
  if (!this.typeKotlin.equals(tmp0_other_with_cast.typeKotlin))
    return false;
  return true;
};
function RelativePosition$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.hm('x', Companion_getInstance_37().z18().tl());
  $this$buildClassSerialDescriptor.hm('y', Companion_getInstance_37().z18().tl());
  $this$buildClassSerialDescriptor.hm('z', Companion_getInstance_37().z18().tl());
  return Unit_instance;
}
function RelativePosition_init_$Init$(position, $this) {
  RelativePosition.call($this, new PositionValue(position.X), new PositionValue(position.Y), new PositionValue(position.Z));
  return $this;
}
function RelativePositionFromPosition(position) {
  return RelativePosition_init_$Init$(position, objectCreate(protoOf(RelativePosition)));
}
function _get_hasAnyPercentage__wplq75($this) {
  return $this.x5o_1.typeKotlin.equals(PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance()) || $this.y5o_1.typeKotlin.equals(PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance()) || $this.z5o_1.typeKotlin.equals(PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance());
}
function Companion_31() {
  Companion_instance_41 = this;
  this.logger = LoggerState_getInstance().g1v('RelativePosition');
  var tmp = this;
  tmp.x5p_1 = buildClassSerialDescriptor('RelativePosition', [], RelativePosition$Companion$descriptor$lambda);
}
protoOf(Companion_31).l1k = function () {
  return this.logger;
};
protoOf(Companion_31).y5p = function (encoder, descriptor, position, startIndex) {
  this.encodePositionValue(encoder, descriptor, position.x5o_1, startIndex);
  this.encodePositionValue(encoder, descriptor, position.y5o_1, startIndex + 1 | 0);
  this.encodePositionValue(encoder, descriptor, position.z5o_1, startIndex + 2 | 0);
};
protoOf(Companion_31).encodeToArray = function (encoder, descriptor, position, startIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  return this.y5p(encoder, descriptor, position, startIndex);
};
protoOf(Companion_31).encodePositionValue = function (encoder, descriptor, position, index) {
  if (position.typeKotlin.equals(PositionType_ABSOLUTE_getInstance())) {
    encoder.oq(descriptor, index, position.value);
  } else {
    encoder.qq(descriptor, index, '' + position.value + '%');
  }
};
protoOf(Companion_31).tl = function () {
  return this.x5p_1;
};
protoOf(Companion_31).z5p = function (encoder, value) {
  var enc = encoder.bp(this.x5p_1);
  if (!(value.x5o_1.value === 0.0)) {
    this.encodePositionValue(enc, this.x5p_1, value.x5o_1, 0);
  }
  if (!(value.y5o_1.value === 0.0)) {
    this.encodePositionValue(enc, this.x5p_1, value.y5o_1, 1);
  }
  if (!(value.z5o_1.value === 0.0)) {
    this.encodePositionValue(enc, this.x5p_1, value.z5o_1, 2);
  }
  enc.cp(this.x5p_1);
};
protoOf(Companion_31).ul = function (encoder, value) {
  return this.z5p(encoder, value instanceof RelativePosition ? value : THROW_CCE());
};
protoOf(Companion_31).vl = function (decoder) {
  var tmp0_desc = this.x5p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp9_input = decoder.bp(tmp0_desc);
  if (!tmp9_input.rp())
    while (tmp1_flag) {
      tmp2_index = tmp9_input.sp(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp9_input.cp(tmp0_desc);
  if (!(0 === (0 & 0))) {
    throwMissingFieldException(0, 0, tmp0_desc);
  }
  return new RelativePosition(null, null, null);
};
protoOf(Companion_31).z18 = function () {
  return Companion_getInstance_38();
};
var Companion_instance_41;
function Companion_getInstance_38() {
  if (Companion_instance_41 == null)
    new Companion_31();
  return Companion_instance_41;
}
function RelativePosition$getAbsolutePosition$lambda() {
  return "Can't use absolute position on a transform defined with relative axes";
}
function RelativePosition(x, y, z) {
  Companion_getInstance_38();
  this.x5o_1 = x;
  this.y5o_1 = y;
  this.z5o_1 = z;
  this.a5p_1 = new Vector(this.x5o_1.value, this.y5o_1.value, this.z5o_1.value);
  this.isOrigin = (this.x5o_1.value === 0.0 && this.y5o_1.value === 0.0 && this.z5o_1.value === 0.0);
}
protoOf(RelativePosition).getAbsolutePosition = function () {
  if (_get_hasAnyPercentage__wplq75(this)) {
    var tmp = Companion_getInstance_38().logger;
    tmp.error(RelativePosition$getAbsolutePosition$lambda);
  }
  return this.a5p_1;
};
protoOf(RelativePosition).a5q = function () {
  return this.isOrigin;
};
protoOf(RelativePosition).getRelativePosition = function (size) {
  var tmp;
  switch (this.x5o_1.typeKotlin.u2_1) {
    case 0:
      tmp = this.a5p_1.X;
      break;
    case 1:
      tmp = size.b2y_1 * 0.01 * this.a5p_1.X;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tmp_0 = tmp;
  var tmp_1;
  switch (this.y5o_1.typeKotlin.u2_1) {
    case 0:
      tmp_1 = this.a5p_1.Y;
      break;
    case 1:
      tmp_1 = size.c2y_1 * 0.01 * this.a5p_1.Y;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tmp_2 = tmp_1;
  var tmp_3;
  switch (this.z5o_1.typeKotlin.u2_1) {
    case 0:
      tmp_3 = this.a5p_1.Z;
      break;
    case 1:
      tmp_3 = size.d2y_1 * 0.01 * this.a5p_1.Z;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return new Vector(tmp_0, tmp_2, tmp_3);
};
protoOf(RelativePosition).b5q = function (x, y, z) {
  return new RelativePosition(x, y, z);
};
protoOf(RelativePosition).copy = function (x, y, z, $super) {
  x = x === VOID ? this.x5o_1 : x;
  y = y === VOID ? this.y5o_1 : y;
  z = z === VOID ? this.z5o_1 : z;
  return this.b5q(x, y, z);
};
protoOf(RelativePosition).toString = function () {
  return 'RelativePosition(x=' + this.x5o_1.toString() + ', y=' + this.y5o_1.toString() + ', z=' + this.z5o_1.toString() + ')';
};
protoOf(RelativePosition).hashCode = function () {
  var result = this.x5o_1.hashCode();
  result = imul(result, 31) + this.y5o_1.hashCode() | 0;
  result = imul(result, 31) + this.z5o_1.hashCode() | 0;
  return result;
};
protoOf(RelativePosition).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RelativePosition))
    return false;
  var tmp0_other_with_cast = other instanceof RelativePosition ? other : THROW_CCE();
  if (!this.x5o_1.equals(tmp0_other_with_cast.x5o_1))
    return false;
  if (!this.y5o_1.equals(tmp0_other_with_cast.y5o_1))
    return false;
  if (!this.z5o_1.equals(tmp0_other_with_cast.z5o_1))
    return false;
  return true;
};
function RelativeTransform_init_$Init$(position, rotation, $this) {
  RelativeTransform.call($this, RelativePositionFromPosition(position), rotation);
  return $this;
}
function RelativeTransformFromVector(position, rotation) {
  return RelativeTransform_init_$Init$(position, rotation, objectCreate(protoOf(RelativeTransform)));
}
function RelativeTransformSerializer() {
  RelativeTransformSerializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.objects.RelativeTransform', null, 2);
  tmp0_serialDesc.lw('position', true);
  tmp0_serialDesc.lw('rotation', true);
  this.v5o_1 = tmp0_serialDesc;
}
protoOf(RelativeTransformSerializer).c5q = function (encoder, descriptor, transform, startIndex) {
  Companion_getInstance_38().encodeToArray(encoder, descriptor, transform.position, startIndex);
  this.encodeRotationToArray(encoder, descriptor, transform.rotation, startIndex + 3 | 0);
};
protoOf(RelativeTransformSerializer).encodeToArray = function (encoder, descriptor, transform, startIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  return this.c5q(encoder, descriptor, transform, startIndex);
};
protoOf(RelativeTransformSerializer).d5q = function (encoder, descriptor, rotation, startIndex) {
  var rotationEuler = rotation.toEulerDegrees();
  encoder.oq(descriptor, startIndex + 3 | 0, round(rotationEuler.X * 1000) / 1000);
  encoder.oq(descriptor, startIndex + 3 | 0, round(rotationEuler.Y * 1000) / 1000);
  encoder.oq(descriptor, startIndex + 3 | 0, round(rotationEuler.Z * 1000) / 1000);
};
protoOf(RelativeTransformSerializer).encodeRotationToArray = function (encoder, descriptor, rotation, startIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  return this.d5q(encoder, descriptor, rotation, startIndex);
};
protoOf(RelativeTransformSerializer).e5q = function (encoder, value) {
  var desc = ListSerializer(Companion_getInstance_37().z18()).tl();
  var comp = encoder.xq(desc, 6);
  this.encodeToArray(comp, desc, value, 0);
  comp.cp(this.v5o_1);
};
protoOf(RelativeTransformSerializer).ul = function (encoder, value) {
  return this.e5q(encoder, value instanceof RelativeTransform ? value : THROW_CCE());
};
protoOf(RelativeTransformSerializer).tl = function () {
  return this.v5o_1;
};
protoOf(RelativeTransformSerializer).vl = function (decoder) {
  var tmp0_desc = this.v5o_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, Companion_getInstance_38(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, Companion_getInstance_38(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  if (!(0 === (0 & tmp3_bitMask0))) {
    throwMissingFieldException(tmp3_bitMask0, 0, tmp0_desc);
  }
  if (0 === (tmp3_bitMask0 & 1))
    tmp4_local0 = RelativePositionFromPosition(Companion_getInstance_5().ZERO);
  if (0 === (tmp3_bitMask0 & 2))
    tmp5_local1 = Companion_getInstance_3().q2b_1;
  return new RelativeTransform(tmp4_local0, tmp5_local1);
};
protoOf(RelativeTransformSerializer).z18 = function () {
  return RelativeTransformSerializer_getInstance();
};
var RelativeTransformSerializer_instance;
function RelativeTransformSerializer_getInstance() {
  if (RelativeTransformSerializer_instance == null)
    new RelativeTransformSerializer();
  return RelativeTransformSerializer_instance;
}
function RelativeTransform(position, rotation) {
  RelativeTransformSerializer_getInstance();
  position = position === VOID ? RelativePositionFromPosition(Companion_getInstance_5().ZERO) : position;
  rotation = rotation === VOID ? Companion_getInstance_3().q2b_1 : rotation;
  this.position = position;
  this.rotation = rotation;
}
protoOf(RelativeTransform).f2w = function () {
  return this.position;
};
protoOf(RelativeTransform).m2g = function () {
  return this.rotation;
};
protoOf(RelativeTransform).getPosition = function (size) {
  return this.position.getRelativePosition(size);
};
protoOf(RelativeTransform).tf = function () {
  return this.position;
};
protoOf(RelativeTransform).uf = function () {
  return this.rotation;
};
protoOf(RelativeTransform).f5q = function (position, rotation) {
  return new RelativeTransform(position, rotation);
};
protoOf(RelativeTransform).copy = function (position, rotation, $super) {
  position = position === VOID ? this.position : position;
  rotation = rotation === VOID ? this.rotation : rotation;
  return this.f5q(position, rotation);
};
protoOf(RelativeTransform).toString = function () {
  return 'RelativeTransform(position=' + this.position.toString() + ', rotation=' + this.rotation.toString() + ')';
};
protoOf(RelativeTransform).hashCode = function () {
  var result = this.position.hashCode();
  result = imul(result, 31) + this.rotation.hashCode() | 0;
  return result;
};
protoOf(RelativeTransform).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RelativeTransform))
    return false;
  var tmp0_other_with_cast = other instanceof RelativeTransform ? other : THROW_CCE();
  if (!this.position.equals(tmp0_other_with_cast.position))
    return false;
  if (!this.rotation.equals(tmp0_other_with_cast.rotation))
    return false;
  return true;
};
function getPositionValue(_this__u8e3s4, $this, key) {
  var tmp = Companion_getInstance_37();
  var tmp0_safe_receiver = _this__u8e3s4.d19(key);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
  return tmp.fromString(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e19());
}
function getDegrees(_this__u8e3s4, $this, key) {
  var tmp0_safe_receiver = _this__u8e3s4.d19(key);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_doubleOrNull(tmp1_safe_receiver);
  return new Degrees(tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
}
function NamedTransformObjectDeserializer() {
}
protoOf(NamedTransformObjectDeserializer).t5o = function (jo) {
  return new RelativeTransform(new RelativePosition(getPositionValue(jo, this, 'x'), getPositionValue(jo, this, 'y'), getPositionValue(jo, this, 'z')), Companion_getInstance_3().s2w(getDegrees(jo, this, 'rx'), getDegrees(jo, this, 'ry'), getDegrees(jo, this, 'rz')));
};
var NamedTransformObjectDeserializer_instance;
function NamedTransformObjectDeserializer_getInstance() {
  return NamedTransformObjectDeserializer_instance;
}
function RelationOriginSerializer() {
  RelationOriginSerializer_instance = this;
  this.g5q_1 = PrimitiveSerialDescriptor('Origin', STRING_getInstance());
}
protoOf(RelationOriginSerializer).tl = function () {
  return this.g5q_1;
};
protoOf(RelationOriginSerializer).x2x = function (encoder, value) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0_subject = value.x;
  var tmp = tmp0_subject === Companion_instance_5.f2x_1 ? 'left' : tmp0_subject === Companion_instance_5.h2x_1 ? 'right' : 'center';
  var tmp1_subject = value.y;
  var tmp_0 = tmp1_subject === Companion_instance_6.k2x_1 ? 'top' : tmp1_subject === Companion_instance_6.i2x_1 ? 'bottom' : 'center';
  var tmp2_subject = value.z;
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = listOf([tmp, tmp_0, tmp2_subject === Companion_instance_7.l2x_1 ? 'back' : tmp2_subject === Companion_instance_7.n2x_1 ? 'front' : 'center']);
  var destination = ArrayList_init_$Create$_0();
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.template.serializers.RelationOriginSerializer.serialize.<anonymous>' call
    if (!(element === 'center')) {
      destination.h(element);
    }
  }
  encoder.fq(joinToString(destination, '-'));
};
protoOf(RelationOriginSerializer).ul = function (encoder, value) {
  return this.x2x(encoder, value instanceof RelationOrigin ? value : THROW_CCE());
};
protoOf(RelationOriginSerializer).vl = function (decoder) {
  var text = decoder.wo();
  return new RelationOrigin(contains_0(text, 'left') ? Companion_instance_5.f2x_1 : contains_0(text, 'right') ? Companion_instance_5.h2x_1 : Companion_instance_5.g2x_1, contains_0(text, 'top') ? Companion_instance_6.k2x_1 : contains_0(text, 'bottom') ? Companion_instance_6.i2x_1 : Companion_instance_6.j2x_1, contains_0(text, 'front') ? Companion_instance_7.n2x_1 : contains_0(text, 'back') ? Companion_instance_7.l2x_1 : Companion_instance_7.m2x_1);
};
var RelationOriginSerializer_instance;
function RelationOriginSerializer_getInstance() {
  if (RelationOriginSerializer_instance == null)
    new RelationOriginSerializer();
  return RelationOriginSerializer_instance;
}
function RelativeTransformDeserializer() {
}
protoOf(RelativeTransformDeserializer).u5o = function (elements) {
  var relativePosition = new RelativePosition(Companion_getInstance_37().fromString(elements.q(0)), Companion_getInstance_37().fromString(elements.q(1)), Companion_getInstance_37().fromString(elements.q(2)));
  var rotation = Companion_getInstance_3().s2w(new Degrees(toDouble(elements.q(3))), new Degrees(toDouble(elements.q(4))), new Degrees(toDouble(elements.q(5))));
  return new RelativeTransform(relativePosition, rotation);
};
var RelativeTransformDeserializer_instance;
function RelativeTransformDeserializer_getInstance() {
  return RelativeTransformDeserializer_instance;
}
function get_logger_0() {
  _init_properties_Serializers_kt__wkoiy7();
  return logger_0;
}
var logger_0;
function parseAndCatch(errorMsg, parseCallback) {
  _init_properties_Serializers_kt__wkoiy7();
  try {
    return parseCallback();
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      var tmp = get_logger_0();
      tmp.error(parseAndCatch$lambda(errorMsg));
      throw new DynamicRangeParseError(errorMsg, e);
    } else {
      throw $p;
    }
  }
}
function DynamicRangeParseError(msg, cause) {
  Exception_init_$Init$(msg, cause, this);
  captureStack(this, DynamicRangeParseError);
}
function parseAndCatch$lambda($errorMsg) {
  return function () {
    return $errorMsg;
  };
}
var properties_initialized_Serializers_kt_i0ph73;
function _init_properties_Serializers_kt__wkoiy7() {
  if (!properties_initialized_Serializers_kt_i0ph73) {
    properties_initialized_Serializers_kt_i0ph73 = true;
    logger_0 = LoggerState_getInstance().g1v('DynamicRangeSerializers');
  }
}
function CatalogGenerator() {
  this.h5q_1 = 0;
}
protoOf(CatalogGenerator).resetItemId = function () {
  this.h5q_1 = 0;
};
protoOf(CatalogGenerator).nextItemId = function () {
  var _unary__edvuaz = this.h5q_1;
  this.h5q_1 = _unary__edvuaz + 1 | 0;
  return _unary__edvuaz;
};
protoOf(CatalogGenerator).i5q = function (id, templateId, size) {
  var tmp;
  if (!(size == null)) {
    tmp = trimIndent('\n        "size": {\n            "width": ' + size.b2y_1 + ',\n            "depth": ' + size.d2y_1 + ',\n            "height": ' + size.c2y_1 + '\n         },\n         "comSize": {\n            "width": ' + size.b2y_1 + ',\n            "depth": ' + size.d2y_1 + ',\n            "height": ' + size.c2y_1 + '\n         }\n            ');
  } else {
    tmp = '"size": {\n    "width": 500,\n    "depth": 300,\n    "height": 2100\n },\n "comSize": {\n    "width": 500,\n    "depth": 300,\n    "height": 2100\n }';
  }
  var sizeStr = tmp;
  return trimIndent('\n        {\n            "id": "' + id + '",\n            "template": {\n                "id": "' + templateId + '",\n                 ' + sizeStr + '\n            }\n        }\n        ');
};
protoOf(CatalogGenerator).generateProduct = function (id, templateId, size, $super) {
  id = id === VOID ? 'product-' + this.nextItemId() : id;
  size = size === VOID ? null : size;
  return this.i5q(id, templateId, size);
};
protoOf(CatalogGenerator).j5q = function (componentsStr, id, inherits) {
  var tmp;
  if (!(inherits == null)) {
    var list = joinToString_0(inherits, '", "', '"', '"');
    tmp = trimIndent('\n            "inherits": [\n                ' + list + '\n            ],\n            ');
  } else {
    tmp = '';
  }
  var inheritsStr = tmp;
  return trimIndent('\n        {\n            "templateId": "' + id + '",\n            "name": "My Test Product",\n            ' + inheritsStr + '\n            "components": {\n                ' + componentsStr + '\n            }\n        }\n        ');
};
protoOf(CatalogGenerator).generateTemplate = function (componentsStr, id, inherits, $super) {
  id = id === VOID ? 'template-' + this.nextItemId() : id;
  inherits = inherits === VOID ? null : inherits;
  return this.j5q(componentsStr, id, inherits);
};
protoOf(CatalogGenerator).k5q = function (components, id, inherits) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(components.length === 0)) {
    // Inline function 'kotlin.collections.reduce' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (components.length === 0)
      throw UnsupportedOperationException_init_$Create$("Empty array can't be reduced.");
    var accumulator = components[0];
    var inductionVariable = 1;
    var last = get_lastIndex(components);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.testutils.CatalogGenerator.generateTemplateFromList.<anonymous>' call
        var acc = accumulator;
        var curr = components[index];
        accumulator = trimIndent('\n            ' + acc + ',\n            ' + curr + '\n                ');
      }
       while (!(index === last));
    tmp = accumulator;
  } else {
    tmp = '';
  }
  var componentsStr = tmp;
  return this.generateTemplate(componentsStr, id, inherits);
};
protoOf(CatalogGenerator).generateTemplateFromList = function (components, id, inherits, $super) {
  var tmp;
  if (components === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = components;
  }
  components = tmp;
  id = id === VOID ? 'template-' + this.nextItemId() : id;
  inherits = inherits === VOID ? null : inherits;
  return this.k5q(components, id, inherits);
};
protoOf(CatalogGenerator).generateTemplateFile = function (templates) {
  var templatsStr = joinToString_0(templates, ',\n');
  return trimIndent('\n        {\n            "range": "test-range",\n            "schemaVersion": "draft-01",\n            "rangeVersion": "1.0",\n            "templates": [\n                ' + templatsStr + '\n            ]\n        }\n        ');
};
protoOf(CatalogGenerator).generateCatalog = function (products) {
  var productsStr = joinToString_0(products, ',\n');
  return trimIndent('\n        {\n            "range": "test-range",\n            "schemaVersion": "draft-01",\n            "rangeVersion": "1.0",\n            "products": [\n                ' + productsStr + '\n            ]\n        }\n        ');
};
function parseMeta(data) {
  var result = new parseMeta$result$1();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = data.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.dynamic.components.parseMeta.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key = element.b2();
    // Inline function 'kotlin.collections.component2' call
    var value = element.c2();
    var json = toString(value);
    if (!(json === '')) {
      result[key] = JSON.parse(json);
    }
  }
  return result;
}
function parseMeta$result$1() {
}
//region block: post-declaration
protoOf($serializer).fx = typeParametersSerializers;
protoOf(DynamicProductCatalog).productSpecification = productSpecification;
protoOf(DynamicProductCatalog).createCustomAssembly = createCustomAssembly;
protoOf(DynamicProductCatalog).createCustomAssemblySpecification = createCustomAssemblySpecification;
defineProp(protoOf(DynamicProductCatalog), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
  return this.s1t();
});
protoOf($serializer_0).fx = typeParametersSerializers;
protoOf($serializer_1).fx = typeParametersSerializers;
protoOf($serializer_2).fx = typeParametersSerializers;
protoOf(MetaDataComponent).r1s = get_serializable;
protoOf(MetaDataComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(MetaDataComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(MetaDataComponent), 'id', protoOf(MetaDataComponent).n1s);
defineProp(protoOf(MetaDataComponent), 'metaData', protoOf(MetaDataComponent).i5g);
defineProp(protoOf(MetaDataComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(MetaDataComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(VisualLightSourceComponent).r1s = get_serializable;
protoOf(VisualLightSourceComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(VisualLightSourceComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(VisualLightSourceComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(VisualLightSourceComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_3).fx = typeParametersSerializers;
protoOf($serializer_4).fx = typeParametersSerializers;
protoOf($serializer_5).fx = typeParametersSerializers;
protoOf($serializer_6).fx = typeParametersSerializers;
defineProp(protoOf(TemplateEditorConnectorData), 'connectorKey', function () {
  return this.w2g();
});
defineProp(protoOf(TemplateEditorConnectorData), 'style', function () {
  return this.g53();
});
defineProp(protoOf(TemplateEditorConnectorData), 'selected', function () {
  return this.h53();
});
defineProp(protoOf(TemplateEditorConnectorData), 'visible', function () {
  return this.i53();
});
defineProp(protoOf(TemplateEditorConnectorData), 'active', function () {
  return this.j53();
});
defineProp(protoOf(TemplateEditorConnectorData), 'showActivationDistance', function () {
  return this.k53();
}, function (value) {
  this.s5h(value);
});
defineProp(protoOf(TemplateEditorConnectorData), 'showTransform', function () {
  return this.l53();
}, function (value) {
  this.t5h(value);
});
protoOf($serializer_7).fx = typeParametersSerializers;
protoOf($serializer_8).fx = typeParametersSerializers;
protoOf($serializer_9).fx = typeParametersSerializers;
protoOf($serializer_10).fx = typeParametersSerializers;
protoOf($serializer_11).fx = typeParametersSerializers;
protoOf($serializer_12).fx = typeParametersSerializers;
defineProp(protoOf(OriginTemplate), 'relativeTo', protoOf(OriginTemplate).d2x);
protoOf($serializer_13).fx = typeParametersSerializers;
defineProp(protoOf(PositionTemplate), 'relativeTransform', protoOf(PositionTemplate).g1m);
defineProp(protoOf(PositionTemplate), 'absoluteTransform', protoOf(PositionTemplate).c5p);
protoOf($serializer_14).fx = typeParametersSerializers;
protoOf($serializer_15).fx = typeParametersSerializers;
protoOf($serializer_16).fx = typeParametersSerializers;
defineProp(protoOf(OriginRelativeTo), 'name', protoOf(OriginRelativeTo).v2);
defineProp(protoOf(OriginRelativeTo), 'ordinal', protoOf(OriginRelativeTo).w2);
defineProp(protoOf(PositionType), 'name', protoOf(PositionType).v2);
defineProp(protoOf(PositionType), 'ordinal', protoOf(PositionType).w2);
protoOf($serializer_17).fx = typeParametersSerializers;
defineProp(protoOf(PositionValue), 'type', protoOf(PositionValue).w2a);
//endregion
//region block: init
Companion_instance_18 = new Companion_8();
Companion_instance_19 = new Companion_9();
Companion_instance_21 = new Companion_11();
Companion_instance_22 = new Companion_12();
Companion_instance_32 = new Companion_22();
Companion_instance_33 = new Companion_23();
Companion_instance_34 = new Companion_24();
Companion_instance_35 = new Companion_25();
Companion_instance_36 = new Companion_26();
Companion_instance_37 = new Companion_27();
NamedTransformObjectDeserializer_instance = new NamedTransformObjectDeserializer();
RelativeTransformDeserializer_instance = new RelativeTransformDeserializer();
//endregion
//region block: exports
defineProp(AutoAdaptGroup, 'CustomSerializer', CustomSerializer_getInstance);
defineProp(DynamicProduct, 'Companion', Companion_getInstance_7);
defineProp(DynamicProductCatalog, 'Companion', Companion_getInstance_8);
defineProp(ProductTemplate, 'Companion', Companion_getInstance_11);
defineProp(MetaDataComponent, 'ID', get_ID);
defineProp(MetaDataComponent, 'Companion', Companion_getInstance_12);
defineProp(VisualLightSourceComponent, 'Companion', Companion_getInstance_13);
defineProp(CatalogTemplateData, 'Companion', Companion_getInstance_14);
defineProp(ModelRenderInfo, 'Companion', Companion_getInstance_15);
defineProp(Part, 'Companion', Companion_getInstance_16);
defineProp(ProductDataComponent, 'Companion', Companion_getInstance_17);
defineProp(AssemblyChild, 'Companion', Companion_getInstance_20);
defineProp(AssemblyTemplate, 'Companion', Companion_getInstance_21);
defineProp(AutoAdaptHostTemplate, 'CustomSerializer', CustomSerializer_getInstance_0);
defineProp(BoundItemTemplate, 'Companion', Companion_getInstance_22);
defineProp(Compartment, 'Companion', Companion_getInstance_23);
defineProp(ComponentsTemplate, 'Companion', Companion_getInstance_24);
defineProp(ConnectorItemTemplate, 'Companion', Companion_getInstance_25);
defineProp(DynamicRangeDimension, 'Companion', Companion_getInstance_26);
defineProp(DragSurfaceTemplate, 'Companion', Companion_getInstance_27);
defineProp(DragSurfacesTemplate, 'CustomSerializer', CustomSerializer_getInstance_1);
DynamicRangeUtils.createConnector = createConnector_0;
DynamicRangeUtils.arrayToMargin = arrayToMargin;
DynamicRangeUtils.assemblyToJson = assemblyToJson;
DynamicRangeUtils.boundsToJson = boundsToJson;
DynamicRangeUtils.connectorsToJson = connectorsToJson;
DynamicRangeUtils.jsonToAssembly = jsonToAssembly;
DynamicRangeUtils.jsonToBounds = jsonToBounds;
DynamicRangeUtils.jsonToConnectors = jsonToConnectors;
DynamicRangeUtils.productTemplateToJson = productTemplateToJson;
DynamicRangeUtils.getMeta = getMeta;
defineProp(DynamicRangeUtils, 'Companion', Companion_getInstance_28);
defineProp(LightTemplate, 'Companion', Companion_getInstance_29);
defineProp(MarginTemplate, 'MarginTemplateSerializer', MarginTemplateSerializer_getInstance);
defineProp(Model3DTemplate, 'Companion', Companion_getInstance_30);
defineProp(OriginTemplate, 'CustomSerializer', CustomSerializer_getInstance_2);
defineProp(PlacementZoneByHeightTemplate, 'Companion', Companion_getInstance_31);
PositionTemplate.PositionTemplateFromString = PositionTemplateFromString;
defineProp(PositionTemplate, 'PositionTemplateSerializer', PositionTemplateSerializer_getInstance);
defineProp(VisualLightSourceTemplate, 'Companion', Companion_getInstance_32);
defineProp(ProductStructureConnectionTemplate, 'Companion', Companion_getInstance_33);
defineProp(ProductStructureItemTemplate, 'Companion', Companion_getInstance_34);
OriginRelativeTo.values = values;
OriginRelativeTo.valueOf = valueOf;
defineProp(OriginRelativeTo, 'BOUND', OriginRelativeTo_BOUND_getInstance);
defineProp(OriginRelativeTo, 'SIZE', OriginRelativeTo_SIZE_getInstance);
defineProp(OriginRelativeTo, 'Companion', Companion_getInstance_35);
var OriginRelativeToImpostor = {getInstance: OriginRelativeToImpostor_getInstance};
PositionType.values = values_0;
PositionType.valueOf = valueOf_0;
defineProp(PositionType, 'ABSOLUTE', PositionType_ABSOLUTE_getInstance);
defineProp(PositionType, 'PERCENTAGE_RELATIVE_SIZE', PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance);
defineProp(PositionType, 'Companion', Companion_getInstance_36);
defineProp(PositionValue, 'Companion', Companion_getInstance_37);
RelativePosition.RelativePositionFromPosition = RelativePositionFromPosition;
defineProp(RelativePosition, 'Companion', Companion_getInstance_38);
RelativeTransform.RelativeTransformFromVector = RelativeTransformFromVector;
defineProp(RelativeTransform, 'RelativeTransformSerializer', RelativeTransformSerializer_getInstance);
export {
  AutoAdaptGroup as AutoAdaptGroup,
  DynamicProduct as DynamicProduct,
  DynamicProductCatalog as DynamicProductCatalog,
  ProductTemplate as ProductTemplate,
  MetaDataComponent as MetaDataComponent,
  VisualLightSourceComponent as VisualLightSourceComponent,
  CatalogTemplateData as CatalogTemplateData,
  ModelRenderInfo as ModelRenderInfo,
  Part as Part,
  ProductDataComponent as ProductDataComponent,
  TemplateEditorConnectorData as TemplateEditorConnectorData,
  AssemblyChild as AssemblyChild,
  AssemblyTemplate as AssemblyTemplate,
  AutoAdaptHostTemplate as AutoAdaptHostTemplate,
  BoundItemTemplate as BoundItemTemplate,
  Compartment as Compartment,
  ComponentsTemplate as ComponentsTemplate,
  ConnectorItemTemplate as ConnectorItemTemplate,
  getConnectorsForSize as getConnectorsForSize,
  DynamicRangeDimension as DynamicRangeDimension,
  DragSurfaceTemplate as DragSurfaceTemplate,
  DragSurfacesTemplate as DragSurfacesTemplate,
  DynamicRangeUtils as DynamicRangeUtils,
  LightTemplate as LightTemplate,
  MarginTemplate as MarginTemplate,
  Model3DTemplate as Model3DTemplate,
  OriginTemplate as OriginTemplate,
  PlacementZoneByHeightTemplate as PlacementZoneByHeightTemplate,
  PositionTemplate as PositionTemplate,
  VisualLightSourceTemplate as VisualLightSourceTemplate,
  ProductStructureConnectionTemplate as ProductStructureConnectionTemplate,
  ProductStructureItemTemplate as ProductStructureItemTemplate,
  OriginRelativeTo as OriginRelativeTo,
  OriginRelativeToImpostor as OriginRelativeToImpostor,
  PositionType as PositionType,
  PositionValue as PositionValue,
  RelativePosition as RelativePosition,
  RelativeTransform as RelativeTransform,
  CatalogGenerator as CatalogGenerator,
};
export {
  MetaDataComponent as MetaDataComponent2cq0ehrtq7cdx,
  VisualLightSourceComponent as VisualLightSourceComponenttdrhcxqvgh5x,
  Part as Part2q3l7avl1ln6e,
  ProductStructureItemTemplate as ProductStructureItemTemplatexsgwmn957tuc,
  ConnectorItemTemplate as ConnectorItemTemplate158e0vjd7zvbi,
  DynamicRangeDimension as DynamicRangeDimensionoovn6z4huzg7,
  CustomSerializer_getInstance as CustomSerializer_getInstance2hqkmf0q3ubar,
  $serializer_getInstance_8 as $serializer_getInstancehu68pl1ql7el,
  $serializer_getInstance_19 as $serializer_getInstance1xx8verojzg8g,
  CustomSerializer_getInstance_0 as CustomSerializer_getInstance1qvw3q6uslqof,
  Companion_getInstance_23 as Companion_getInstance6xapf1uwypti,
  Companion_getInstance_25 as Companion_getInstanceyff9kgd07fth,
  Companion_getInstance_26 as Companion_getInstance3vd3cz8a8h4cg,
  CustomSerializer_getInstance_1 as CustomSerializer_getInstancepfr9byx5mclv,
  MarginTemplateSerializer_getInstance as MarginTemplateSerializer_getInstance3w2f3vs68h6ag,
  $serializer_getInstance_16 as $serializer_getInstanceld03a1a152sw,
  PositionTemplateSerializer_getInstance as PositionTemplateSerializer_getInstance48bp9f1t4oxb,
  $serializer_getInstance_17 as $serializer_getInstancefcepiwcts4gk,
};
//endregion

//# sourceMappingURL=core-core-range-dynamic-range.mjs.map
